<ng-container *ngIf="storyData && ((elementCountFlag) ? elementDataLoaded : true);else loading">
  <div (click)="customFunc($event)" [class]="!togglePreview ? 'pageContainer tabcontent storyMain' : 'pageContainer tabcontent storyMain'" id="allStories" style="display:block;">
    <div class="storySectionScroll" #storySec (scroll)="checkAllElementsVisibility()">
      <div class="tabcontainer marb20" #tabcont>
        <div class="storyBtns fr wid100 right">
          <div class="storybtnContent" [style.display]="topToggleOpen ? 'block' : 'none'">
            <button class="resCurVer" *ngIf="enableRestoreVersion" (click)="restoreCurrentVersion()" [disabled]="storyData.metadata?.killed">Restore current version</button>
            <ng-container *ngIf="storyEditMode">
              <ng-container *ngIf="storyData && storyData.metadata && !storyData.metadata.deleteMode">
                <ng-container *ngIf="storyFlowIndex === 3">
                  <span class="created">{{ 'SCHEDULED TO BE PUBLISHED AT ' + getNewTypeDate(storyData.scheduledDate) }}</span>
                </ng-container>
                <ng-container *ngIf="storyFlowIndex === 4">
                  <span class="created">{{ 'EMBARGOED BY ' + storyData.embargoBy + ' UNTIL \n' +
                    getNewTypeDate(storyData.embargoDate)
                    }}
                  </span>
                </ng-container>
                <ng-container *ngIf="storyFlowIndex === 5 && storyType !== 'liveblog'">
                  <span class="created">{{storyData.lastPublishedDate ? ('PUBLISHED AT ' +
                    getNewTypeDate(storyData.lastPublishedDate))
                    : 'Date not present' }}</span>
                </ng-container>
                <ng-container *ngIf="storyFlowIndex !== 3 && storyFlowIndex !== 4 && storyFlowIndex !== 5 && (storyType !== 'liveblog')">
                  <span class="created" id="button{{storyFlowArray[4][storyFlowIndex].trim()}}">{{storyFlowArray[4][storyFlowIndex] ? storyFlowArray[4][storyFlowIndex].trim()
                    :
                    ''}}</span>
                </ng-container>
                <!--  -->
                <ng-container *ngIf="storyType !== 'deadlink'">
                  <ng-container *ngFor="let buttonData of storyFlowActionArray; let i = index">
                    <ng-container *ngIf="flowCTAButtons.indexOf('' + (i + 1)) > -1">
                      <ng-container *ngIf="buttonData.functionType === 'calendar'">
                        <button type="button" name="createCard" [id]="buttonData.id" [disabled]="disableElement('story-save')" [class]="disableElement('story-save') ? '' : storyFlowArray[2][storyFlowIndex]"
                          daterangepicker [options]="singleCalendarConfig" (selected)="selectedDate($event, buttonData.modelIdForTime, daterange)"
                          (cancelDaterangepicker)="calendarEventsHandler($event, buttonData.modelIdForTime, buttonData.methodName)"
                          (applyDaterangepicker)="calendarEventsHandler($event, buttonData.modelIdForTime, buttonData.methodName)">
                          {{buttonData ? buttonData.displayName : '-'}}
                        </button>
                      </ng-container>
                      <ng-container *ngIf="buttonData.functionType === 'button'">
                        <button type="button" name="createCard" [id]="buttonData.id" [disabled]="disableElement('story-save')" (click)="checkForPendingRequests(buttonData.methodName, 0, null)"
                          [class]="disableElement('story-save') ? '' : storyFlowArray[2][storyFlowIndex]">
                          {{buttonData ? buttonData.displayName : '-'}}
                        </button>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="storyData && (storyType === 'liveblog') && (storyData.metadata.status === 'PUBLISHED')">
                  <ng-container *ngIf="(!storyData.expiryDate || (storyData.expiryDate === null))">
                    <span class="created">THE BLOG IS LIVE</span>
                    <button type="button" name="createCard" [disabled]="disableElement('story-save')" [class]="disableElement('story-save') ? '' : 'red'"
                      id="expireAt" daterangepicker [options]="singleCalendarConfig" (selected)="selectedDate($event, 'expireAt', daterange)"
                      (cancelDaterangepicker)="calendarEventsHandler($event, 'expireAt', 'setExpiryTime')"
                      (applyDaterangepicker)="calendarEventsHandler($event, 'expireAt', 'setExpiryTime')">
                      End Live Blog
                    </button>
                  </ng-container>

                  <ng-container *ngIf="storyData.expiryDate && storyData.expiryDate !== null && (storyData.expireAt > getTimeRightNow()) ">
                    <span class="created">The BLOG will end at {{getNewTypeDate(storyData.expiryDate)}}</span>
                    <button type="button" name="createCard" [disabled]="disableElement('story-save')" [class]="disableElement('story-save') ? '' : 'red'"
                      id="expireAt" daterangepicker [options]="singleCalendarConfig" (selected)="selectedDate($event, 'expireAt', daterange)"
                      (cancelDaterangepicker)="calendarEventsHandler($event, 'expireAt', 'setExpiryTime')"
                      (applyDaterangepicker)="calendarEventsHandler($event, 'expireAt', 'setExpiryTime')">
                      Change end Time
                    </button>
                  </ng-container>


                  <ng-container *ngIf="storyData.expiryDate && storyData.expiryDate !== null && (getTimeRightNow() > storyData.expireAt) ">
                    <span class="created">The BLOG ended at {{getNewTypeDate(storyData.expiryDate)}}</span>
                  </ng-container>

                </ng-container>
                <div class="secondaryCta fr" #secondaryCTAs>
                  <span class="threedots" id="ellipsis" (click)="revertListFlag = !revertListFlag">
                    <span></span>
                    <span></span>
                    <span></span>
                  </span>
                  <div class="revertStoryBlock" *ngIf="revertListFlag">
                    <ul>
                      <ng-container *ngFor="let buttonData of storyFlowActionArray; let i = index">
                        <ng-container *ngIf="flowSecCTAButtons.indexOf('' + (i + 1)) > -1">
                          <ng-container *ngIf="buttonData.functionType === 'calendar'">
                            <li>
                              <button (click)="openCalendar(buttonData.modelIdForTime)">
                                {{buttonData ? buttonData.displayName : '-'}}
                              </button>
                            </li>
                            <!-- <ng-container *ngIf="flagdata.hasOwnProperty(buttonData.modelIdForTime) && flagdata[buttonData.modelIdForTime]"> -->
                            <input type="text" name="daterangeInput" [id]="buttonData.modelIdForTime" daterangepicker
                              [options]="singleCalendarConfig" (selected)="selectedDate($event, buttonData.modelIdForTime, daterange)"
                              (cancelDaterangepicker)="calendarEventsHandler($event, buttonData.modelIdForTime, buttonData.methodName)"
                              (applyDaterangepicker)="calendarEventsHandler($event, buttonData.modelIdForTime, buttonData.methodName)" />
                            <!-- </ng-container> -->
                          </ng-container>
                          <ng-container *ngIf="buttonData.functionType === 'button'">
                            <li>
                              <span *ngIf="buttonData.methodName === 'softPublish'" class="tooltip">Click here to update all the changes made without changing update date on the website</span>
                              <button [id]="buttonData.id" (click)="checkForPendingRequests(buttonData.methodName, 0, null)" >{{buttonData ?
                                buttonData.displayName : '-'}}
                              </button>
                            </li>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </ul>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="storyData && storyData.metadata && storyData.metadata.deleteMode">
                <span class="created">KILLED</span>

                <div class="secondaryCta fr" #secondaryCTAs>
                  <span class="threedots" (click)="revertListFlag = !revertListFlag">
                    <span></span>
                    <span></span>
                    <span></span>
                  </span>
                  <div class="revertStoryBlock" *ngIf="revertListFlag">
                    <ul>
                      <li>
                        <button id="unkillStory" (click)="unkillStoryURL()">UnKill Story</button>
                      </li>
                    </ul>
                  </div>
                </div>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="!storyEditMode">
                <ng-container *ngIf="versionLock">
                  <button type="button" name="createCard" id="overrideStory" (click)="overrideStoryVersion()" class="blue">
                    Override Story
                  </button>

                  <button type="button" name="createCard" id="goBack" (click)="cancelOverrideVersion()" class="blue">
                    Go Back
                  </button>
                </ng-container>
                <ng-container *ngIf="!versionLock && !isLocked">
                  <button type="button" name="createCard" id="unlockStory" (click)="pickForEditingCurrentStory()" class="blue">
                    Unlock Story
                  </button>
                </ng-container>
              <!-- </ng-container> -->
              <ng-container *ngIf="storyData && storyData.metadata && storyData.metadata.status && !storyData.metadata.deleteMode && !versionLock && isLocked">
                <ng-container *ngIf="storyData.metadata.status === 'SCHEDULED'">
                  <span class="created">{{ 'SCHEDULED TO BE PUBLISHED AT ' + getNewTypeDate(storyData.scheduledDate) }}</span>
                  <ng-container *ngFor="let buttonData of storyFlowActionArray; let i = index">
                    <ng-container *ngIf="flowCTAButtons.indexOf('' + (i + 1)) > -1">
                      <ng-container *ngIf="buttonData.functionType === 'calendar'">
                        <button type="button" name="createCard" [disabled]="disableElement('story-save')" [class]="disableElement('story-save') ? '' : storyFlowArray[2][storyFlowIndex]"
                          daterangepicker [options]="singleCalendarConfig" (selected)="selectedDate($event, buttonData.modelIdForTime, daterange)"
                          (cancelDaterangepicker)="calendarEventsHandler($event, buttonData.modelIdForTime, buttonData.methodName)"
                          (applyDaterangepicker)="calendarEventsHandler($event, buttonData.modelIdForTime, buttonData.methodName)">
                          {{buttonData ? buttonData.displayName : '-'}}
                        </button>
                      </ng-container>
                      <ng-container *ngIf="buttonData.functionType === 'button'">
                        <button type="button" name="createCard" [disabled]="disableElement('story-save')" (click)="checkForPendingRequests(buttonData.methodName, 0, null)"
                          [class]="disableElement('story-save') ? '' : storyFlowArray[2][storyFlowIndex]">
                          {{buttonData ? buttonData.displayName : '-'}}
                        </button>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                  <div class="secondaryCta fr" #secondaryCTAs>
                    <span class="threedots" (click)="revertListFlag = !revertListFlag">
                      <span></span>
                      <span></span>
                      <span></span>
                    </span>
                    <div class="revertStoryBlock" *ngIf="revertListFlag">
                      <ul>
                        <ng-container *ngFor="let buttonData of storyFlowActionArray; let i = index">
                          <ng-container *ngIf="flowSecCTAButtons.indexOf('' + (i + 1)) > -1">
                            <ng-container *ngIf="buttonData.functionType === 'calendar'">
                              <li>
                                <button (click)="openCalendar(buttonData.modelIdForTime)">
                                  {{buttonData ? buttonData.displayName : '-'}}
                                </button>
                              </li>
                              <!-- <ng-container *ngIf="flagdata.hasOwnProperty(buttonData.modelIdForTime) && flagdata[buttonData.modelIdForTime]"> -->
                              <input type="text" name="daterangeInput" [id]="buttonData.modelIdForTime" daterangepicker
                                [options]="singleCalendarConfig" (selected)="selectedDate($event, buttonData.modelIdForTime, daterange)"
                                (cancelDaterangepicker)="calendarEventsHandler($event, buttonData.modelIdForTime, buttonData.methodName)"
                                (applyDaterangepicker)="calendarEventsHandler($event, buttonData.modelIdForTime, buttonData.methodName)" />
                              <!-- </ng-container> -->
                            </ng-container>
                            <ng-container *ngIf="buttonData.functionType === 'button'">
                              <li>
                                <button (click)="checkForPendingRequests(buttonData.methodName, 0, null)">{{buttonData
                                  ?
                                  buttonData.displayName : '-'}}</button>
                              </li>
                            </ng-container>
                          </ng-container>
                        </ng-container>
                      </ul>
                    </div>
                  </div>

                </ng-container>
              </ng-container>
            </ng-container>
          </div>
          <span [class]="topToggleOpen ? 'btnOpen spImg_story' : 'btnOpen spImg_story hideClass'" (click)="topToggleOpen = !topToggleOpen;"></span>
        </div>
        <ng-container [ngSwitch]="storyType">
        <ng-container *ngSwitchCase="'story'">
          <div [class]="showPlagText ? 'formStory enablePlag fl100' : 'formStory fl100'" class="formStory fl100" [ngStyle]="setStoryHeight()" #formStory>
            <ul class="storyuL">
              <li #headlineEl [class]="setCheckForErrorIndication(1) ? ((storyData.mobileHeadline && (htmlToPlaintext(storyData.mobileHeadline).length > 80)) ? ('headline errorborder errorInput fl100') : ('headline errorInput fl100')) : ((storyData.mobileHeadline && (htmlToPlaintext(storyData.mobileHeadline).length > 80)) ? ('headline errorborder fl100') : ('headline fl100')) "
                (focus)="setFocus('headline')">
                <label id="storyButton" [style.visibility]="(setCheckForErrorIndication(1) || (headlineFocusFlag)) ? 'visible' : 'hidden'">
                  Landing page headline
                  <i class="mandate">*</i>
                  <span>{{htmlToPlaintext(storyData.mobileHeadline)? htmlToPlaintext(storyData.mobileHeadline).length:
                    '0'}}/{{headlineMaxLength}}
                    char</span>
                </label>
                <div id="enterHeadlineText" class="dataField bdrfill">
                  <ng-container *ngIf="isCKEditorEnabled">
                    <div id="storyElement" (keypress)="hotkeypress($event)" (keyup)="headlineKeyUpEvent($event)" (keydown)="headlineKeyDownEventCk($event)">
                      <ckeditor [editor]="ckEditor"  id="{{id}}"
                      [data]="headline"
                      [config]="ckplainconfig"
                      [tabindex]="0"
                      (ready)="ckchanges($event, 'ready', 'headline')"
                      (change)="onChange($event,'headline')"
                      (blur)="ckchanges($event, 'blur', 'headline')"
                      (focus)="ckchanges($event, 'focus', 'headline')"
                      (error)="ckchanges($event, 'error', 'headline')"
                      ></ckeditor>
                    </div>
                  </ng-container>
                  
                  <span class="fieldValidation"
                  *ngIf="headlineRestrictionChecks.includes('mobileHeadline')
                  && sharedService.checkIfRestrictedCharactersArePresent(storyData.mobileHeadline, 'headline')">
                  Please remove ((") {{'{}'}} [])</span>
                </div>
                <div class="storyaction" *ngIf=(storyEditMode)>
                  <span id="headline1" class="plusHeadline" (click)="discareUrlChanges(true)">
                    <i class="icon-add-headline" id="buttonAddCoustomHeadline"></i>
                  </span>
                  <span class="deleteHeadline" id="headline2" (click)="clearHeadline();">
                    <i class="icon-delete"></i>
                  </span>
                </div>
              </li>

              <li #summaryEl [class]="(setCheckForErrorIndication(5) || setCheckForErrorIndication(6)) ?
               ((storyData.summary && (htmlToPlaintext(storyData.summary).length > (summaryMaxLength ? summaryMaxLength : 300))) ?
                ('summary errorborder errorInput') : ('summary errorInput')) :
                 ((storyData.summary && (htmlToPlaintext(storyData.summary).length > (summaryMaxLength ? summaryMaxLength : 300))) ? ('summary errorborder') : ('summary'))">
                <label [style.visibility]="(setCheckForErrorIndication(5) || setCheckForErrorIndication(6) || (summaryFocusFlag)) ? 'visible' : 'hidden'">Summary
                  <span>{{htmlToPlaintext(storyData.summary)?.length}}/{{(summaryMaxLength ? summaryMaxLength : 300)}} char</span>
                </label>
                <div class='dataField bdrfill'>
                  <ng-container *ngIf="isCKEditorEnabled">
                    <div id="storyElement" (keyup)="summaryKeyUpEvent($event)" (keydown)="summaryKeyDownEventCk($event)">
                      <ckeditor [editor]="ckEditor2"  id="{{id}}"
                      [data]="summary"
                      [config]="cksummaryconfig"
                      [tabindex]="0"
                      (ready)="ckchanges($event, 'ready', 'summary')"
                      (change)="onChange($event,'summary')"
                      (blur)="ckchanges($event, 'blur', 'summary')"
                      (focus)="ckchanges($event, 'focus', 'summary')"
                      (error)="ckchanges($event, 'error', 'summary')"
                      ></ckeditor>
                    </div>
                  </ng-container>
                 
                  <span class="fieldValidation"
                    *ngIf="summaryRestrictionChecks.includes('summary')
                    && sharedService.checkIfRestrictedCharactersArePresent(storyData.summary, 'summary')">
                    Please remove (")</span>
                </div>
                <div class="storyaction" *ngIf=(storyEditMode)>
                  <ng-container *ngIf="isNewsletterFieldsEnabled()">
                    <span id="headline1" class="plusHeadline" (click)="openSummaryPopup(true)">
                      <i class="icon-add-headline"></i>
                    </span>
                  </ng-container>
                  <span id="summary1" class="deleteHeadline" (click)="clearSummary()">
                    <i class="icon-delete"></i>
                  </span>
                </div>
              </li>

              <li [class]="setCheckForErrorIndication(7) ? ((pickStoryImageLoad || imageUploadInProgress)
              ? 'leadMedia errorInput loadwaiting' : 'leadMedia errorInput') : ((pickStoryImageLoad || imageUploadInProgress) ? 'leadMedia loadwaiting' : 'leadMedia')"
                id="leadMedia">
                <ng-container *ngIf="(storyData.leadMedia && storyData.leadMedia.elements && (storyData.leadMedia.elements.length > 0))">
                  <div class="element-module" #leadElement [leadMedia]="true" [leadMediaGif]="false" [EditMode]="storyEditMode" [id]="storyData.leadMedia.elements[0]"
                    [cardId]="storyData.leadMedia.elements[0]" (deleteCardfn)="deleteImageCardEmit($event)"
                    (updateContentOnParent)="getUpadtedElementContent($event)" [preLoadedcardData]="serveElementContent(storyData.leadMedia.elements[0])"
                    (sendWordCountToStory)="getWordCount($event)" (childKeyDown)="childKeyDownEventCatcher($event)"
                    [hideDragger]="true" (currentcardfn)="currentCardId(null)" (previousFocusEmit)="focusOnElement($event, 'lead|up')"
                    (nextFocusEmit)="focusOnElement($event, 'lead|down')" (incrementPendingRequest)="increasePendingCount()"
                    (decrementPendingRequest)="decreasePendingCount($event)" [showErrorForPublish]="setCheckForErrorIndication(7)"
                    (scrollOut)="scr($event)" (storySave)="autoSaveRequest($event)" [storytype]="storyType" [leadVideoThumbnail]="true"
                    (sendVideoCaption)="updateVideoCaption($event)" (sendVideoImageCaption)="updateVideoImageCaption($event)"
                    (sendReplaceVideoImage)="replacingVideoThumbnail($event)"
                    >
                  </div>
                </ng-container>
                <ng-container *ngIf="(pickStoryImageLoad || imageUploadInProgress)">
                  <div class="imagepreloader">
                    <div class="a" style="--n: 5;">
                      <div class="dot dot1" style="--i: 0;"></div>
                      <div class="dot dot2" style="--i: 1;"></div>
                      <div class="dot dot3" style="--i: 2;"></div>
                      <div class="dot dot4" style="--i: 3;"></div>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="!(storyData.leadMedia && storyData.leadMedia.elements && (storyData.leadMedia.elements.length > 0))
                  && storyEditMode && !(pickStoryImageLoad || imageUploadInProgress)">
                  <label [style.visibility]="focusOnLeadMedia === true ? 'visible' : 'hidden'">Lead Media</label>
                  <div class="dataField" (focus)="focusOnLeadMedia = true;focusedCard = null" (focusout)="focusOnLeadMedia = (leadMediaImageToggle ? true : false)"
                    (mouseenter)="focusOnLeadMedia = true" (mouseleave)="focusOnLeadMedia = (leadMediaImageToggle ? true : false)"
                    tabindex="3">
                    <ul [ngClass]="{'z-high': leadMediaImageToggle}" class="leadMediaIcon">
                      <li class="spImg_story">
                        <span class="i_image" [ngClass]="{'active' : leadMediaImageToggle}" (click)="listClick($event,1)">
                          <i class="icon-image"></i>
                        </span>
                        <div [class]="'imageAction' +  (leadMediaImageToggle ? ' block' : '') ">
                          <div class="blockContain">
                            <div class="uploadimage">
                              <i class="icon-upload"></i>
                              <div class="upload-btn-wrapper">
                                <span class="btn">Upload a new Image</span>
                                <input type="file" name="myfile" accept="image/*" (change)="onFileChangeSingle($event, 'leadMedia')" />
                              </div>
                            </div>
                            <div class="pickimage">
                              <i class="icon-image-library"></i>
                              <span (click)="showGallery()" class="pickimageBtn">Pick from Image Library</span>
                              <div class="lightBox block" *ngIf="isLightbox">
                                <div class="headerLight">
                                  <div class="close fl spImg" (click)="disableshowGallery()"></div>
                                </div>
                                <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="getLeadMediaId($event)"
                                  *ngIf="isPhotopopup"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="spImg_story" *ngIf="getLeadVideoFlag('story')">
                        <span class="i_video" [ngClass]="{'active' : leadMediaVideoToggle}" (click)="showVideoGallery('leadMedia')">
                          <i class="icon-video"></i>
                        </span>
                      </li>
                    </ul>
                  </div>
                </ng-container>
              </li>

              <!-- Gif Image -->
              <li [class]="setCheckForErrorIndication(23) ? ((pickStoryImageLoadGif || imageUploadInProgressGif)
              ? 'leadMedia leadMediaGif errorInput loadwaiting' : 'leadMedia leadMediaGif errorInput') : ((pickStoryImageLoadGif || imageUploadInProgressGif) ? 'leadMedia leadMediaGif loadwaiting' : 'leadMedia leadMediaGif')"
                id="leadMediaGif" *ngIf="enableGifMedia">
                <ng-container *ngIf="(storyData.leadMediaGif && storyData.leadMediaGif.elements && (storyData.leadMediaGif.elements.length > 0))">
                  <div class="element-module" #leadElementl [leadMediaGif]="true" [leadMedia]="false" [EditMode]="storyEditMode" [id]="storyData.leadMediaGif.elements[0]" [cardTypeGif]="'gif'"
                    [cardId]="storyData.leadMediaGif.elements[0]" (deleteCardfn)="deleteImageCardEmit($event)"
                    (updateContentOnParent)="getUpadtedElementContent($event)" [preLoadedcardData]="serveElementContent(storyData.leadMediaGif.elements[0])"
                    (sendWordCountToStory)="getWordCount($event)" (childKeyDown)="childKeyDownEventCatcher($event)"
                    [hideDragger]="true" (currentcardfn)="currentCardId(null)" (previousFocusEmit)="focusOnElement($event, 'lead|up')"
                    (nextFocusEmit)="focusOnElement($event, 'lead|down')" (incrementPendingRequest)="increasePendingCount()"
                    (decrementPendingRequest)="decreasePendingCount($event)" [showErrorForPublish]="setCheckForErrorIndication(23)"
                    (scrollOut)="scr($event)" (storySave)="autoSaveRequest($event)" [storytype]="storyType">
                  </div>
                </ng-container>
                <ng-container *ngIf="(pickStoryImageLoadGif || imageUploadInProgressGif)">
                  <div class="imagepreloader">
                    <div class="a" style="--n: 5;">
                      <div class="dot dot1" style="--i: 0;"></div>
                      <div class="dot dot2" style="--i: 1;"></div>
                      <div class="dot dot3" style="--i: 2;"></div>
                      <div class="dot dot4" style="--i: 3;"></div>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="!(storyData.leadMediaGif && storyData.leadMediaGif.elements && (storyData.leadMediaGif.elements.length > 0))
                  && storyEditMode && !(pickStoryImageLoadGif || imageUploadInProgressGif)">
                  <label [style.visibility]="focusOnLeadMedia === true ? 'visible' : 'hidden'">Gif Media</label>
                  <div class="dataField" (focus)="focusOnLeadMedia = true;focusedCard = null" (focusout)="focusOnLeadMedia = (leadMediaImageGifToggle ? true : false)"
                    (mouseenter)="focusOnLeadMedia = true" (mouseleave)="focusOnLeadMedia = (leadMediaImageGifToggle ? true : false)"
                    tabindex="3">
                    <div class="uploadimage gifUpload">
                      <div class="upload-btn-wrapper relative">
                        <i class="icon-upload"></i>
                        <span class="btn">Upload a new gif Image</span>
                        <input type="file" accept="image/*" name="myfile" (change)="onFileChangeSingle($event, 'leadMediaGif')" />
                      </div>
                    </div>
                    <!-- <ul [ngClass]="{'z-high': leadMediaImageGifToggle}" class="leadMediaIcon">
                      <li class="spImg_story">
                        <span class="i_image" [ngClass]="{'active' : leadMediaImageGifToggle}" (click)="listClick($event,2)">
                          <i class="icon-image"></i>
                        </span>
                        <div [class]="'imageAction' +  (leadMediaImageGifToggle ? ' block' : '') ">
                          <div class="blockContain">
                            <div class="uploadimage">
                              <i class="icon-upload"></i>
                              <div class="upload-btn-wrapper">
                                <span class="btn">Upload a new Image</span>
                                <input type="file" name="myfile" accept="image/*" (change)="onFileChangeSingle($event, 'leadMediaGif')" />
                              </div>
                            </div>
                            <div class="pickimage">
                              <i class="icon-image-library"></i>
                              <span (click)="showGalleryGif()" class="pickimageBtn">Pick from Image Library</span>
                              <div class="lightBox block" *ngIf="isLightbox">
                                <div class="headerLight">
                                  <div class="close fl spImg" (click)="disableshowGalleryGif()"></div>
                                </div>
                                <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="getLeadMediaGifId($event)"
                                  *ngIf="isPhotopopup"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul> -->
                  </div>
                </ng-container>
              </li>
              <!-- element list -->
              <li class="elementListDrag" #autoscroll>
                <ul class='container' #lis [dragula]="'sixth-bag'" [dragulaModel]='storyData.elements'>
                  <li *ngFor="let elementId of viewPortItems;let i = index">
                    <ng-container *ngIf="elementId !== hideElementId">
                      <div #elReferenc class="element-module" [id]="elementId" [preLoadedcardData]="serveElementContent(elementId)"
                        (updateContentOnParent)="getUpadtedElementContent($event)" (cardDataFromElement)="getCardDatafromElement($event)"
                        (removeSavedCardData)="removeSaved($event)" [cardId]="elementId" [EditMode]="storyEditMode"
                        [editCardFlag]="storyEditMode" [editCardId]="currentcardId" (saveCardfn)="saveCardEmit($event)"
                        (deleteCardfn)="deleteCardEmit($event)" (childKeyDown)="childKeyDownEventCatcher($event)"
                        (currentcardfn)="currentCardId($event)" (afterInitializeEmit)="removeTempCardView($event)"
                        (selectOneStory)="openViewForSingleStorySelect($event)" (sendWordCountToStory)="getWordCount($event)"
                        (emitInsertInlineElement)="addInlineElement($event)" (previousFocusEmit)="focusOnElement($event, 'up')"
                        (nextFocusEmit)="focusOnElement($event, 'down')" (changeRelated)="getRelatedStoryEmits($event)" (changeRelatedHowto)="getRelatedStoryEmitsHowto($event)"
                        (updateCardDatafn)="receiveCardData($event)" (emitParaDeleteContent)="mergeParaWithUpper($event)"
                        (lastindexfn)="lastParaIndex($event)" [storyElementArray]="storyData.elements"
                        (incrementPendingRequest)="increasePendingCount()" (decrementPendingRequest)="decreasePendingCount($event)"
                        (scrollOut)="scr($event)" [storyId]="id" (embedChangeOutput)="checkForSourceUrlInEmbed($event)" [modelSuggestion]="modelSuggestion" [brandSuggestion]="brandSuggestion"
                        [storytype]="storyType" (paraContentChanged)="onParaContentChanged($event)" [disableEditPara]="disableEditPara"
                        (manualLinkCountIncr)="manualAutoBacklinkCountIncr()"
                        (manualLinkCountDecr)="manualAutoBacklinkCountDecr()"
                        >
                      </div>
                    </ng-container>
                  </li>
                </ul>
              </li>

              <!-- temp elements -->
              <li>
                <ul class='container' *ngIf="tempCardArray.ids.length > 0">
                  <li *ngFor="let element of tempCardArray.objs">
                    <div #elReferenceTemp class="temp-view-card" [cardType]="'paragraph'" [cardData]="element">
                    </div>
                  </li>
                </ul>
              </li>

              <!-- new element -->
              <li *ngIf="storyEditMode && showTempPara">
                <div #newElement class="element-module" [id]="'newElement'" [cardId]="tempCardData ? tempCardData.id : null"
                  [EditMode]="storyEditMode" [editCardFlag]="storyEditMode" [editCardId]="currentcardId" (saveCardfn)="saveCardEmit($event)"
                  (deleteCardfn)="deleteCardEmit($event)" (childKeyDown)="childKeyDownEventCatcher($event)"
                  (updateContentOnParent)="getUpadtedElementContent($event)" (cardDataFromElement)="getCardDatafromElement($event)"
                  (removeSavedCardData)="removeSaved($event)" (currentcardfn)="currentCardId($event)"
                  (sendWordCountToStory)="getWordCount($event)" (previousFocusEmit)="focusOnElement($event, 'up')"
                  (nextFocusEmit)="focusOnElement($event, 'down')" (emitParaDeleteContent)="mergeParaWithUpper($event)"
                  [preLoadedcardData]="tempCardData" (lastindexfn)="lastParaIndex($event)" (tempParaSaveEmit)="getTempParaSavedId($event)"
                  (deleteTempViewOfPara)="showElementOfTempPara($event)" [storyElementArray]="storyData.elements"
                  (incrementPendingRequest)="increasePendingCount()" (decrementPendingRequest)="decreasePendingCount($event)"
                  (scrollOut)="scr($event)" [storytype]="storyType"
                  (manualLinkCountIncr)="manualAutoBacklinkCountIncr()"
                  (manualLinkCountDecr)="manualAutoBacklinkCountDecr()"
                  >

                </div>
              </li>
            </ul>
          <!-- Plagiarism Html Start -->
            <div class="lightBox plagiarismBlock block"  style="display:block;" *ngIf="showPlagText" >
            <div class="lightContent">
              <div class="headingPage">
                <div class="close" (click)="closePlagText()"><i class="icon-close"></i></div>
                <h2 id="plagData">Plagiarism Check</h2>
              </div>
              <div class="contentPart">
                <div class="storyPlagiarism">
                  <div class="storyPart">
                    <ul>
                      <li>
                        <label>Headline</label>
                        <div class="dataField">
                          <div class="fieldBlock" [innerHtml]="storyData.mobileHeadline">
                          </div>
                        </div>
                      </li>
                      <li>
                        <label>Summary</label>
                        <div class="dataField">
                          <div class="fieldBlock" [innerHtml]="storyData.summary">
                          </div>
                        </div>
                      </li>
                      <li class="paragraph" >
                        <label>Paragraph</label>
                        <div class="dataField">
                          <div class="fieldBlock" [innerHtml]="highlightedText">
                          <!-- <p>
                          Assembly Election 2022 LIVE Updates: BJP national president JP Nadda on Wednesday announced that BJP, Apna Dal, and Nishad Party will jointly contest the upcoming Uttar Pradesh assembly polls on 403 seats.<var class="plagiarism-highlight" style="font-style:normal">Addressing a presser, he said, “In the last two days, we had discussions with all our allies in seat sharing.</var> We will fight all 403 seats in UP. This state has given the momentum of development with a double-engine government. <var class="plagiarism-highlight" style="font-style:normal">With the model of ‘Sabka Sath Sabka Vikas, development has been our agenda in all sectors.</var> <var class="plagiarism-highlight" style="font-style:normal">Be it is connectivity, education, health, etc. In all these aspects our alliance has worked together.</var> <var class="plagiarism-highlight" style="font-style:normal">Women, youths, law, and order have been our focus in the last five years.</var> <var class="plagiarism-highlight" style="font-style:normal">The situation was completely different in the raj (rule)
                          of the previous government.</var> There was ‘Gunda raj’, etc. Today everything has changed under our government.”</p>
                          <p>Meanwhile, Amit Palekar, an advocate by profession was announced as Aam Aadmi Party (AAP)’s chief minister face for the upcoming Goa assembly elections.</p>
                          <p><var class="plagiarism-highlight" style="font-style:normal">On the other hand, Aparna Yadav, daughter-in-law of former Uttar Pradesh chief minister Mulayam Singh Yadav, officially joined the BJP on Wednesday ahead of UP polls.</var></p>
                          <p><var class="plagiarism-highlight" style="font-style:normal">Bharatiya Janata Party (BJP) is all set to hold rallies in a ‘hybrid mode’ amid a ban on physical rallies due to rising cases of Covid-19.</var> <var class="plagiarism-highlight" style="font-style:normal">Reportedly, the party has curated a fresh strategy for the upcoming five state polls, wherein the rallies will be telecast live on several social media platforms, that will witness a crowd of around 2 lakh people.</var></p>
                          <p>The Election Commission on Tuesday let off the Samajwadi Party with a light rap for violating Covid-19 norms on its office premises last week, advising it to be careful and ensure such breaches do not happen in the future. <var class="plagiarism-highlight" style="font-style:normal">Considering that it is the first reported violation during the current round of elections, the Commission advised it to follow all the extant guidelines diligently, according to an order.</var></p>
                          <p><var class="plagiarism-highlight" style="font-style:normal">Meanwhile, the Congress will “expose failures” of the BJP on several issues, including that of farmers and women, internal security, price rise and unemployment, in the run-up to the assembly polls in five states beginning February 10, party sources told PTI.</var> <var class="plagiarism-highlight" style="font-style:normal">They said that as part of its campaign, senior Congress leaders will hold press conferences in all the poll-bound states on Wednesday on the issue of farmers.</var> <var class="plagiarism-highlight" style="font-style:normal">They said the party seeks to highlight how the BJP has failed to double farmers’ income and how it has burdened them with additional taxes on farm inputs and given the agrarian community pain due to the farm laws.</var></p>
                          <p>Meanwhile, Amit Palekar, an advocate by profession was announced as Aam Aadmi Party (AAP)’s chief minister face for the upcoming Goa assembly elections.</p>
                          <p><var class="plagiarism-highlight" style="font-style:normal">On the other hand, Aparna Yadav, daughter-in-law of former Uttar Pradesh chief minister Mulayam Singh Yadav, officially joined the BJP on Wednesday ahead of UP polls.</var></p>
                          <p><var class="plagiarism-highlight" style="font-style:normal">Bharatiya Janata Party (BJP) is all set to hold rallies in a ‘hybrid mode’ amid a ban on physical rallies due to rising cases of Covid-19.</var> <var class="plagiarism-highlight" style="font-style:normal">Reportedly, the party has curated a fresh strategy for the upcoming five state polls, wherein the rallies will be telecast live on several social media platforms, that will witness a crowd of around 2 lakh people.</var></p>
                          <p>The Election Commission on Tuesday let off the Samajwadi Party with a light rap for violating Covid-19 norms on its office premises last week, advising it to be careful and ensure such breaches do not happen in the future. <var class="plagiarism-highlight" style="font-style:normal">Considering that it is the first reported violation during the current round of elections, the Commission advised it to follow all the extant guidelines diligently, according to an order.</var></p> -->

                          </div>
                          </div>

                        </li>
                    </ul>
                    <div class="fr wid100 right padlr30 ptb15">
                      <button type="button" (click)="closePlagText()" class="cancel gray ml10">Close</button>
                    </div>
                    <div class="clearBoth"></div>
                  </div>
                </div>
              </div>
            </div>
            </div>
<!-- Plagiarism Html End -->
          </div>

          <div>
            <div class="story_icons">
              <ul class="para_icons">
                <!-- <li class="font_icon spImg_story"></li> -->
                <li class="image_icon" (click)="openInlineImageOption('image')" #toolbarInlineImage>
                  <i class="icon-image" id="buttonInsertImage"></i><span class="tooltip">Insert Image</span>
                  <div [class]="'imageAction' +  (inlineImageToggle ? ' block' : '') ">
                    <div class="blockContain">
                      <div class="uploadimage">
                        <i class="icon-upload"></i>
                        <div class="upload-btn-wrapper">
                          <span class="btn">Upload new File</span>
                          <ng-container *ngIf="!sharedService.isdomainConfig('story','multipleInlineImage')">
                              <input type="file" name="myfile" accept="image/*" (change)="onFileChange($event, 'elements')" />
                          </ng-container>
                          <ng-container *ngIf="sharedService.isdomainConfig('story','multipleInlineImage')">
                            <input #uploadGalleryId tabindex="0" type="file" accept="image/*" name="myfile" (change)="multipleInlineUpload($event, 'elements')" multiple />
                          </ng-container>
                        </div>
                      </div>
                      <div class="pickimage">
                        <i class="icon-image-library"></i>
                        <span (click)="addInlineImage()" class="pickimageBtn">Pick from Image Library</span>
                      </div>
                    </div>
                  </div>
                </li>
                <li class="gallery_icon" (click)="openInlineImageOption('sample_image')" #toolbarSampleImage>
                  <i class="icon-image-gallery" id="buttonInsertImage"></i><span class="tooltip">Insert Sample Images Element</span>
                  <div [class]="'imageAction' +  (sampleImageToggle ? ' block' : '') ">
                    <div class="blockContain">
                      <div class="uploadimage">
                        <i class="icon-upload"></i>
                        <div class="upload-btn-wrapper">
                          <span class="btn">Upload new Files</span>
                            <input #uploadGalleryId tabindex="0" type="file" accept="image/*" name="myfile" (change)="multipleSampleUpload($event, 'elements')" multiple />
                        </div>
                      </div>
                      <div class="pickimage">
                        <i class="icon-image-library"></i>
                        <span (click)="addSampleFromGallery()" class="pickimageBtn">Pick from Image Library</span>
                      </div>
                    </div>
                  </div>
                </li>
                
                
                <li class="pdf_icon">
                  <i class="icon-pages"  (click)="isButtonDisabled() ? showMessage('PDF') : file.click()"></i>
                  <div class="upload-btn-wrapper">
                    <input #file [disabled]="isButtonDisabled()" type="file" name="myfile" accept=".pdf" (change)="onFileChange($event, 'elements')"/>
                  </div>
                  <span class="tooltip">Insert Pdf</span>
                </li>
                <ng-container *ngIf="(isAmazonEnabled());then amazonData else embedData"></ng-container>

                <ng-template #amazonData>

                <li class="embed_icon relative" (click)="isButtonDisabled() ? showMessage('Embed') : openInlineImageOption('embed')"  #toolbarEmbed>
                  <i class="icon-embed" id="buttonInsertEmbed"></i>
                  <span class="tooltip">Insert Embed</span>
                  <div [class]="'embedSelect' +  (inlineEmbedToggle ? ' block' : '') ">
                    <div class="embedDropBlock">
                      <div class="embedInsert">
                          <span (click)="isButtonDisabled() ? showMessage('Embed') : openEmbedPopup('elements')" id="insertEmbedForHT">Insert Embed</span>
                      </div>
                      <div class="embedLibrary">
                        <span (click)="openElementModal('embed')">Pick from Library</span>
                      </div>
                      </div>
                  </div>
                </li>
                </ng-template>
                <ng-template #embedData>
                  <li class="embed_icon" (click)="isButtonDisabled() ? showMessage('Embed') : openEmbedPopup('elements')">
                    <i class="icon-embed" id="buttonInsertEmbed"></i>
                    <span class="tooltip">Insert Embed</span>
                  </li>

                  </ng-template>


                <li class="related_icon spImg_story"
                (click)="isButtonDisabled() ? showMessage('Related Stories') : openRelatedStoryModal('Related Stories','multiple')" id="buttonRelatedStory">
                  <span class="tooltip">Insert Related Story</span>
                </li>

                <li class="related_icon spImg_story"
                (click)="isButtonDisabled() ? showMessage('Also Reas') : openRelatedStoryModal('Also Read','multiple')" id="buttonRelatedStory">
                  <span class="tooltip">Insert Also Read</span>
                </li>
                <!-- for auto & tech -->
                <ng-container *ngIf="enableInlineRelatedStoryHowto">
                <li class="related_icon spImg_story"
                (click)="isButtonDisabled() ? showMessage('Related Stories') : openRelatedHowtoStoryModal('multiple')" id="buttonRelatedStory">
                  <span class="tooltip">Insert HowTo Story</span>
                </li>
              </ng-container>


                <ng-container *ngIf="(isTableEnabled());then tablOptions else tableOption"></ng-container>

                <ng-template #tablOptions>

                <li class="table_icon spImg_story" (click)="openInlineImageOption('table')"  #toolbarTable>
                  <i class="icon-table"></i>
                  <span class="tooltip">Insert Table</span>
                  <div [class]="'tableSelect' +  (inlineTableToggle ? ' block' : '') ">
                    <div class="tableDropBlock">
                      <div class="tableInsert">
                          <span (click)="isButtonDisabled() ? showMessage('Table') : createNewTable('elements')">Insert Table</span>
                      </div>
                      <div class="tableLibrary">
                        <span (click)="openElementModal('table')">Pick from Library</span>
                      </div>
                      </div>
                  </div>
                </li>
                </ng-template>
                <ng-template #tableOption>
                  <li *ngIf="domainConfig.elementsDisabled.indexOf('Embed') === -1" class="table_icon spImg_story"
                  (click)="createNewTable('elements')">
                     <i class="icon-table"></i>
                     <span class="tooltip">Insert Table</span>
                  </li>

                  </ng-template>


                <li class="video_icon"  *ngIf="domainConfig.elementsDisabled.indexOf('video') === -1"
                  (click)="isButtonDisabled() ? showMessage('Video') : showVideoGallery('elements')">
                  <i class="icon-video" id="buttonInsertVideo"></i>
                  <span class="tooltip">Insert Video</span>
                </li>
                <li *ngIf="domainConfig.elementsDisabled.indexOf('quote') === -1"
                class="quotes_icon relative" (click)="isButtonDisabled() ? showMessage('Quote') : openQuotePopup()">
                  <i class="icon-quote-active"></i>
                  <span class="tooltip">Insert Quote</span>
                </li>
                <li *ngIf="domainConfig.elementsDisabled.indexOf('review') === -1" #toolbarReview
                class="reviews_icon relative" (click)="isButtonDisabled() ? showMessage('Review') : openInlineImageOption('review')">
                  <i class="icon-star-active"></i>
                  <span class="tooltip">Review</span>
                  <div [class]="'reviewSelect' +  (inlineReviewToggle ? ' block' : '') ">
                    <div class="reviewDropBlock">
                      <div class="reviewInsert">
                          <span (click)="addReview()">Insert Review</span>
                      </div>
                      <div class="reviewLibrary">
                        <span (click)="openElementModal('review')">Pick from Library</span>
                      </div>
                      </div>
                  </div>
                </li>
                <li *ngIf="domainConfig.elementsDisabled.indexOf('market') === -1" class="market_icon"
                 (click)="isButtonDisabled() ? showMessage('Market') : openMarketPopup()">
                  <i class="icon-market" id="buttonInsertMarket"></i>
                  <span class="tooltip">Insert Market</span>
                </li>





                <li class="scorecard_icon" *ngIf="domainConfig.elementsDisabled.indexOf('cricket') === -1"
                (click)="isButtonDisabled() ? showMessage('Match') : openMatchPopup()">
                 <i class="icon-scorecard"></i>
                 <span class="tooltip">Insert Scorecard</span>
               </li>
               <li class="chart_icon" *ngIf="domainConfig.elementsDisabled.indexOf('chart') === -1"
                (click)="isButtonDisabled() ? showMessage('Chart') : openChartPopup()">
                 <i class="icon-charts-graphs"></i>
                 <span class="tooltip">Insert Chart</span>
               </li>
               <li class="faq_icon spImg_story1" *ngIf="domainConfig.elementsDisabled.indexOf('faq') === -1"
                (click)="isButtonDisabled() ? showMessage('Faqs') : openFaqPopup()">
                 <!-- <i class="icon-faqs-graphs"></i> -->
                 <span class="tooltip">Insert Faq</span>
              </li>
               <li class="step_icon spImg_storyQuestion" *ngIf="domainConfig.elementsDisabled.indexOf('howToSteps') === -1"
                (click)="isButtonDisabled() ? showMessage('Steps') : openStepPopup()">
                 <!-- <i class="icon-faqs-graphs"></i> -->
                 <span class="tooltip">Insert Steps</span>
               </li>
               <li class="step_icon spImg_recipeIcon" *ngIf="domainConfig.elementsDisabled.indexOf('recipe') === -1"
               (click)="isButtonDisabled() ? showMessage('recipe') : openRecipePopup()">
                <!-- <i class="icon-faqs-graphs"></i> -->
                <span class="tooltip">Insert Recipe</span>
              </li>
               <li class="step_icon spImg_podcast_podcast podcast_align" *ngIf="domainConfig.elementsDisabled.indexOf('podcast') === -1"
                (click)="isButtonDisabled() ? showMessage('Podcast') : openPodcastPopup()">
                 <!-- <i class="icon-faqs-graphs"></i> -->
                 <span class="tooltip">Insert Podcast</span>
               </li>
               <li class="related_icon spImg_story" *ngIf="domainConfig.elementsDisabled.indexOf('productElement') === -1"
               (click)="isButtonDisabled() ? showMessage('Product Popup') : openProductPopup()" id="buttonProductElement">
                 <span class="tooltip">Insert Product Element</span>
               </li>
               <li class="related_icon spImg_story" *ngIf="domainConfig.elementsDisabled.indexOf('categoryProductElement') === -1"
               (click)="isButtonDisabled() ? showMessage('Product Popup') : openCategoryProductPopup()" id="buttonCategoryProductElement">
                 <span class="tooltip">Insert Category Product Element</span>
               </li>
              </ul>
            </div>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'deadlink'">
          <!-- <app-deadlink-story [storyDataInput]="storyData" [headline]="headline" [changeFlag]="changeFlag" [summary]="summary" [focusOnLeadMedia]="focusOnLeadMedia" [storyEditMode]="storyEditMode"></app-deadlink-story> -->
          <div class="formStory fl100" [ngStyle]="setStoryHeight()" #formStory>
            <ul class="storyuL">
              <li #headlineEl [class]="setCheckForErrorIndication(1) ? ((storyData.mobileHeadline && (htmlToPlaintext(storyData.mobileHeadline).length > 80)) ? ('headline errorborder errorInput fl100') : ('headline errorInput fl100')) : ((storyData.mobileHeadline && (htmlToPlaintext(storyData.mobileHeadline).length > 80)) ? ('headline errorborder fl100') : ('headline fl100')) "
                (focus)="setFocus('headline')">
                <label id="storyButton" [style.visibility]="(setCheckForErrorIndication(1) || (headlineFocusFlag)) ? 'visible' : 'hidden'">
                  Landing page headline
                  <i class="mandate">*</i>
                  <span>{{htmlToPlaintext(storyData.mobileHeadline)? htmlToPlaintext(storyData.mobileHeadline).length:
                    '0'}}/{{headlineMaxLength}}
                    char</span>
                </label>
                <div class="dataField bdrfill">
                  <div id="storyElement" (keypress)="hotkeypress($event)" (keyup)="headlineKeyUpEvent($event)" (keydown)="headlineKeyDownEventCk($event)">
                    <ckeditor [editor]="ckEditor"  id="{{id}}"
                    [data]="headline"
                    [config]="ckplainconfig"
                    [tabindex]="0"
                    (ready)="ckchanges($event, 'ready', 'headline')"
                    (change)="onChange($event,'headline')"
                    (blur)="ckchanges($event, 'blur', 'headline')"
                    (focus)="ckchanges($event, 'focus', 'headline')"
                    (error)="ckchanges($event, 'error', 'headline')"
                    ></ckeditor>
                  </div>
                  <span class="fieldValidation"
                  *ngIf="headlineRestrictionChecks.includes('mobileHeadline')
                  && sharedService.checkIfRestrictedCharactersArePresent(storyData.mobileHeadline, 'headline')">
                  Please remove ((") {{'{}'}} [])</span>
                </div>
                <div class="storyaction" *ngIf=(storyEditMode)>
                  <span class="deleteHeadline" id="headline2" (click)="clearHeadline();">
                    <i class="icon-delete"></i>
                  </span>
                </div>
              </li>
              <!-- Summary  -->
               <li #summaryEl [class]="(setCheckForErrorIndication(5) || setCheckForErrorIndication(6)) ?
               ((storyData.summary && (htmlToPlaintext(storyData.summary).length > (summaryMaxLength ? summaryMaxLength : 300))) ?
                ('summary errorborder errorInput') : ('summary errorInput')) :
                 ((storyData.summary && (htmlToPlaintext(storyData.summary).length > (summaryMaxLength ? summaryMaxLength : 300))) ? ('summary errorborder') : ('summary'))">
                <label [style.visibility]="(setCheckForErrorIndication(5) || setCheckForErrorIndication(6) || (summaryFocusFlag)) ? 'visible' : 'hidden'">Summary
                  <span>{{htmlToPlaintext(storyData.summary)?.length}}/{{(summaryMaxLength ? summaryMaxLength : 300)}} char</span>
                </label>
                <div class='dataField bdrfill'>
                 
                  <div id="storyElement" (keyup)="summaryKeyUpEvent($event)" (keydown)="summaryKeyDownEventCk($event)">
                    <ckeditor [editor]="ckEditor2"  id="{{id}}"
                    [data]="summary"
                    [config]="cksummaryconfig"
                    [tabindex]="0"
                    (ready)="ckchanges($event, 'ready', 'summary')"
                    (change)="onChange($event,'summary')"
                    (blur)="ckchanges($event, 'blur', 'summary')"
                    (focus)="ckchanges($event, 'focus', 'summary')"
                    (error)="ckchanges($event, 'error', 'summary')"
                    ></ckeditor>
                  </div>
                  <span class="fieldValidation"
                    *ngIf="summaryRestrictionChecks.includes('summary')
                    && sharedService.checkIfRestrictedCharactersArePresent(storyData.summary, 'summary')">
                    Please remove (")</span>
                </div>
                <div class="storyaction" *ngIf=(storyEditMode)>
                  <span id="summary1" class="deleteHeadline" (click)="clearSummary()">
                    <i class="icon-delete"></i>
                  </span>
                </div>
              </li>
          <li [class]="setCheckForErrorIndication(7) ? ((pickStoryImageLoad || imageUploadInProgress)
          ? 'leadMedia errorInput loadwaiting' : 'leadMedia errorInput') : ((pickStoryImageLoad || imageUploadInProgress) ? 'leadMedia loadwaiting' : 'leadMedia')"
            id="leadMedia">
            <ng-container *ngIf="(storyData.leadMedia && storyData.leadMedia.elements && (storyData.leadMedia.elements.length > 0))">
              <div class="element-module" #leadElement [leadMedia]="true" [EditMode]="storyEditMode" [id]="storyData.leadMedia.elements[0]"
                [cardId]="storyData.leadMedia.elements[0]" (deleteCardfn)="deleteImageCardEmit($event)"
                (updateContentOnParent)="getUpadtedElementContent($event)" [preLoadedcardData]="serveElementContent(storyData.leadMedia.elements[0])"
                (sendWordCountToStory)="getWordCount($event)" (childKeyDown)="childKeyDownEventCatcher($event)"
                [hideDragger]="true" (currentcardfn)="currentCardId(null)" (previousFocusEmit)="focusOnElement($event, 'lead|up')"
                (nextFocusEmit)="focusOnElement($event, 'lead|down')" (incrementPendingRequest)="increasePendingCount()"
                (decrementPendingRequest)="decreasePendingCount($event)" [showErrorForPublish]="setCheckForErrorIndication(7)"
                (scrollOut)="scr($event)" (storySave)="autoSaveRequest($event)" [storytype]="storyType">
              </div>
            </ng-container>
            <ng-container *ngIf="(pickStoryImageLoad || imageUploadInProgress)">
              <div class="imagepreloader">
                <div class="a" style="--n: 5;">
                  <div class="dot dot1" style="--i: 0;"></div>
                  <div class="dot dot2" style="--i: 1;"></div>
                  <div class="dot dot3" style="--i: 2;"></div>
                  <div class="dot dot4" style="--i: 3;"></div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="!(storyData.leadMedia && storyData.leadMedia.elements && (storyData.leadMedia.elements.length > 0))
              && storyEditMode && !(pickStoryImageLoad || imageUploadInProgress)">
              <label [style.visibility]="focusOnLeadMedia === true ? 'visible' : 'hidden'">Lead Media</label>
              <div class="dataField" (focus)="focusOnLeadMedia = true;focusedCard = null" (focusout)="focusOnLeadMedia = (leadMediaImageToggle ? true : false)"
                (mouseenter)="focusOnLeadMedia = true" (mouseleave)="focusOnLeadMedia = (leadMediaImageToggle ? true : false)"
                tabindex="3">
                <ul [ngClass]="{'z-high': leadMediaImageToggle}" class="leadMediaIcon">
                  <li class="spImg_story">
                    <span class="i_image" [ngClass]="{'active' : leadMediaImageToggle}" (click)="listClick($event,1)">
                      <i class="icon-image" id="iconForImageUpload"></i>
                    </span>
                    <div [class]="'imageAction' +  (leadMediaImageToggle ? ' block' : '') ">
                      <div class="blockContain">
                        <div class="uploadimage">
                          <i class="icon-upload"></i>
                          <div class="upload-btn-wrapper">
                            <span class="btn">Upload a new Image</span>
                            <input type="file" name="myfile" accept="image/*" (change)="onFileChangeSingle($event, 'leadMedia')" />
                          </div>
                        </div>
                        <div class="pickimage">
                          <i class="icon-image-library"></i>
                          <span (click)="showGallery()" class="pickimageBtn" id="imagePicFromLib">Pick from Image Library</span>
                          <div class="lightBox block" *ngIf="isLightbox">
                            <div class="headerLight">
                              <div class="close fl spImg" (click)="disableshowGallery()"></div>
                            </div>
                            <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="getLeadMediaId($event)"
                              *ngIf="isPhotopopup"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </ng-container>
          </li>
          <li class="elementListDrag" #autoscroll>
            <ul class='container' #lis [dragula]="'sixth-bag'" [dragulaModel]='storyData.elements'>
              <li *ngFor="let elementId of viewPortItems;let i = index">
                <ng-container *ngIf="elementId !== hideElementId">
                  <div #elReferenc class="element-module" [id]="elementId" [preLoadedcardData]="serveElementContent(elementId)"
                    (updateContentOnParent)="getUpadtedElementContent($event)" (cardDataFromElement)="getCardDatafromElement($event)"
                    (removeSavedCardData)="removeSaved($event)" [cardId]="elementId" [EditMode]="storyEditMode"
                    [editCardFlag]="storyEditMode" [editCardId]="currentcardId" (saveCardfn)="saveCardEmit($event)"
                    (deleteCardfn)="deleteCardEmit($event)" (childKeyDown)="childKeyDownEventCatcher($event)"
                    (currentcardfn)="currentCardId($event)" (afterInitializeEmit)="removeTempCardView($event)"
                    (selectOneStory)="openViewForSingleStorySelect($event)" (sendWordCountToStory)="getWordCount($event)"
                    (emitInsertInlineElement)="addInlineElement($event)" (previousFocusEmit)="focusOnElement($event, 'up')"
                    (nextFocusEmit)="focusOnElement($event, 'down')" (changeRelated)="getRelatedStoryEmits($event)" (changeRelatedHowto)="getRelatedStoryEmitsHowto($event)" (changeAlsoRead)="getAlsoReadEmit($event)"
                    (updateCardDatafn)="receiveCardData($event)" (emitParaDeleteContent)="mergeParaWithUpper($event)"
                    (lastindexfn)="lastParaIndex($event)" [storyElementArray]="storyData.elements"
                    (incrementPendingRequest)="increasePendingCount()" (decrementPendingRequest)="decreasePendingCount($event)"
                    (scrollOut)="scr($event)" [storyId]="id" (embedChangeOutput)="checkForSourceUrlInEmbed($event)"
                    [storytype]="storyType"
                    >
                  </div>
                </ng-container>
              </li>
            </ul>
          </li>




          </ul>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'photostory'">
          <div class="formStory listicle storyuL photoStory" [ngStyle]="setStoryHeight()">

            <ul class="storyuL">
              <li #headlineEl [class]="setCheckForErrorIndication(1) ? ((storyData.mobileHeadline && (htmlToPlaintext(storyData.mobileHeadline).length > errorheadlineMaxLength)) ? ('headline errorborder errorInput fl100') : ('headline errorInput fl100')) : ((storyData.mobileHeadline && (htmlToPlaintext(storyData.mobileHeadline).length > errorheadlineMaxLength)) ? ('headline errorborder fl100') : ('headline fl100'))"
                (focus)="setFocus('headline')">
                <label id="storyButton" [style.visibility]="(setCheckForErrorIndication(1) || (headlineFocusFlag)) ? 'visible' : 'hidden'">
                  Landing page headline
                  <i class="mandate">*</i>
                  <span>{{htmlToPlaintext(storyData.mobileHeadline)?.length}}/{{headlineMaxLength}} char'</span>
                </label>
                <div class="dataField bdrfill photoHeadline">
                  <ng-container *ngIf="isCKEditorEnabled">
                    <div id="storyElement" (keypress)="hotkeypress($event)" (keyup)="headlineKeyUpEvent($event)" (keydown)="headlineKeyDownEventCk($event)">
                      <ckeditor [editor]="ckEditor"  id="{{id}}"
                      [data]="headline"
                      [config]="ckplainconfig"
                      [tabindex]="0"
                      (ready)="ckchanges($event, 'ready', 'headline')"
                      (change)="onChange($event,'headline')"
                      (blur)="ckchanges($event, 'blur', 'headline')"
                      (focus)="ckchanges($event, 'focus', 'headline')"
                      (error)="ckchanges($event, 'error', 'headline')"
                      ></ckeditor>
                    </div>
                  </ng-container>
               
                  <span class="fieldValidation"
                  *ngIf="headlineRestrictionChecks.includes('mobileHeadline')
                  && sharedService.checkIfRestrictedCharactersArePresent(storyData.mobileHeadline, 'headline')">
                  Please remove ((") {{'{}'}} [])</span>
                </div>
                <div class="storyaction" *ngIf=(storyEditMode)>
                  <span id="headline1" class="plusHeadline" (click)="discareUrlChanges(true)">
                    <i class="icon-add-headline" id="headlineAddButtton"></i>
                  </span>
                  <span class="deleteHeadline" id="headline2" (click)="clearHeadline()">
                    <i class="icon-delete"></i>
                  </span>
                </div>
              </li>

              <li #summaryEl [class]="(setCheckForErrorIndication(5) || setCheckForErrorIndication(6)) ?
               ((storyData.summary && (htmlToPlaintext(storyData.summary).length > (summaryMaxLength ? summaryMaxLength : 300))) ?
                ('summary errorborder errorInput') : ('summary errorInput')) :
                 ((storyData.summary && (htmlToPlaintext(storyData.summary).length > (summaryMaxLength ? summaryMaxLength : 300))) ? ('summary errorborder') : ('summary'))">
                <label [style.visibility]="(setCheckForErrorIndication(5) || setCheckForErrorIndication(6) || (summaryFocusFlag)) ? 'visible' : 'hidden'">Summary
                  <span>{{htmlToPlaintext(storyData.summary)?.length}}/{{(summaryMaxLength ? summaryMaxLength : 300)}} char</span>
                </label>
                <div class="dataField bdrfill">
                  <ng-container *ngIf="isCKEditorEnabled">
                    <div id="storyElement" (keyup)="summaryKeyUpEvent($event)" (keydown)="summaryKeyDownEventCk($event)">
                      <ckeditor [editor]="ckEditor2"  id="{{id}}"
                      [data]="summary"
                      [config]="cksummaryconfig"
                      [tabindex]="0"
                      (ready)="ckchanges($event, 'ready', 'summary')"
                      (change)="onChange($event,'summary')"
                      (blur)="ckchanges($event, 'blur', 'summary')"
                      (focus)="ckchanges($event, 'focus', 'summary')"
                      (error)="ckchanges($event, 'error', 'summary')"
                      ></ckeditor>
                    </div>
                  </ng-container>
                 
                  <span class="fieldValidation"
                    *ngIf="summaryRestrictionChecks.includes('summary')
                    && sharedService.checkIfRestrictedCharactersArePresent(storyData.summary, 'summary')">
                    Please remove (")</span>
                </div>

                <div class="storyaction" *ngIf=(storyEditMode)>
                  <ng-container *ngIf="isNewsletterFieldsEnabled()">
                    <span id="headline1" class="plusHeadline" (click)="openSummaryPopup(true)">
                      <i class="icon-add-headline"></i>
                    </span>
                  </ng-container>
                  <span id="summary1" class="deleteHeadline" (click)="clearSummary()">
                    <i class="icon-delete"></i>
                  </span>
                </div>
              </li>
            </ul>

            <div class="border_bddd"></div>
            <!-- new element -->
            <ng-container *ngIf="storyEditMode">
              <div #newPhotostoryElement class="element-module newPhotostoryElement" [id]="'newPhotostoryElement'" [cardId]="null" [cardType]="'image'"
                [editCardId]="currentcardId" [EditMode]="storyEditMode" [editCardFlag]="storyEditMode" (saveCardfn)="saveCardEmit($event)"
                (childKeyDown)="childKeyDownEventCatcher($event)" (currentcardfn)="currentCardId($event)"
                [leadMediaId]="storyData.leadMedia.elements?.length > 0 ? storyData.leadMedia.elements[0]: null"
                (tempSaveCard)="saveCardTemporarily($event)" (sendWordCountToStory)="getWordCount($event)"
                [currentFocusedElementId]="focusedCard" (previousFocusEmit)="focusOnElement($event, 'up')"
                (nextFocusEmit)="focusOnElement($event, 'down')" (incrementPendingRequest)="increasePendingCount()"
                (updateContentOnParent)="getUpadtedElementContent($event)" (decrementPendingRequest)="decreasePendingCount($event)"
                (scrollOut)="scr($event)" [storytype]="storyType">
              </div>

              <ul class="storyuL">
                <li>
                  <label class="noBorder" [style.visibility]="'hidden'">&nbsp;</label>
                  <div class="dataField">
                    <button tabindex="0" type="button" name="createCard" style="margin-bottom:35px;"
                    class="yellow" (click)="addSlide()">Add Slide</button>
                  </div>
                </li>
              </ul>
            </ng-container>


            <div #autoscroll>
              <div class='container' [dragula]="'sixth-bag'" [dragulaModel]='storyData.elements'>
                <div *ngFor="let listItemId of storyData.elements; let i = index">
                  <!-- <div *ngFor="let listItemId of storyData.elements; let i = index"> -->
                  <div #elReferenc class="element-module" [id]="listItemId" [cardId]="listItemId" [preLoadedcardData]="serveElementContent(listItemId)"
                    (updateContentOnParent)="getUpadtedElementContent($event)" (setPhotoStoryLeadMedia)="updatePhotoStoryLeadMedia($event)" [leadMediaId]="storyData.leadMedia.elements.length > 0 ? storyData.leadMedia.elements[0]: null"
                    (removeSavedCardData)="removeSaved($event)" (cardDataFromElement)="getCardDatafromElement($event)" [EditMode]="storyEditMode"
                    [editCardFlag]="storyEditMode" [editCardId]="currentcardId" (deleteCardfn)="deleteCardEmit($event)"
                    (childKeyDown)="childKeyDownEventCatcher($event)" (currentcardfn)="currentCardId($event)"
                    (afterInitializeEmit)="removeTempCardView($event)" (sendWordCountToStory)="getWordCount($event)"
                    [currentFocusedElementId]="focusedCard" (currentcardfn)="currentCardId($event)" (previousFocusEmit)="focusOnElement($event, 'up')"
                    (nextFocusEmit)="focusOnElement($event, 'down')" (updateCardDatafn)="receiveCardData($event)"
                    (incrementPendingRequest)="increasePendingCount()" (decrementPendingRequest)="decreasePendingCount($event)"
                    (scrollOut)="scr($event)" (embedChangeOutput)="checkForSourceUrlInEmbed($event)" [storytype]="storyType">
                  </div>
                </div>
              </div>
            </div>

          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'gallery'">
          <div class="formStory photogallery fl100" [ngStyle]="setStoryHeight()">

            <ul class="storyuL">
              <li #headlineEl [class]="setCheckForErrorIndication(1) ? ((storyData.mobileHeadline && (htmlToPlaintext(storyData.mobileHeadline).length > errorheadlineMaxLength)) ? ('headline errorborder errorInput fl100') : ('headline errorInput fl100')) : ((storyData.mobileHeadline && (htmlToPlaintext(storyData.mobileHeadline).length > errorheadlineMaxLength)) ? ('headline errorborder fl100') : ('headline fl100'))"
                (focus)="setFocus('headline')">
                <label id="storyButton" [style.visibility]="(setCheckForErrorIndication(1) || (headlineFocusFlag)) ? 'visible' : 'hidden'">
                  Landing page headline
                  <i class="mandate">*</i>
                  <span>{{htmlToPlaintext(storyData.mobileHeadline)?.length}}/{{headlineMaxLength}} char'</span>
                </label>
                <div class="dataField bdrfill">
                  <ng-container *ngIf="isCKEditorEnabled">
                    <div id="storyElement" (keypress)="hotkeypress($event)" (keyup)="headlineKeyUpEvent($event)" (keydown)="headlineKeyDownEventCk($event)">
                      <ckeditor [editor]="ckEditor"  id="{{id}}"
                      [data]="headline"
                      [config]="ckplainconfig"
                      [tabindex]="0"
                      (ready)="ckchanges($event, 'ready', 'headline')"
                      (change)="onChange($event,'headline')"
                      (blur)="ckchanges($event, 'blur', 'headline')"
                      (focus)="ckchanges($event, 'focus', 'headline')"
                      (error)="ckchanges($event, 'error', 'headline')"
                      ></ckeditor>
                    </div>
                </ng-container>
               
                  <span class="fieldValidation"
                  *ngIf="headlineRestrictionChecks.includes('mobileHeadline')
                  && sharedService.checkIfRestrictedCharactersArePresent(storyData.mobileHeadline, 'headline')">
                  Please remove ((") {{'{}'}} [])</span>
                </div>
                <div class="storyaction" *ngIf=(storyEditMode)>
                  <span id="headline1" class="plusHeadline" (click)="discareUrlChanges(true)">
                    <i class="icon-add-headline" id="headlineAddButtton"></i>
                  </span>
                  <span class="deleteHeadline" id="headline2" (click)="clearHeadline()">
                    <i class="icon-delete"></i>
                  </span>
                </div>
              </li>
              <li #summaryEl [class]="(setCheckForErrorIndication(5) || setCheckForErrorIndication(6)) ?
               ((storyData.summary && (htmlToPlaintext(storyData.summary).length > (summaryMaxLength ? summaryMaxLength : 300))) ?
                ('summary errorborder errorInput') : ('summary errorInput')) :
                 ((storyData.summary && (htmlToPlaintext(storyData.summary).length > (summaryMaxLength ? summaryMaxLength : 300))) ? ('summary errorborder') : ('summary'))">
                <label [style.visibility]="(setCheckForErrorIndication(5) || setCheckForErrorIndication(6) || (summaryFocusFlag)) ? 'visible' : 'hidden'">Summary
                  <span>{{htmlToPlaintext(storyData.summary)?.length}}/{{(summaryMaxLength ? summaryMaxLength : 300)}} char</span>
                </label>
                <div class="dataField bdrfill">
                  <ng-container *ngIf="isCKEditorEnabled">
                    <div id="storyElement" (keyup)="summaryKeyUpEvent($event)" (keydown)="summaryKeyDownEventCk($event)">
                      <ckeditor [editor]="ckEditor2"  id="{{id}}"
                      [data]="summary"
                      [config]="cksummaryconfig"
                      [tabindex]="0"
                      (ready)="ckchanges($event, 'ready', 'summary')"
                      (change)="onChange($event,'summary')"
                      (blur)="ckchanges($event, 'blur', 'summary')"
                      (focus)="ckchanges($event, 'focus', 'summary')"
                      (error)="ckchanges($event, 'error', 'summary')"
                      ></ckeditor>
                    </div>
                  </ng-container>
                 
                <span class="fieldValidation"
                  *ngIf="summaryRestrictionChecks.includes('summary')
                  && sharedService.checkIfRestrictedCharactersArePresent(storyData.summary, 'summary')">
                  Please remove (")</span>
                </div>

                <div class="storyaction" *ngIf=(storyEditMode)>
                  <ng-container *ngIf="isNewsletterFieldsEnabled()">
                    <span id="headline1" class="plusHeadline" (click)="openSummaryPopup(true)">
                      <i class="icon-add-headline"></i>
                    </span>
                  </ng-container>
                  <span id="summary1" class="deleteHeadline" (click)="clearSummary()">
                    <i class="icon-delete"></i>
                  </span>
                </div>
              </li>

              <!-- Upload options to upload the images on top rather than on bottom -->
              <li class="leadMedia" *ngIf="storyEditMode && storyData.elements.length > 0">
                <label style="visibility:hidden">Lead Media</label>
                <div class="dataField">
                  <div class="uploadimage">
                    <div class="upload-btn-wrapper relative">
                      <i class="icon-upload"></i>
                      <span class="btn">Upload a new Image</span>
                      <input #uploadGalleryId tabindex="0" type="file" accept="image/*" name="myfile" (change)="galleryUpload($event, 'elements', 'top')"
                        multiple />
                    </div>
                  </div>
                  <span class="seperator"></span>
                  <div class="pickimage">
                    <i class="icon-image-library"></i>
                    <span #pickGalleryId tabindex="0" id="imagePicFromLib" (click)="showGallery('top')" class="pickimageBtn">Pick
                      from Image Library</span>
                    <div class="lightBox photogallerylist block" *ngIf="isLightbox && showImagePopUpTop">
                      <div class="headerLight">
                        <div class="close fl spImg" (click)="disableshowGallery()"></div>
                      </div>
                      <div class="photo-listing" [exclusionList]="excludeImageListingIds" [photogalleryId]="true"
                        (emitIdfn)="getphotogalleryIds($event, 'top')" *ngIf="isPhotopopup"></div>
                    </div>
                  </div>
                  <div class="pickimage">
                    <i class="icon-image-library"></i>
                    <span  tabindex="0" id="imagePicFromLib" (click)="showViewImages()" class="pickimageBtn">
                      View Images</span>  
                    </div>
                </div>

              </li>

              <!-- element list -->
              <li class="elementListDrag" #autoscroll>
                <ul class='container' [dragula]='"sixth-bag"' [dragulaModel]='storyData.elements'>
                  <li *ngFor="let elementId of viewPortItems;let i = index">
                    <div #elReferenc class="element-module" [leadMediaId]="storyData.leadMedia.elements.length > 0 ? storyData.leadMedia.elements[0]: null"
                      [id]="elementId" [EditMode]="storyEditMode" [cardId]="elementId" [preLoadedcardData]="serveElementContent(elementId)"
                      [storytype]="storyType"(updateContentOnParent)="getUpadtedElementContent($event)" (cardDataFromElement)="getCardDatafromElement($event)"
                      (removeSavedCardData)="removeSaved($event)" (deleteCardfn)="deleteCardEmit($event)"
                      [showToggle]="true" (childKeyDown)="childKeyDownEventCatcher($event)" (sendWordCountToStory)="getWordCount($event)"
                      (setAsLeadMediafn)="getGalleryLeadMedia($event)" (emitParentImageId)="getImageParents($event)"
                      (emitParentImageIdDelete)="deleteImageParents($event)" (previousFocusEmit)="focusOnElement($event, 'up')"
                      (nextFocusEmit)="focusOnElement($event, 'down')" (updateCardDatafn)="receiveCardData($event)"
                      (incrementPendingRequest)="increasePendingCount()" (decrementPendingRequest)="decreasePendingCount($event)"
                      (scrollOut)="scr($event)" (ampValidationOutput)="ampValidationInput($event)" [storytype]="storyType" (cropCompletedEvent)="imageCroppingCompleted($event)">
                    </div>
                  </li>
                </ul>
              </li>

              <li class="leadMedia" *ngIf=(storyEditMode)>
                <label style="visibility:hidden">Lead Media</label>
                <div class="dataField">
                  <div class="uploadimage">
                    <div class="upload-btn-wrapper relative">
                      <i class="icon-upload"></i>
                      <span class="btn">Upload a new Image</span>
                      <input #uploadGalleryId tabindex="0" type="file" accept="image/*" name="myfile" (change)="galleryUpload($event, 'elements')"
                        multiple />
                    </div>
                  </div>
                  <span class="seperator"></span>
                  <div class="pickimage">
                    <i class="icon-image-library"></i>
                    <span #pickGalleryId tabindex="0" id="imagePicFromLib" (click)="showGallery('bottom')" class="pickimageBtn">Pick
                      from Image Library</span>
                    <div class="lightBox photogallerylist block" *ngIf="isLightbox && !showImagePopUpTop">
                      <div class="headerLight">
                        <div class="close fl spImg" (click)="disableshowGallery()"></div>
                      </div>
                      <div class="photo-listing" [exclusionList]="excludeImageListingIds" [photogalleryId]="true"
                        (emitIdfn)="getphotogalleryIds($event, 'bottom')" *ngIf="isPhotopopup"></div>
                    </div>
                  </div>
                  <div class="pickimage">
                    <i class="icon-image-library"></i>
                    <span  tabindex="0" id="imagePicFromLib" (click)="showViewImages()" class="pickimageBtn">
                      View Images</span>
                    <div class="lightBox photogallerylist block" *ngIf="isLightbox && showViewImagePopup">
                      <div class="headerLight">
                        <div class="close fl spImg" (click)="cancelViewImages()"></div>
                      </div>
                     <div class="lightContent lightforView" >
                    
                      <div class="imagesView">
                      <div class="listView">
                      <ul [dragula]='"view-images-bag"' [dragulaModel]='viewImagesData'>
                       
                          <li class="imagesView_list" *ngFor="let image of viewImagesData; let i = index;">
                          <img  width="100%" height="180px" [src]="image['image']['images']['382x214']?image['image']['images']['382x214']:image['image']['images']['original']">
                          </li>
                       
                        </ul>
                      </div>
                      </div>
                      <div class="view-images-btn">
                        <button (click)="updateDragViewImages()" class="green">Update</button>
                        <button (click)="cancelViewImages()" class="blue">Cancel</button>
                      </div>
                   
                     </div>
                    </div>
                    </div>
                </div>

              </li>
            </ul>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'mediagallery'">
          <div class="formStory photogallery fl100" [ngStyle]="setStoryHeight()">

            <ul class="storyuL">
              <li #headlineEl [class]="setCheckForErrorIndication(1) ? ((storyData.mobileHeadline && (htmlToPlaintext(storyData.mobileHeadline).length > errorheadlineMaxLength)) ? ('headline errorborder errorInput fl100') : ('headline errorInput fl100')) : ((storyData.mobileHeadline && (htmlToPlaintext(storyData.mobileHeadline).length > errorheadlineMaxLength)) ? ('headline errorborder fl100') : ('headline fl100'))"
                (focus)="setFocus('headline')">
                <label id="storyButton" [style.visibility]="(setCheckForErrorIndication(1) || (headlineFocusFlag)) ? 'visible' : 'hidden'">
                  Landing page headline
                  <i class="mandate">*</i>
                  <span>{{htmlToPlaintext(storyData.mobileHeadline)?.length}}/{{headlineMaxLength}} char'</span>
                </label>
                <div class="dataField bdrfill">
                  <ng-container *ngIf="isCKEditorEnabled">
                    <div id="storyElement" (keypress)="hotkeypress($event)" (keyup)="headlineKeyUpEvent($event)" (keydown)="headlineKeyDownEventCk($event)">
                      <ckeditor [editor]="ckEditor"  id="{{id}}"
                      [data]="headline"
                      [config]="ckplainconfig"
                      [tabindex]="0"
                      (ready)="ckchanges($event, 'ready', 'headline')"
                      (change)="onChange($event,'headline')"
                      (blur)="ckchanges($event, 'blur', 'headline')"
                      (focus)="ckchanges($event, 'focus', 'headline')"
                      (error)="ckchanges($event, 'error', 'headline')"
                      ></ckeditor>
                    </div>
                </ng-container>
               
                </div>
                <div class="storyaction" *ngIf=(storyEditMode)>
                  <span id="headline1" class="plusHeadline" (click)="discareUrlChanges(true)">
                    <i class="icon-add-headline" id="headlineAddButtton"></i>
                  </span>
                  <span class="deleteHeadline" id="headline2" (click)="clearHeadline()">
                    <i class="icon-delete"></i>
                  </span>
                </div>
              </li>
              <li #summaryEl [class]="(setCheckForErrorIndication(5) || setCheckForErrorIndication(6)) ?
               ((storyData.summary && (htmlToPlaintext(storyData.summary).length > (summaryMaxLength ? summaryMaxLength : 300))) ?
                ('summary errorborder errorInput') : ('summary errorInput')) :
                 ((storyData.summary && (htmlToPlaintext(storyData.summary).length > (summaryMaxLength ? summaryMaxLength : 300))) ? ('summary errorborder') : ('summary'))">
                <label [style.visibility]="(setCheckForErrorIndication(5) || setCheckForErrorIndication(6) || (summaryFocusFlag)) ? 'visible' : 'hidden'">Summary
                  <span>{{htmlToPlaintext(storyData.summary)?.length}}/{{(summaryMaxLength ? summaryMaxLength : 300)}} char</span>
                </label>
                <div class="dataField bdrfill">
                  <ng-container *ngIf="isCKEditorEnabled">
                    <div id="storyElement" (keyup)="summaryKeyUpEvent($event)" (keydown)="summaryKeyDownEventCk($event)">
                      <ckeditor [editor]="ckEditor2"  id="{{id}}"
                      [data]="summary"
                      [config]="cksummaryconfig"
                      [tabindex]="0"
                      (ready)="ckchanges($event, 'ready', 'summary')"
                      (change)="onChange($event,'summary')"
                      (blur)="ckchanges($event, 'blur', 'summary')"
                      (focus)="ckchanges($event, 'focus', 'summary')"
                      (error)="ckchanges($event, 'error', 'summary')"
                      ></ckeditor>
                    </div>
                  </ng-container>
                
                </div>

                <div class="storyaction" *ngIf=(storyEditMode)>
                  <ng-container *ngIf="isNewsletterFieldsEnabled()">
                    <span id="headline1" class="plusHeadline" (click)="openSummaryPopup(true)">
                      <i class="icon-add-headline"></i>
                    </span>
                  </ng-container>
                  <span id="summary1" class="deleteHeadline" (click)="clearSummary()">
                    <i class="icon-delete"></i>
                  </span>
                </div>
              </li>

              <!-- element list -->
              <li class="elementListDrag" #autoscroll>
                <ul class='container' [dragula]='"sixth-bag"' [dragulaModel]='storyData.elements'>
                  <li *ngFor="let elementId of viewPortItems;let i = index">
                    <div #elReferenc class="element-module" [leadMediaId]="storyData.leadMedia.elements.length > 0 ? storyData.leadMedia.elements[0]: null"
                      [id]="elementId" [EditMode]="storyEditMode" [cardId]="elementId" [preLoadedcardData]="serveElementContent(elementId)"
                      (updateContentOnParent)="getUpadtedElementContent($event)" (cardDataFromElement)="getCardDatafromElement($event)"
                      (removeSavedCardData)="removeSaved($event)" (deleteCardfn)="deleteCardEmit($event)"
                      [showToggle]="true" (childKeyDown)="childKeyDownEventCatcher($event)" (sendWordCountToStory)="getWordCount($event)"
                      (setAsLeadMediafn)="getGalleryLeadMedia($event)" (emitParentImageId)="getImageParents($event)"
                      (emitParentImageIdDelete)="deleteImageParents($event)" (previousFocusEmit)="focusOnElement($event, 'up')"
                      (nextFocusEmit)="focusOnElement($event, 'down')" (updateCardDatafn)="receiveCardData($event)"
                      (incrementPendingRequest)="increasePendingCount()" (decrementPendingRequest)="decreasePendingCount($event)"
                      (scrollOut)="scr($event)" (ampValidationOutput)="ampValidationInput($event)" [storytype]="storyType">
                    </div>
                  </li>
                </ul>
              </li>

              <li class="leadMedia block3" *ngIf=(storyEditMode)>
                <label style="visibility:hidden">Lead Media</label>
                <div class="dataField">
                  <div class="uploadimage">
                    <div class="upload-btn-wrapper relative">
                      <i class="icon-upload"></i>
                      <span class="btn">Upload a new Image</span>
                      <input #uploadGalleryId tabindex="0" type="file" accept="image/*" name="myfile" (change)="galleryUpload($event, 'elements')"
                        multiple />
                    </div>
                  </div>
                  <span class="seperator"></span>
                  <div class="pickimage">
                    <i class="icon-image-library"></i>
                    <span #pickGalleryId tabindex="0" (click)="showGallery()" class="pickimageBtn">Pick
                      from Image Library</span>
                    <div class="lightBox photogallerylist block" *ngIf="isLightbox">
                      <div class="headerLight">
                        <div class="close fl spImg" (click)="disableshowGallery()"></div>
                      </div>
                      <div class="photo-listing" [exclusionList]="excludeImageListingIds" [photogalleryId]="true"
                        (emitIdfn)="getphotogalleryIds($event)" *ngIf="isPhotopopup"></div>
                    </div>
                  </div>
                  <span class="seperator"></span>
                  <div class="pickimage">
                    <i class="icon-video"></i>
                    <span tabindex="0" (click)=" showVideoGallery('elements')" class="pickimageBtn">Pick
                      from Video Library</span>
                  </div>
                  <span class="seperator"></span>

                  <div class="embed_icon pickimage">
                    <i class="icon-embed"></i>
                    <span class="pickimageBtn" (click)="openEmbedPopup('elements')">Insert Embed</span>

                  </div>
                </div>

              </li>
            </ul>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'video'">
          <div class="formStory VideoElement fl100" [ngStyle]="setStoryHeight()">

            <ul class="storyuL">
              <li #headlineEl [class]="setCheckForErrorIndication(1) ? ((storyData.mobileHeadline && (htmlToPlaintext(storyData.mobileHeadline).length > errorheadlineMaxLength)) ? ('headline errorborder errorInput fl100') : ('headline errorInput fl100')) : ((storyData.mobileHeadline && (htmlToPlaintext(storyData.mobileHeadline).length > errorheadlineMaxLength)) ? ('headline errorborder fl100') : ('headline fl100'))"
                (focus)="setFocus('headline')">
                <label id="storyButton" [style.visibility]="(setCheckForErrorIndication(1) || (headlineFocusFlag)) ? 'visible' : 'hidden'">
                  Landing page headline
                  <i class="mandate">*</i>
                  <span>{{htmlToPlaintext(storyData.mobileHeadline)?.length}}/{{headlineMaxLength}} char'</span>
                </label>
                <div class="dataField bdrfill">
                  <ng-container *ngIf="isCKEditorEnabled">
                    <div id="storyElement" (keypress)="hotkeypress($event)" (keyup)="headlineKeyUpEvent($event)" (keydown)="headlineKeyDownEventCk($event)">
                      <ckeditor [editor]="ckEditor"  id="{{id}}"
                      [data]="headline"
                      [config]="ckplainconfig"
                      [tabindex]="0"
                      (ready)="ckchanges($event, 'ready', 'headline')"
                      (change)="onChange($event,'headline')"
                      (blur)="ckchanges($event, 'blur', 'headline')"
                      (focus)="ckchanges($event, 'focus', 'headline')"
                      (error)="ckchanges($event, 'error', 'headline')"
                      ></ckeditor>
                    </div>
                  </ng-container>
                 
                  <span class="fieldValidation"
                  *ngIf="headlineRestrictionChecks.includes('mobileHeadline')
                  && sharedService.checkIfRestrictedCharactersArePresent(storyData.mobileHeadline, 'headline')">
                  Please remove ((") {{'{}'}} [])</span>
                </div>
                <div class="storyaction" *ngIf=(storyEditMode)>
                  <span id="headline1" class="plusHeadline" (click)="discareUrlChanges(true)">
                    <i class="icon-add-headline" id="addHeadlineIcon"></i>
                  </span>
                  <span class="deleteHeadline" id="headline2" (click)="clearHeadline()">
                    <i class="icon-delete"></i>
                  </span>
                </div>
              </li>

              <li #summaryEl [class]="(setCheckForErrorIndication(5) || setCheckForErrorIndication(6)) ?
               ((storyData.summary && (htmlToPlaintext(storyData.summary).length > (summaryMaxLength ? summaryMaxLength : 300))) ?
                ('summary errorborder errorInput') : ('summary errorInput')) :
                 ((storyData.summary && (htmlToPlaintext(storyData.summary).length > (summaryMaxLength ? summaryMaxLength : 300))) ?
                  ('summary errorborder') : ('summary'))">
                <label [style.visibility]="(setCheckForErrorIndication(5) || setCheckForErrorIndication(6) || (summaryFocusFlag)) ? 'visible' : 'hidden'">Summary
                  <span>{{htmlToPlaintext(storyData.summary)?.length}}/{{(summaryMaxLength ? summaryMaxLength : 300)}} char</span>
                </label>
                <div class="dataField bdrfill">
                  <ng-container *ngIf="isCKEditorEnabled">
                    <div id="storyElement" (keyup)="summaryKeyUpEvent($event)" (keydown)="summaryKeyDownEventCk($event)">
                      <ckeditor [editor]="ckEditor2"  id="{{id}}"
                      [data]="summary"
                      [config]="cksummaryconfig"
                      [tabindex]="0"
                      (ready)="ckchanges($event, 'ready', 'summary')"
                      (change)="onChange($event,'summary')"
                      (blur)="ckchanges($event, 'blur', 'summary')"
                      (focus)="ckchanges($event, 'focus', 'summary')"
                      (error)="ckchanges($event, 'error', 'summary')"
                      ></ckeditor>
                    </div>
                  </ng-container>
                
                  <span class="fieldValidation"
                    *ngIf="summaryRestrictionChecks.includes('summary')
                    && sharedService.checkIfRestrictedCharactersArePresent(storyData.summary, 'summary')">
                    Please remove (")</span>
                </div>

                <div class="storyaction" *ngIf=(storyEditMode)>
                  <ng-container *ngIf="isNewsletterFieldsEnabled()">
                    <span id="headline1" class="plusHeadline" (click)="openSummaryPopup(true)">
                      <i class="icon-add-headline"></i>
                    </span>
                  </ng-container>
                  <span id="summary1" class="deleteHeadline" (click)="clearSummary()">
                    <i class="icon-delete"></i>
                  </span>
                </div>
              </li>

              <li [class]="setCheckForErrorIndication(7) ? ((pickStoryImageLoad || imageUploadInProgress) ?
              'leadMedia errorInput loadwaiting' : 'leadMedia errorInput') : ((pickStoryImageLoad || imageUploadInProgress) ?
               'leadMedia loadwaiting' : 'leadMedia')"
              id="leadMedia">
                <ng-container *ngIf="(storyData.leadMedia && storyData.leadMedia.elements && (storyData.leadMedia.elements.length > 0))">
                  <div class="element-module" #leadElement [EditMode]="storyEditMode" [id]="storyData.leadMedia.elements[0]"
                  (updateContentOnParent)="getUpadtedElementContent($event)" [preLoadedcardData]="serveElementContent(storyData.leadMedia.elements[0])"
                    [cardId]="storyData.leadMedia.elements[0]"  [leadMedia]="true" (deleteCardfn)="deleteImageCardEmit($event)"
                    (childKeyDown)="childKeyDownEventCatcher($event)" [hideDragger]="true" (sendWordCountToStory)="getWordCount($event)"
                    (previousFocusEmit)="focusOnElement($event, 'lead|up')" (nextFocusEmit)="focusOnElement($event, 'lead|down')"
                    (incrementPendingRequest)="increasePendingCount()" (decrementPendingRequest)="decreasePendingCount($event)"
                    (scrollOut)="scr($event)" (storySave)="autoSaveRequest($event)" [storytype]="storyType">
                  </div>
                </ng-container>
                <ng-container *ngIf="(pickStoryImageLoad || imageUploadInProgress)">
                  <div class="imagepreloader">
                    <div class="a" style="--n: 5;">
                      <div class="dot dot1" style="--i: 0;"></div>
                      <div class="dot dot2" style="--i: 1;"></div>
                      <div class="dot dot3" style="--i: 2;"></div>
                      <div class="dot dot4" style="--i: 3;"></div>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="!(storyData.leadMedia && storyData.leadMedia.elements && (storyData.leadMedia.elements.length > 0))
                  && storyEditMode && !(pickStoryImageLoad || imageUploadInProgress)">

                  <label [style.visibility]="focusOnLeadMedia ? 'visible' : 'hidden'">Lead Media</label>
                  <div class="dataField" (focus)="focusOnLeadMedia = true" (focusout)="focusOnLeadMedia = (leadMediaImageToggle ? true : false)"
                    (mouseenter)="focusOnLeadMedia = true" (mouseleave)="focusOnLeadMedia = (leadMediaImageToggle ? true : false)"
                    tabindex="3">
                    <ul [ngClass]="{'z-high': leadMediaImageToggle}" class="leadMediaIcon">
                      <li class="spImg_story">
                        <span class="i_image" [ngClass]="{'active' : leadMediaImageToggle}" (click)="listClick($event,1)">
                          <i class="icon-image" id="iconForImageUpload"></i>
                        </span>
                        <div [class]="'imageAction' +  (leadMediaImageToggle ? ' block' : '') ">
                          <div class="blockContain">
                            <div class="uploadimage">
                              <i class="icon-upload"></i>
                              <div class="upload-btn-wrapper">
                                <span class="btn">Upload a new Image</span>
                                <input type="file" accept="image/*" name="myfile" (change)="onFileChangeSingle($event, 'leadMedia')" />
                              </div>
                            </div>
                            <div class="pickimage">
                              <i class="icon-image-library"></i>
                              <span (click)="showGallery()" class="pickimageBtn" id="imagePicFromLib">Pick from Image Library</span>
                              <div class="lightBox block" *ngIf="isLightbox">
                                <div class="headerLight">
                                  <div class="close fl spImg" (click)="disableshowGallery()"></div>
                                </div>
                                <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="getLeadMediaId($event)"
                                  *ngIf="isPhotopopup"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </ng-container>
              </li>

              <li class="leadMedia" *ngIf="storyData.elements.length > 0">
               <!-- <label style="visibility:hidden"></label> -->
                <div class="element-module" #elReferenc (sendWordCountToStory)="getWordCount($event)" [id]="storyData.elements[0]"
                  [preLoadedcardData]="serveElementContent(storyData.elements[0])"
                  (updateContentOnParent)="getUpadtedElementContent($event)" (cardDataFromElement)="getCardDatafromElement($event)"
                  (removeSavedCardData)="removeSaved($event)" [EditMode]="storyEditMode" [cardId]="storyData.elements[0]"
                  (deleteCardfn)="deleteVideoElement($event)" (previousFocusEmit)="focusOnElement($event, 'up')"
                  (nextFocusEmit)="focusOnElement($event, 'down')" (updateCardDatafn)="receiveCardData($event)"
                  (incrementPendingRequest)="increasePendingCount()" (decrementPendingRequest)="decreasePendingCount($event)"
                  (scrollOut)="scr($event)" [storytype]="storyType">
                </div>
              </li>
            </ul>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="storyType === 'listicle' || storyType === 'highlights' ? storyType : ''">
          <div class="formStory listicle storyuL" [ngStyle]="setStoryHeight()">

            <ul class="storyuL">
              <li #headlineEl [class]="setCheckForErrorIndication(1) ? ((storyData.mobileHeadline && (htmlToPlaintext(storyData.mobileHeadline).length > errorheadlineMaxLength)) ? ('headline errorborder errorInput fl100') : ('headline errorInput fl100')) : ((storyData.mobileHeadline && (htmlToPlaintext(storyData.mobileHeadline).length > errorheadlineMaxLength)) ? ('headline errorborder fl100') : ('headline fl100'))"
                (focus)="setFocus('headline')">
                <label id="storyButton" [style.visibility]="(setCheckForErrorIndication(1) || (headlineFocusFlag)) ? 'visible' : 'hidden'">
                  Landing page headline 2
                  <i class="mandate">*</i>
                  <span>{{htmlToPlaintext(storyData.mobileHeadline)?.length}}/{{headlineMaxLength}} char'</span>
                </label>
                <div class="dataField bdrfill">
                  <ng-container *ngIf="isCKEditorEnabled">
                    <div id="storyElement" (keypress)="hotkeypress($event)" (keyup)="headlineKeyUpEvent($event)" (keydown)="headlineKeyDownEventCk($event)">
                      <ckeditor [editor]="ckEditor"  id="{{id}}"
                      [data]="headline"
                      [config]="ckplainconfig"
                      [tabindex]="0"
                      (ready)="ckchanges($event, 'ready', 'headline')"
                      (change)="onChange($event,'headline')"
                      (blur)="ckchanges($event, 'blur', 'headline')"
                      (focus)="ckchanges($event, 'focus', 'headline')"
                      (error)="ckchanges($event, 'error', 'headline')"
                      ></ckeditor>
                    </div>
                  </ng-container>
                  
                  <span class="fieldValidation"
                  *ngIf="headlineRestrictionChecks.includes('mobileHeadline')
                  && sharedService.checkIfRestrictedCharactersArePresent(storyData.mobileHeadline, 'headline')">
                  Please remove ((") {{'{}'}} [])</span>
                </div>
                <div class="storyaction" *ngIf=(storyEditMode)>
                  <span id="headline1" class="plusHeadline" (click)="discareUrlChanges(true)">
                    <i class="icon-add-headline" id="buttonAddCoustomHeadline"></i>
                  </span>
                  <span class="deleteHeadline" id="headline2" (click)="clearHeadline()">
                    <i class="icon-delete"></i>
                  </span>
                </div>
              </li>

              <li #summaryEl [class]="(setCheckForErrorIndication(5) || setCheckForErrorIndication(6)) ?
               ((storyData.summary && (htmlToPlaintext(storyData.summary).length > (summaryMaxLength ? summaryMaxLength : 300))) ?
                ('summary errorborder errorInput') : ('summary errorInput')) :
                 ((storyData.summary && (htmlToPlaintext(storyData.summary).length > (summaryMaxLength ? summaryMaxLength : 300))) ? ('summary errorborder') : ('summary'))">
                <label [style.visibility]="(setCheckForErrorIndication(5) || setCheckForErrorIndication(6) || (summaryFocusFlag)) ? 'visible' : 'hidden'">Summary
                  <span>{{htmlToPlaintext(storyData.summary)?.length}}/{{(summaryMaxLength ? summaryMaxLength : 300)}} char</span>
                </label>
                <div class="dataField bdrfill">
                  <ng-container *ngIf="isCKEditorEnabled">
                    <div id="storyElement" (keyup)="summaryKeyUpEvent($event)" (keydown)="summaryKeyDownEventCk($event)">
                      <ckeditor [editor]="ckEditor2"  id="{{id}}"
                      [data]="summary"
                      [config]="cksummaryconfig"
                      [tabindex]="0"
                      (ready)="ckchanges($event, 'ready', 'summary')"
                      (change)="onChange($event,'summary')"
                      (blur)="ckchanges($event, 'blur', 'summary')"
                      (focus)="ckchanges($event, 'focus', 'summary')"
                      (error)="ckchanges($event, 'error', 'summary')"
                      ></ckeditor>
                    </div>
                  </ng-container>
                
                  <span class="fieldValidation"
                    *ngIf="summaryRestrictionChecks.includes('summary')
                    && sharedService.checkIfRestrictedCharactersArePresent(storyData.summary, 'summary')">
                    Please remove (")</span>
                </div>

                <div class="storyaction" *ngIf=(storyEditMode)>
                  <ng-container *ngIf="isNewsletterFieldsEnabled()">
                    <span id="headline1" class="plusHeadline" (click)="openSummaryPopup(true)">
                      <i class="icon-add-headline"></i>
                    </span>
                  </ng-container>
                  <span id="summary1" class="deleteHeadline" (click)="clearSummary()">
                    <i class="icon-delete"></i>
                  </span>
                </div>
              </li>

              <li [class]="setCheckForErrorIndication(7) ? ((pickStoryImageLoad || imageUploadInProgress) ?
               'leadMedia errorInput loadwaiting' : 'leadMedia errorInput') : ((pickStoryImageLoad || imageUploadInProgress) ?
                'leadMedia loadwaiting' : 'leadMedia')"
              id="leadMedia">
                <ng-container *ngIf="(storyData.leadMedia && storyData.leadMedia.elements && (storyData.leadMedia.elements.length > 0))">
                  <div class="element-module" #leadElement [leadMedia]="true" [EditMode]="storyEditMode" [id]="storyData.leadMedia.elements[0]"
                    [cardId]="storyData.leadMedia.elements[0]" (deleteCardfn)="deleteImageCardEmit($event)"
                    (updateContentOnParent)="getUpadtedElementContent($event)" [preLoadedcardData]="serveElementContent(storyData.leadMedia.elements[0])"
                    (childKeyDown)="childKeyDownEventCatcher($event)" [hideDragger]="true" (sendWordCountToStory)="getWordCount($event)"
                    (previousFocusEmit)="focusOnElement($event, 'lead|up')" (nextFocusEmit)="focusOnElement($event, 'lead|down')"
                    (incrementPendingRequest)="increasePendingCount()" (decrementPendingRequest)="decreasePendingCount($event)"
                    (scrollOut)="scr($event)" (storySave)="autoSaveRequest($event)" [storytype]="storyType">
                  </div>
                </ng-container>
                <ng-container *ngIf="(pickStoryImageLoad || imageUploadInProgress)">
                  <div class="imagepreloader">
                    <div class="a" style="--n: 5;">
                      <div class="dot dot1" style="--i: 0;"></div>
                      <div class="dot dot2" style="--i: 1;"></div>
                      <div class="dot dot3" style="--i: 2;"></div>
                      <div class="dot dot4" style="--i: 3;"></div>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="!(storyData.leadMedia && storyData.leadMedia.elements && (storyData.leadMedia.elements.length > 0))
                  && storyEditMode && !(pickStoryImageLoad || imageUploadInProgress)">
                  <label [style.visibility]="focusOnLeadMedia ? 'visible' : 'hidden'">Lead Media</label>
                  <div class="dataField" (focus)="focusOnLeadMedia = true" (focusout)="focusOnLeadMedia = (leadMediaImageToggle ? true : false)"
                    (mouseenter)="focusOnLeadMedia = true" (mouseleave)="focusOnLeadMedia = (leadMediaImageToggle ? true : false)"
                    tabindex="3">
                    <ul [ngClass]="{'z-high': leadMediaImageToggle}" class="leadMediaIcon">
                      <li class="spImg_story">
                        <span class="i_image" [ngClass]="{'active' : leadMediaImageToggle}" (click)="listClick($event,1)">
                          <i class="icon-image" id="iconForImageUpload"></i>
                        </span>
                        <div [class]="'imageAction' +  (leadMediaImageToggle ? ' block' : '') ">
                          <div class="blockContain">
                            <div class="uploadimage">
                              <i class="icon-upload"></i>
                              <div class="upload-btn-wrapper">
                                <span class="btn">Upload a new Image</span>
                                <input type="file" accept="image/*" name="myfile" (change)="onFileChangeSingle($event, 'leadMedia')" />
                              </div>
                            </div>
                            <div class="pickimage">
                              <i class="icon-image-library"></i>
                              <span (click)="showGallery()" class="pickimageBtn" id="imagePicFromLib">Pick from Image Library</span>
                              <div class="lightBox block" *ngIf="isLightbox">
                                <div class="headerLight">
                                  <div class="close fl spImg" (click)="disableshowGallery()"></div>
                                </div>
                                <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="getLeadMediaId($event)"
                                  *ngIf="isPhotopopup"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </ng-container>
              </li>

              <li #introEl [class]="'summary body'"
              (focus)="setFocus('intro')">
              <label [style.visibility]="(introFocusFlag) ? 'visible' : 'hidden'">Intro
                Paragraph
                <span>{{storyData.introBody ? htmlToPlaintext(storyData.introBody).length: '0'}}/80 char</span>
              </label>
              <div class="dataField bdrfill">
                <ng-container *ngIf="isCKEditorEnabled">
                  <div id="storyElement" (keyup)="introKeyUpEvent($event)" (keydown)="introKeyDownEventCk($event)">
                    <ckeditor [editor]="ckEditor3"  id="{{id}}"
                    [data]="storyData.introBody"
                    [config]="ckconfig"
                    [tabindex]="0"
                    (ready)="ckchanges($event, 'ready', 'intro')"
                    (change)="onChange($event,'intro')"
                    (blur)="ckchanges($event, 'blur', 'intro')"
                    (focus)="ckchanges($event, 'focus', 'intro')"
                    (error)="ckchanges($event, 'error', 'intro')"
                    ></ckeditor>
                  </div>
                </ng-container>
                
              </div>

              <div class="storyaction" *ngIf=(storyEditMode)>
                <span id="summary1" class="deleteHeadline" (click)="storyData.introBody = ''">
                  <i class="icon-delete"></i>
                </span>
              </div>
            </li>
            </ul>
            <!-- listicle item -->

            <div class="border_bddd"></div>
            <div #autoscroll>
              <div [dragula]='"sixth-bag"' [dragulaModel]='storyData.elements'>
                <div *ngFor="let listItemId of viewPortItems; let i = index">
                  <div #elReferenc class="element-module" [id]="listItemId" [preLoadedcardData]="serveElementContent(listItemId)"
                    (updateContentOnParent)="getUpadtedElementContent($event)" (cardDataFromElement)="getCardDatafromElement($event)"
                    (removeSavedCardData)="removeSaved($event)" [cardId]="listItemId" [index]="(i + 1)"
                    [EditMode]="storyEditMode" [editCardFlag]="storyEditMode" [editCardId]="currentcardId"
                    (deleteCardfn)="deleteCardEmit($event)" (childKeyDown)="childKeyDownEventCatcher($event)"
                    (currentcardfn)="currentCardId($event)" [currentFocusedElementId]="focusedCard"
                    (afterInitializeEmit)="removeTempCardView($event)" (sendWordCountToStory)="getWordCount($event)"
                    (previousFocusEmit)="focusOnElement($event, 'up')" (nextFocusEmit)="focusOnElement($event, 'down')"
                    (updateCardDatafn)="receiveCardData($event)" (incrementPendingRequest)="increasePendingCount()"
                    (decrementPendingRequest)="decreasePendingCount($event)"
                    (scrollOut)="scr($event)" [storytype]="storyType">
                  </div>
                  <div class="border_bddd"></div>
                </div>
              </div>
            </div>
            <!-- temp elements -->
            <ng-container *ngIf="tempCardArray.ids.length > 0">
              <ul class='containerlisticle'>
                <li *ngFor="let element of tempCardArray.objs">
                  <div #elReferenceTemp class="temp-view-card" [cardType]="storyType" [cardData]="element">
                  </div>
                  <div class="border_bddd"></div>
                </li>
              </ul>
            </ng-container>
            <!-- new element -->
            <ng-container *ngIf="storyEditMode">
              <div #newListElement class="element-module" [id]="'newListElement'" [cardId]="null" [cardType]="storyType"
                [index]="storyData.elements.length + 1" [editCardId]="currentcardId" [EditMode]="storyEditMode"
                (updateContentOnParent)="getUpadtedElementContent($event)"
                [editCardFlag]="storyEditMode" (saveCardfn)="saveCardEmit($event)"
                (childKeyDown)="childKeyDownEventCatcher($event)" (currentcardfn)="currentCardId($event)"
                (tempSaveCard)="saveCardTemporarily($event)" (sendWordCountToStory)="getWordCount($event)"
                [currentFocusedElementId]="focusedCard" (previousFocusEmit)="focusOnElement($event, 'up')"
                (nextFocusEmit)="focusOnElement($event, 'down')" (incrementPendingRequest)="increasePendingCount()"
                (decrementPendingRequest)="decreasePendingCount($event)"
                (scrollOut)="scr($event)" [storytype]="storyType">
              </div>
              <div class="border_bddd"></div>

              <!-- add new list item button -->
              <div class="addnewlist" #addListicleButton tabindex="0" (click)="addListicleElement()">
                <i class="icon-add-headline"></i> <span *ngIf="storyType === 'listicle'">Save List Item</span>
                <span id="buttonSaveHighlightsItem" *ngIf="storyType === 'highlights'">Save Highlights item</span>
              </div>
            </ng-container>

          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'liveblog'">
          <div class="formStory listicle storyuL" [ngStyle]="setStoryHeight()">

            <ul class="storyuL">
              <li #headlineEl [class]="setCheckForErrorIndication(1) ? ((storyData.mobileHeadline && (htmlToPlaintext(storyData.mobileHeadline).length > errorheadlineMaxLength)) ? ('headline errorborder errorInput fl100') : ('headline errorInput fl100')) : ((storyData.mobileHeadline && (htmlToPlaintext(storyData.mobileHeadline).length > errorheadlineMaxLength)) ? ('headline errorborder fl100') : ('headline fl100'))"
                (focus)="setFocus('headline')">
                <label id="storyButton" [style.visibility]="(setCheckForErrorIndication(1) || (headlineFocusFlag)) ? 'visible' : 'hidden'">
                  Landing page headline
                  <i class="mandate">*</i>
                  <span>{{htmlToPlaintext(storyData.mobileHeadline)?.length}}/{{headlineMaxLength}} char'</span>
                </label>
                <div class="dataField bdrfill">
                  <ng-container *ngIf="isCKEditorEnabled">
                    <div id="storyElement" (keypress)="hotkeypress($event)" (keyup)="headlineKeyUpEvent($event)" (keydown)="headlineKeyDownEventCk($event)">
                      <ckeditor [editor]="ckEditor"  id="{{id}}"
                      [data]="headline"
                      [config]="ckplainconfig"
                      [tabindex]="0"
                      (ready)="ckchanges($event, 'ready', 'headline')"
                      (change)="onChange($event,'headline')"
                      (blur)="ckchanges($event, 'blur', 'headline')"
                      (focus)="ckchanges($event, 'focus', 'headline')"
                      (error)="ckchanges($event, 'error', 'headline')"
                      ></ckeditor>
                    </div>
                  </ng-container>
                 
                  <span class="fieldValidation"
                  *ngIf="headlineRestrictionChecks.includes('mobileHeadline')
                  && sharedService.checkIfRestrictedCharactersArePresent(storyData.mobileHeadline, 'headline')">
                  Please remove ((") {{'{}'}} [])</span>
                </div>
                <div class="storyaction" *ngIf=(storyEditMode)>
                  <span id="headline1" class="plusHeadline" (click)="discareUrlChanges(true)">
                    <i class="icon-add-headline" id="headlineAddButtton"></i>
                  </span>
                  <span class="deleteHeadline" id="headline2" (click)="clearHeadline()">
                    <i class="icon-delete"></i>
                  </span>
                </div>
              </li>

              <li #summaryEl [class]="(setCheckForErrorIndication(5) || setCheckForErrorIndication(6)) ?
               ((storyData.summary && (htmlToPlaintext(storyData.summary).length > (summaryMaxLength ? summaryMaxLength : 300))) ?
                ('summary errorborder errorInput') : ('summary errorInput')) :
                 ((storyData.summary && (htmlToPlaintext(storyData.summary).length > (summaryMaxLength ? summaryMaxLength : 300))) ? ('summary errorborder') : ('summary'))">
                <label [style.visibility]="(setCheckForErrorIndication(5) || setCheckForErrorIndication(6) || (summaryFocusFlag)) ? 'visible' : 'hidden'">Summary
                  <span>{{htmlToPlaintext(storyData.summary)?.length}}/{{(summaryMaxLength ? summaryMaxLength : 300)}} char</span>
                </label>
                <div class="dataField bdrfill">
                  <ng-container *ngIf="isCKEditorEnabled">
                    <div id="storyElement" (keyup)="summaryKeyUpEvent($event)" (keydown)="summaryKeyDownEventCk($event)">
                      <ckeditor [editor]="ckEditor2"  id="{{id}}"
                      [data]="summary"
                      [config]="cksummaryconfig"
                      [tabindex]="0"
                      (ready)="ckchanges($event, 'ready', 'summary')"
                      (change)="onChange($event,'summary')"
                      (blur)="ckchanges($event, 'blur', 'summary')"
                      (focus)="ckchanges($event, 'focus', 'summary')"
                      (error)="ckchanges($event, 'error', 'summary')"
                      ></ckeditor>
                    </div>
                  </ng-container>
                  
                  <span class="fieldValidation"
                    *ngIf="summaryRestrictionChecks.includes('summary')
                    && sharedService.checkIfRestrictedCharactersArePresent(storyData.summary, 'summary')">
                    Please remove (")</span>
                </div>

                <div class="storyaction" *ngIf=(storyEditMode)>
                  <ng-container *ngIf="isNewsletterFieldsEnabled()">
                    <span id="headline1" class="plusHeadline" (click)="openSummaryPopup(true)">
                      <i class="icon-add-headline"></i>
                    </span>
                  </ng-container>
                  <span id="summary1" class="deleteHeadline" (click)="clearSummary()">
                    <i class="icon-delete"></i>
                  </span>
                </div>
              </li>

              <li [class]="setCheckForErrorIndication(7) ? ((pickStoryImageLoad || imageUploadInProgress) ?
               'leadMedia errorInput loadwaiting' : 'leadMedia errorInput') : ((pickStoryImageLoad || imageUploadInProgress) ?
                'leadMedia loadwaiting' : 'leadMedia')"
              id="leadMedia">
                <ng-container *ngIf="(storyData.leadMedia && storyData.leadMedia.elements && (storyData.leadMedia.elements.length > 0))">
                  <div class="element-module" #leadElement [leadMedia]="true" [EditMode]="storyEditMode" [id]="storyData.leadMedia.elements[0]"
                    (updateContentOnParent)="getUpadtedElementContent($event)" [preLoadedcardData]="serveElementContent(storyData.leadMedia.elements[0])"
                    [cardId]="storyData.leadMedia.elements[0]" (deleteCardfn)="deleteImageCardEmit($event)"
                    (childKeyDown)="childKeyDownEventCatcher($event)" [hideDragger]="true" (sendWordCountToStory)="getWordCount($event)"
                    (previousFocusEmit)="focusOnElement($event, 'lead|up')" (nextFocusEmit)="focusOnElement($event, 'lead|down')"
                    (incrementPendingRequest)="increasePendingCount()" (decrementPendingRequest)="decreasePendingCount($event)"
                    (scrollOut)="scr($event)" (storySave)="autoSaveRequest($event)" [storytype]="storyType">
                  </div>
                </ng-container>
                <ng-container *ngIf="(pickStoryImageLoad || imageUploadInProgress)">
                  <div class="imagepreloader">
                    <div class="a" style="--n: 5;">
                      <div class="dot dot1" style="--i: 0;"></div>
                      <div class="dot dot2" style="--i: 1;"></div>
                      <div class="dot dot3" style="--i: 2;"></div>
                      <div class="dot dot4" style="--i: 3;"></div>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="!(storyData.leadMedia && storyData.leadMedia.elements && (storyData.leadMedia.elements.length > 0))
                  && storyEditMode && !(pickStoryImageLoad || imageUploadInProgress)">
                  <label [style.visibility]="focusOnLeadMedia ? 'visible' : 'hidden'">Lead Media</label>
                  <div class="dataField" (focus)="focusOnLeadMedia = true" (focusout)="focusOnLeadMedia = (leadMediaImageToggle ? true : false)"
                    (mouseenter)="focusOnLeadMedia = true" (mouseleave)="focusOnLeadMedia = (leadMediaImageToggle ? true : false)"
                    tabindex="3">
                    <ul [ngClass]="{'z-high': leadMediaImageToggle}" class="leadMediaIcon">
                      <li class="spImg_story">
                        <span class="i_image" [ngClass]="{'active' : leadMediaImageToggle}" (click)="listClick($event,1)">
                          <i class="icon-image"></i>
                        </span>
                        <div [class]="'imageAction' +  (leadMediaImageToggle ? ' block' : '') ">
                          <div class="blockContain">
                            <div class="uploadimage">
                              <i class="icon-upload"></i>
                              <div class="upload-btn-wrapper">
                                <span class="btn">Upload a new Image</span>
                                <input type="file" accept="image/*" name="myfile" (change)="onFileChangeSingle($event, 'leadMedia')" />
                              </div>
                            </div>
                            <div class="pickimage">
                              <i class="icon-image-library"></i>
                              <span (click)="showGallery()" class="pickimageBtn">Pick from Image Library</span>
                              <div class="lightBox block" *ngIf="isLightbox">
                                <div class="headerLight">
                                  <div class="close fl spImg" (click)="disableshowGallery()"></div>
                                </div>
                                <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="getLeadMediaId($event)"
                                  *ngIf="isPhotopopup"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="spImg_story" *ngIf="getLeadVideoFlag('liveblog')">
                        <span class="i_video" [ngClass]="{'active' : leadMediaVideoToggle}" (click)="showVideoGallery('leadMedia')">
                          <i class="icon-video"></i>
                        </span>
                      </li>
                    </ul>
                  </div>
                </ng-container>
              </li>
              <li #introEl [class]="(setCheckForErrorIndication(10) ? 'summary errorInput body' : 'summary body')"
                (focus)="setFocus('intro')">
                <div class="border_bddd mar_bot20"></div>
                <label [style.visibility]="(setCheckForErrorIndication(10) || (introFocusFlag)) ? 'visible' : 'hidden'">Intro
                  Paragraph
                  <span>{{storyData.introBody ? htmlToPlaintext(storyData.introBody).length: '0'}}/80 char</span>
                </label>
                <div class="dataField bdrfill techAlign paragraph">
                  <ng-container *ngIf="isCKEditorEnabled">
                    <div id="storyElement" (keyup)="introKeyUpEvent($event)" (keydown)="introKeyDownEventCk($event)">
                      <ckeditor [editor]="ckEditor3"  id="{{id}}"
                      [data]="storyData.introBody"
                      [config]="getConfigLiveBlogIntroPara()"
                      [tabindex]="0"
                      (ready)="ckchanges($event, 'ready', 'intro')"
                      (change)="onChange($event,'intro')"
                      (blur)="ckchanges($event, 'blur', 'intro')"
                      (focus)="ckchanges($event, 'focus', 'intro')"
                      (error)="ckchanges($event, 'error', 'intro')"
                      ></ckeditor>
                    </div>
                  </ng-container>
                 
                </div>

                <div class="storyaction" *ngIf=(storyEditMode)>
                  <span id="summary1" class="deleteHeadline" (click)="storyData.introBody = ''">
                    <i class="icon-delete"></i>
                  </span>
                </div>
              </li>
              <!-- Liveblog Intro Embeds Elemenr-->
              <ng-container class="liveblog-intro-embed-block" *ngIf="liveblogIntroEmbed">
              <div class="border_bddd mar_bot20"></div>
              <div *ngFor="let listItemId of viewPoerItemLiveblogEmbed; let i = index">
                <!-- <div *ngFor="let listItemId of storyData.elements; let i = index"> -->

                <div #elReferenc class="element-module" [id]="listItemId" [cardId]="listItemId" [preLoadedcardData]="serveElementContent(listItemId)"
                  (updateContentOnParent)="getUpadtedElementContent($event)"
                  (removeSavedCardData)="removeSaved($event)" (cardDataFromElement)="getCardDatafromElement($event)" [EditMode]="storyEditMode"
                  [editCardFlag]="storyEditMode" [editCardId]="currentcardId" (deleteCardfn)="deleteCardEmitEmbedLiveblog($event)"
                 (pinCardfn)="pinCardEmit($event)" [activePin]="false"
                  (childKeyDown)="childKeyDownEventCatcher($event)" (currentcardfn)="currentCardId($event)"
                  (afterInitializeEmit)="removeTempCardView($event)" (sendWordCountToStory)="getWordCount($event)"
                  [currentFocusedElementId]="focusedCard" (currentcardfn)="currentCardId($event)" (previousFocusEmit)="focusOnElement($event, 'up')"
                  (nextFocusEmit)="focusOnElement($event, 'down')" (updateCardDatafn)="receiveCardData($event)"
                  (incrementPendingRequest)="increasePendingCount()" (decrementPendingRequest)="decreasePendingCount($event)"
                  (scrollOut)="scr($event)" (embedChangeOutput)="checkForSourceUrlInEmbed($event)" (liveblogDelete)="deleteLiveBlogImg($event)" [storytype]="storyType">
                </div>
              </div>
              <div class="liveblogEmbedblock">
                <label>Intro Embed</label>
                <ul>

                  <li class="table_icon scorecard_icon" *ngIf="enableLiveBlogIntroElements.indexOf('cricket') > -1"
                  (click)="openMatchPopupLiveblogEmbed(true)">
                   <i class="icon-scorecard"></i>
                   <span class="tooltip">Insert Scorecard</span>
                 </li>

                 <li  class="table_icon spImg_story" *ngIf="enableLiveBlogIntroElements.indexOf('table') > -1"
                 (click)="createNewTableLiveblogEmbed('elements',true)">
                    <i class="icon-table"></i>
                    <span class="tooltip">Insert Table</span>
                 </li>

                 <li class="table_icon embed_icon"  *ngIf="enableLiveBlogIntroElements.indexOf('Embed') > -1"
                 (click)="openEmbedPopupLiveblog('elements',true)">
                  <i class="icon-embed" id="buttonInsertEmbed"></i>
                  <span class="tooltip">Insert Embed</span>
                </li>

               <li class="table_icon video_icon" *ngIf="enableLiveBlogIntroElements.indexOf('video') > -1"
               (click)="showVideoGalleryLiveblogEmbed('elements',true)">
               <i class="icon-video" id="buttonInsertVideo"></i>
               <span class="tooltip">Insert Video</span>
              </li>

              <li class="table_icon image_icon relative" *ngIf="enableLiveBlogIntroElements.indexOf('image') > -1"
              (click)="openInlineImageOptionLiveblogEmbed('image',true)">
                <i class="icon-image" id="buttonInsertImage"></i><span class="tooltip">Insert Image</span>
                <div [class]="'imageAction' +  (inlineImageToggle ? ' block' : '') ">
                  <div class="blockContain">
                    <div class="uploadimage">
                      <i class="icon-upload"></i>
                      <div class="upload-btn-wrapper">
                        <span class="btn">Upload new File</span>
                        <input type="file" name="myfile" accept="image/*" (change)="onFileChangeLiveblogEmbed($event, 'elements',true)" />
                      </div>
                    </div>
                    <div class="pickimage">
                      <i class="icon-image-library"></i>
                      <span (click)="addInlineImageLiveblogEmbed(true)" class="pickimageBtn">Pick from Image Library</span>
                    </div>
                  </div>
                </div>
              </li>

              <li class="table_icon step_icon spImg_podcast" *ngIf="enableLiveBlogIntroElements.indexOf('podcast') > -1"
                (click)="openPodcastPopupLiveblogEmbed(true)">
                 <span class="tooltip">Insert Podcast</span>
               </li>
              
                </ul>
              </div>
            </ng-container>
  <!--
              <li class="leadMedia" id="leadMedia" *ngIf="(isPinnedElementEnabled() > 0)">
                <ng-container *ngIf="(storyData.pinnedArticles && (storyData.pinnedArticles.length > 0))">
                  <ng-container *ngFor="let pinItem of storyData.pinnedArticles">
                   <div class="element-module" #pinnedElement [EditMode]="storyEditMode" [id]="pinItem"
                      [cardId]="pinItem" (deleteCardfn)="deletePinnedElement($event)"
                      (updateContentOnParent)="getUpadtedElementContent($event)"
                      (childKeyDown)="childKeyDownEventCatcher($event)" [hideDragger]="true" (sendWordCountToStory)="getWordCount($event)"
                      (previousFocusEmit)="focusOnElement($event, 'pinned|up')" (nextFocusEmit)="focusOnElement($event, 'pinned|down')"
                      (incrementPendingRequest)="increasePendingCount()" (decrementPendingRequest)="decreasePendingCount($event)"
                      (scrollOut)="scr($event)" (storySave)="autoSaveRequest($event)"[storytype]="storyType">
                    </div>



                  </ng-container>
                </ng-container>
                 <ng-container *ngIf="storyEditMode && (storyData.pinnedArticles && (storyData.pinnedArticles.length < isPinnedElementEnabled()))">
                  <label [style.visibility]="focusOnPinnedMedia ? 'visible' : 'hidden'">Pinned Media</label>
                  <div class="dataField selectPinned" (focus)="focusOnPinnedMedia = true" (focusout)="focusOnPinnedMedia = (pinnedMediaImageToggle ? true : false)"
                    (mouseenter)="focusOnPinnedMedia = true" (mouseleave)="focusOnPinnedMedia = (pinnedMediaImageToggle ? true : false)"
                    tabindex="3">
                    <ul [ngClass]="{'z-high': pinnedMediaImageToggle}" class="leadMediaIcon">
                      <li class="spImg_story">
                        <span class="i_image" [ngClass]="{'active' : pinnedMediaImageToggle}" (click)="pinnedListClick($event,1)">
                          <i class="icon-image"></i>
                        </span>
                        <div [class]="'imageAction' +  (pinnedMediaImageToggle ? ' block' : '') ">
                          <div class="blockContain">
                            <div class="uploadimage">
                              <i class="icon-upload"></i>
                              <div class="upload-btn-wrapper">
                                <span class="btn">Upload a new Image</span>
                                <input type="file" accept="image/*" name="pinnedfile" (change)="onFileChangeSingle($event, 'pinnedMedia')" />
                              </div>
                            </div>
                            <div class="pickimage">
                              <i class="icon-image-library"></i>
                              <span (click)="showPinnedGallery()" class="pickimageBtn">Pick from Image Library</span>
                              <div class="lightBox block" *ngIf="isPinnedLigthbox">
                                <div class="headerLight">
                                  <div class="close fl spImg" (click)="hidePinnedGallery()"></div>
                                </div>
                                <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="getPinnedMediaId($event)"
                                  *ngIf="isPinnedPhotopopup"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="embed_icon spImg_story" (click)="openEmbedPopup('pinnedMedia')">
                        <i class="icon-embed"></i>
                        <span class="tooltip">Insert Embed</span>
                      </li>
                      <li *ngIf="domainConfig.elementsDisabled.indexOf('table') === -1" class="table_icon spImg_story" (click)="createNewTable('pinnedMedia')">
                        <span class="tooltip">Insert table</span>
                        <i class="icon-table"></i>
                    </li>
                    </ul>
                  </div>
                </ng-container>
              </li>-->

            </ul>

            <div class="border_bddd"></div>
            <!-- new element -->
            <ng-container *ngIf="storyEditMode">
              <div #newLiveblogElement class="element-module" [id]="'newLiveblogElement'" [cardId]="null" [cardType]="'liveblog'"
                [editCardId]="currentcardId" [EditMode]="storyEditMode" [editCardFlag]="storyEditMode" (saveCardfn)="saveCardEmit($event)"
                (childKeyDown)="childKeyDownEventCatcher($event)" (currentcardfn)="currentCardId($event)"
                (tempSaveCard)="saveCardTemporarily($event)" (sendWordCountToStory)="getWordCount($event)"
                [currentFocusedElementId]="focusedCard" (previousFocusEmit)="focusOnElement($event, 'up')"
                (nextFocusEmit)="focusOnElement($event, 'down')" (incrementPendingRequest)="increasePendingCount()"
                (updateContentOnParent)="getUpadtedElementContent($event)" (decrementPendingRequest)="decreasePendingCount($event)"
                (scrollOut)="scr($event)" [storytype]="storyType">
              </div>
              <ul class="storyuL">
                <li>
                  <label class="noBorder" [style.visibility]="'hidden'">&nbsp;</label>
                  <div class="dataField">
                    <button #addLiveblogButton tabindex="0" type="button" name="createCard" style="margin-bottom:35px;"
                      class="editedCard irisblue" (click)="addLiveblogElement()">Publish
                      this Post</button>

                    <button #addLiveblogPostButton tabindex="0" type="button" name="createCard" style="margin-bottom:35px;"
                    class="yellow" (click)="addLiveblogPost()">Add Post</button>
                  </div>
                </li>
              </ul>
            </ng-container>


            <!-- add new list item button -->
            <!-- temp elements -->
            <ng-container *ngIf="tempCardArray.ids.length > 0">
              <ul class='containerliveblog'>

                <li *ngFor="let element of tempCardArray.objs">
                  <div class="border_bddd"></div>
                  <div #elReferenceTemp class="temp-view-card" [cardType]="'liveblog'" [cardData]="element">
                  </div>

                </li>
              </ul>
            </ng-container>



            <div #autoscroll>
              <div>
                <div class='container' [dragula]="'sixth-bag'" [dragulaModel]='storyData.pinnedArticles'>
                <ng-container *ngIf="(sharedService.isPinnedElementEnabled() > 0)"><!--rohit-->
                  <ng-container *ngIf="(storyData.pinnedArticles && (storyData.pinnedArticles.length > 0))">
                    <ng-container *ngFor="let pinItem of storyData.pinnedArticles">
                      <div #elReferenc class="element-module"  [id]="pinItem" [cardId]="pinItem" [preLoadedcardData]="serveElementContent(pinItem)"
                      (updateContentOnParent)="getUpadtedElementContent($event)"
                      (removeSavedCardData)="removeSaved($event)" (cardDataFromElement)="getCardDatafromElement($event)" [EditMode]="storyEditMode"
                      [editCardFlag]="storyEditMode" [editCardId]="currentcardId" (deletePinCardfn)="deletePinCardEmit($event)"
                     [activePin]="true"  (unPinCardfn)="unPinCardEmit($event)"
                      (childKeyDown)="childKeyDownEventCatcher($event)" (currentcardfn)="currentCardId($event)"
                      (afterInitializeEmit)="removeTempCardView($event)" (sendWordCountToStory)="getWordCount($event)"
                      [currentFocusedElementId]="focusedCard" (currentcardfn)="currentCardId($event)" (previousFocusEmit)="focusOnElement($event, 'up')"
                      (nextFocusEmit)="focusOnElement($event, 'down')" (updateCardDatafn)="receiveCardData($event)"
                      (incrementPendingRequest)="increasePendingCount()" (decrementPendingRequest)="decreasePendingCount($event)"
                      (scrollOut)="scr($event)" (embedChangeOutput)="checkForSourceUrlInEmbed($event)" [storytype]="storyType">
                    </div>
                    </ng-container>
                  </ng-container>
                  </ng-container>
                </div>


                <ng-container >
                  <div *ngFor="let listItemId of viewPortItems; let i = index">
                    <!-- <div *ngFor="let listItemId of storyData.elements; let i = index"> -->
                      <ng-container *ngIf="i<copyliveBlogShowMaxEle">
                        <div #elReferenc class="element-module" [id]="listItemId" [cardId]="listItemId" [preLoadedcardData]="serveElementContent(listItemId)"
                        (updateContentOnParent)="getUpadtedElementContent($event)"
                        (removeSavedCardData)="removeSaved($event)" (cardDataFromElement)="getCardDatafromElement($event)" [EditMode]="storyEditMode"
                        [editCardFlag]="storyEditMode" [editCardId]="currentcardId" (deleteCardfn)="deleteCardEmit($event)"
                       (pinCardfn)="pinCardEmit($event)" [activePin]="false"
                        (childKeyDown)="childKeyDownEventCatcher($event)" (currentcardfn)="currentCardId($event)"
                        (afterInitializeEmit)="removeTempCardView($event)" (sendWordCountToStory)="getWordCount($event)"
                        [currentFocusedElementId]="focusedCard" (currentcardfn)="currentCardId($event)" (previousFocusEmit)="focusOnElement($event, 'up')"
                        (nextFocusEmit)="focusOnElement($event, 'down')" (updateCardDatafn)="receiveCardData($event)"
                        (incrementPendingRequest)="increasePendingCount()" (decrementPendingRequest)="decreasePendingCount($event)"
                        (scrollOut)="scr($event)" (embedChangeOutput)="checkForSourceUrlInEmbed($event)" (liveblogDelete)="deleteLiveBlogImg($event)" [storytype]="storyType">
                      </div>
                      </ng-container>
                  </div>
                </ng-container>
                <div *ngIf="copyliveBlogShowMaxEle<viewPortItems.length" id="load-more">
                  <button class="created" [ngClass]="'blue'" (click)="loadMore()">Load More</button>
                </div>
              </div>
            </div>

          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'mintlite'">
          <div class="formStory listicle storyuL" [ngStyle]="setStoryHeight()">

            <ul class="storyuL">
              <li #headlineEl [class]="setCheckForErrorIndication(1) ? ((storyData.mobileHeadline && (htmlToPlaintext(storyData.mobileHeadline).length > errorheadlineMaxLength)) ? ('headline errorborder errorInput fl100') : ('headline errorInput fl100')) : ((storyData.mobileHeadline && (htmlToPlaintext(storyData.mobileHeadline).length > errorheadlineMaxLength)) ? ('headline errorborder fl100') : ('headline fl100'))"
                (focus)="setFocus('headline')">
                <label id="storyButton" [style.visibility]="(setCheckForErrorIndication(1) || (headlineFocusFlag)) ? 'visible' : 'hidden'">
                  Landing page headline
                  <i class="mandate">*</i>
                  <span>{{htmlToPlaintext(storyData.mobileHeadline)?.length}}/{{headlineMaxLength}} char'</span>
                </label>
                <div class="dataField bdrfill">
                  <ng-container *ngIf="isCKEditorEnabled">
                    <div id="storyElement" (keypress)="hotkeypress($event)" (keyup)="headlineKeyUpEvent($event)" (keydown)="headlineKeyDownEventCk($event)">
                      <ckeditor [editor]="ckEditor"  id="{{id}}"
                      [data]="headline"
                      [config]="ckplainconfig"
                      [tabindex]="0"
                      (ready)="ckchanges($event, 'ready', 'headline')"
                      (change)="onChange($event,'headline')"
                      (blur)="ckchanges($event, 'blur', 'headline')"
                      (focus)="ckchanges($event, 'focus', 'headline')"
                      (error)="ckchanges($event, 'error', 'headline')"
                      ></ckeditor>
                    </div>
                  </ng-container>
                 
                </div>
                <div class="storyaction" *ngIf=(storyEditMode)>
                  <span id="headline1" class="plusHeadline" (click)="discareUrlChanges(true)">
                    <i class="icon-add-headline" id="headlineAddButtton"></i>
                  </span>
                  <span class="deleteHeadline" id="headline2" (click)="clearHeadline()">
                    <i class="icon-delete"></i>
                  </span>
                </div>
              </li>

              <li #summaryEl [class]="(setCheckForErrorIndication(5) || setCheckForErrorIndication(6)) ?
               ((storyData.summary && (htmlToPlaintext(storyData.summary).length > (summaryMaxLength ? summaryMaxLength : 300))) ?
                ('summary errorborder errorInput') : ('summary errorInput')) :
                 ((storyData.summary && (htmlToPlaintext(storyData.summary).length > (summaryMaxLength ? summaryMaxLength : 300))) ? ('summary errorborder') : ('summary'))">
                <label [style.visibility]="(setCheckForErrorIndication(5) || setCheckForErrorIndication(6) || (summaryFocusFlag)) ? 'visible' : 'hidden'">Summary
                  <span>{{htmlToPlaintext(storyData.summary)?.length}}/{{(summaryMaxLength ? summaryMaxLength : 300)}} char</span>
                </label>
                <div class="dataField bdrfill">
                  <ng-container *ngIf="isCKEditorEnabled">
                    <div id="storyElement" (keyup)="summaryKeyUpEvent($event)" (keydown)="summaryKeyDownEventCk($event)">
                      <ckeditor [editor]="ckEditor2"  id="{{id}}"
                      [data]="summary"
                      [config]="cksummaryconfig"
                      [tabindex]="0"
                      (ready)="ckchanges($event, 'ready', 'summary')"
                      (change)="onChange($event,'summary')"
                      (blur)="ckchanges($event, 'blur', 'summary')"
                      (focus)="ckchanges($event, 'focus', 'summary')"
                      (error)="ckchanges($event, 'error', 'summary')"
                      ></ckeditor>
                    </div>
                  </ng-container>
                 
                </div>

                <div class="storyaction" *ngIf=(storyEditMode)>
                  <ng-container *ngIf="isNewsletterFieldsEnabled()">
                    <span id="headline1" class="plusHeadline" (click)="openSummaryPopup(true)">
                      <i class="icon-add-headline"></i>
                    </span>
                  </ng-container>
                  <span id="summary1" class="deleteHeadline" (click)="clearSummary()">
                    <i class="icon-delete"></i>
                  </span>
                </div>
              </li>

              <li [class]="setCheckForErrorIndication(7) ? ((pickStoryImageLoad || imageUploadInProgress) ?
               'leadMedia errorInput loadwaiting' : 'leadMedia errorInput') : ((pickStoryImageLoad || imageUploadInProgress) ?
                'leadMedia loadwaiting' : 'leadMedia')"
              id="leadMedia">
                <ng-container *ngIf="(storyData.leadMedia && storyData.leadMedia.elements && (storyData.leadMedia.elements.length > 0))">
                  <div class="element-module" #leadElement [leadMedia]="true" [EditMode]="storyEditMode" [id]="storyData.leadMedia.elements[0]"
                    [cardId]="storyData.leadMedia.elements[0]" (deleteCardfn)="deleteImageCardEmit($event)"
                    (childKeyDown)="childKeyDownEventCatcher($event)" [hideDragger]="true" (sendWordCountToStory)="getWordCount($event)"
                    (previousFocusEmit)="focusOnElement($event, 'lead|up')" (nextFocusEmit)="focusOnElement($event, 'lead|down')"
                    (incrementPendingRequest)="increasePendingCount()" (decrementPendingRequest)="decreasePendingCount($event)"
                    (scrollOut)="scr($event)" (storySave)="autoSaveRequest($event)">
                  </div>
                </ng-container>
                <ng-container *ngIf="(pickStoryImageLoad || imageUploadInProgress)">
                  <div class="imagepreloader">
                    <div class="a" style="--n: 5;">
                      <div class="dot dot1" style="--i: 0;"></div>
                      <div class="dot dot2" style="--i: 1;"></div>
                      <div class="dot dot3" style="--i: 2;"></div>
                      <div class="dot dot4" style="--i: 3;"></div>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="!(storyData.leadMedia && storyData.leadMedia.elements && (storyData.leadMedia.elements.length > 0))
                  && storyEditMode && !(pickStoryImageLoad || imageUploadInProgress)">
                  <label [style.visibility]="focusOnLeadMedia ? 'visible' : 'hidden'">Lead Media</label>
                  <div class="dataField" (focus)="focusOnLeadMedia = true" (focusout)="focusOnLeadMedia = (leadMediaImageToggle ? true : false)"
                    (mouseenter)="focusOnLeadMedia = true" (mouseleave)="focusOnLeadMedia = (leadMediaImageToggle ? true : false)"
                    tabindex="3">
                    <ul [ngClass]="{'z-high': leadMediaImageToggle}" class="leadMediaIcon">
                      <li class="spImg_story">
                        <span class="i_image" [ngClass]="{'active' : leadMediaImageToggle}" (click)="listClick($event,1)">
                          <i class="icon-image"></i>
                        </span>
                        <div [class]="'imageAction' +  (leadMediaImageToggle ? ' block' : '') ">
                          <div class="blockContain">
                            <div class="uploadimage">
                              <i class="icon-upload"></i>
                              <div class="upload-btn-wrapper">
                                <span class="btn">Upload a new Image</span>
                                <input type="file" accept="image/*" name="myfile" (change)="onFileChangeSingle($event, 'leadMedia')" />
                              </div>
                            </div>
                            <div class="pickimage">
                              <i class="icon-image-library"></i>
                              <span (click)="showGallery()" class="pickimageBtn">Pick from Image Library</span>
                              <div class="lightBox block" *ngIf="isLightbox">
                                <div class="headerLight">
                                  <div class="close fl spImg" (click)="disableshowGallery()"></div>
                                </div>
                                <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="getLeadMediaId($event)"
                                  *ngIf="isPhotopopup"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </ng-container>
              </li>
              <li #introEl [class]="( setCheckForErrorIndication(10)) ?
              ((storyData.introBody && (htmlToPlaintext(storyData.introBody).length > 80)) ?
               ('summary errorborder errorInput') : ('summary errorInput')) :
                ((storyData.introBody && (htmlToPlaintext(storyData.introBody).length >  80)) ? ('summary errorborder') : ('summary'))"
                (focus)="setFocus('intro')">
                <div class="border_bddd mar_bot20"></div>
                <label [style.visibility]="(setCheckForErrorIndication(10) || (introFocusFlag)) ? 'visible' : 'hidden'">Intro
                  Paragraph
                  <span>{{storyData.introBody ? htmlToPlaintext(storyData.introBody).length: '0'}}/80 char</span>
                </label>
                <div class="dataField bdrfill">
                  <ng-container *ngIf="isCKEditorEnabled">
                    <div id="storyElement" (keyup)="introKeyUpEvent($event)" (keydown)="introKeyDownEventCk($event)">
                      <ckeditor [editor]="ckEditor3"  id="{{id}}"
                      [data]="storyData.introBody"
                      [config]="ckconfig"
                      [tabindex]="0"
                      (ready)="ckchanges($event, 'ready', 'intro')"
                      (change)="onChange($event,'intro')"
                      (blur)="ckchanges($event, 'blur', 'intro')"
                      (focus)="ckchanges($event, 'focus', 'intro')"
                      (error)="ckchanges($event, 'error', 'intro')"
                      ></ckeditor>
                    </div>
                  </ng-container>
                
                </div>

                <div class="storyaction" *ngIf=(storyEditMode)>
                  <span id="summary1" class="deleteHeadline" (click)="storyData.introBody = ''">
                    <i class="icon-delete"></i>
                  </span>
                </div>
              </li>

              <!-- <li class="leadMedia" id="leadMedia" *ngIf="(isPinnedElementEnabled() > 0)">

                <ng-container *ngIf="(storyData.pinnedArticles && (storyData.pinnedArticles.length > 0))">
                  <ng-container *ngFor="let pinItem of storyData.pinnedArticles">
                    <div class="element-module" #pinnedElement [EditMode]="storyEditMode" [id]="pinItem"
                      [cardId]="pinItem" (deleteCardfn)="deletePinnedElement($event)"
                      (childKeyDown)="childKeyDownEventCatcher($event)" [hideDragger]="true" (sendWordCountToStory)="getWordCount($event)"
                      (previousFocusEmit)="focusOnElement($event, 'pinned|up')" (nextFocusEmit)="focusOnElement($event, 'pinned|down')"
                      (incrementPendingRequest)="increasePendingCount()" (decrementPendingRequest)="decreasePendingCount($event)"
                      (scrollOut)="scr($event)" (storySave)="autoSaveRequest($event)">
                    </div>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="storyEditMode && (storyData.pinnedArticles && (storyData.pinnedArticles.length < isPinnedElementEnabled()))">

                  <label [style.visibility]="focusOnPinnedMedia ? 'visible' : 'hidden'">Pinned Media</label>
                  <div class="dataField selectPinned" (focus)="focusOnPinnedMedia = true" (focusout)="focusOnPinnedMedia = (pinnedMediaImageToggle ? true : false)"
                    (mouseenter)="focusOnPinnedMedia = true" (mouseleave)="focusOnPinnedMedia = (pinnedMediaImageToggle ? true : false)"
                    tabindex="3">
                    <ul [ngClass]="{'z-high': pinnedMediaImageToggle}" class="leadMediaIcon">
                      <li class="spImg_story">
                        <span class="i_image" [ngClass]="{'active' : pinnedMediaImageToggle}" (click)="pinnedListClick($event,1)">
                          <i class="icon-image"></i>
                        </span>
                        <div [class]="'imageAction' +  (pinnedMediaImageToggle ? ' block' : '') ">
                          <div class="blockContain">
                            <div class="uploadimage">
                              <i class="icon-upload"></i>
                              <div class="upload-btn-wrapper">
                                <span class="btn">Upload a new Image</span>
                                <input type="file" accept="image/*" name="pinnedfile" (change)="onFileChangeSingle($event, 'pinnedMedia')" />
                              </div>
                            </div>
                            <div class="pickimage">
                              <i class="icon-image-library"></i>
                              <span (click)="showPinnedGallery()" class="pickimageBtn">Pick from Image Library</span>
                              <div class="lightBox block" *ngIf="isPinnedLigthbox">
                                <div class="headerLight">
                                  <div class="close fl spImg" (click)="hidePinnedGallery()"></div>
                                </div>
                                <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="getPinnedMediaId($event)"
                                  *ngIf="isPinnedPhotopopup"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="embed_icon spImg_story" (click)="openEmbedPopup('pinnedMedia')">
                        <i class="icon-embed"></i>
                        <span class="tooltip">Insert Embed</span>
                      </li>
                      <li *ngIf="domainConfig.elementsDisabled.indexOf('table') === -1" class="table_icon spImg_story" (click)="createNewTable('pinnedMedia')">
                        <span class="tooltip">Insert table</span>
                        <i class="icon-table"></i>
                    </li>
                    </ul>
                  </div>
                </ng-container>
              </li> -->

            </ul>


            <div #autoscroll>
              <div>
                <div *ngFor="let listItemId of viewPortItems; let i = index">
                  <!-- <div *ngFor="let listItemId of storyData.elements; let i = index"> -->
                  <div #elReferenc class="element-module" [id]="listItemId" [cardId]="listItemId" [preLoadedcardData]="serveElementContent(listItemId)"
                    (updateContentOnParent)="getUpadtedElementContent($event)"
                    (removeSavedCardData)="removeSaved($event)" (cardDataFromElement)="getCardDatafromElement($event)" [EditMode]="storyEditMode"
                    [editCardFlag]="storyEditMode" [editCardId]="currentcardId" (deleteCardfn)="deleteCardEmit($event)"
                    (childKeyDown)="childKeyDownEventCatcher($event)" (currentcardfn)="currentCardId($event)"
                    (afterInitializeEmit)="removeTempCardView($event)" (sendWordCountToStory)="getWordCount($event)"
                    [currentFocusedElementId]="focusedCard" (currentcardfn)="currentCardId($event)" (previousFocusEmit)="focusOnElement($event, 'up')"
                    (nextFocusEmit)="focusOnElement($event, 'down')" (updateCardDatafn)="receiveCardData($event)"
                    (incrementPendingRequest)="increasePendingCount()" (decrementPendingRequest)="decreasePendingCount($event)"
                    (scrollOut)="scr($event)" (embedChangeOutput)="checkForSourceUrlInEmbed($event)" [storytype]="storyType">
                  </div>
                </div>
              </div>
            </div>

            <div class="border_bddd"></div>
            <!-- new element -->
            <ng-container *ngIf="storyEditMode">
              <div #newLiveblogElement class="element-module" [id]="'newLiveblogElement'" [cardId]="null" [cardType]="'mintlite'"
                [editCardId]="currentcardId" [EditMode]="storyEditMode" [editCardFlag]="storyEditMode" (saveCardfn)="saveCardEmit($event)"
                (childKeyDown)="childKeyDownEventCatcher($event)" (currentcardfn)="currentCardId($event)"
                (tempSaveCard)="saveCardTemporarily($event)" (sendWordCountToStory)="getWordCount($event)"
                [currentFocusedElementId]="focusedCard" (previousFocusEmit)="focusOnElement($event, 'up')"
                (nextFocusEmit)="focusOnElement($event, 'down')" (incrementPendingRequest)="increasePendingCount()"
                (updateContentOnParent)="getUpadtedElementContent($event)" (decrementPendingRequest)="decreasePendingCount($event)"
                (scrollOut)="scr($event)" [storytype]="storyType">
              </div>
              <ul class="storyuL">
                <li>
                  <label class="noBorder" [style.visibility]="'hidden'">&nbsp;</label>
                  <div class="dataField">
                    <button #addLiveblogButton tabindex="0" type="button" name="createCard" style="margin-bottom:35px;"
                      class="editedCard irisblue" (click)="addLiveblogElementLite()">Publish
                      this Post</button>

                    <button #addLiveblogPostButton tabindex="0" id="buttonAddPost" type="button" name="createCard" style="margin-bottom:35px;"
                    class="yellow" (click)="addLiveblogPostLite()">Add Post</button>
                  </div>
                </li>
              </ul>
            </ng-container>


            <!-- add new list item button -->
            <!-- temp elements -->
            <ng-container *ngIf="tempCardArray.ids.length > 0">
              <ul class='containerliveblog'>

                <li *ngFor="let element of tempCardArray.objs">
                  <div class="border_bddd"></div>
                  <div #elReferenceTemp class="temp-view-card" [cardType]="'mintlite'" [cardData]="element">
                  </div>

                </li>
              </ul>
            </ng-container>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'web-story'">
          <app-web-stories #webStoryElement [webStory]="storyData" (updateContentOnParent)="getUpadtedElementContent($event)" (cardDataFromElement)="getCardDatafromElement($event)" (replaceElementData)="replaceElementData($event)"
          (deleteCardfn)="deleteWebStorySlide($event)" (removeSavedCardData)="removeSaved($event)" [slides]="Elements" (updateStoryData)="updateStoryData($event)" [storyEditMode]="storyEditMode"></app-web-stories>
        </ng-container>


        </ng-container>
      </div>
    </div>
  </div>
<!-- <div [class]="!togglePreview ? 'thirdContainScroll languageTrans' : 'thirdContainScroll'"> -->

  <ng-container *ngIf="showWebStoriesTab">

  <div class="thirdContainScroll">
    <div class="thirdContainer marb20">
      <div class="tabs tabStories">
        <span class="tablinks metadata " (click)="snowplowAnalytics('Metadata');activeFeed = 'metadata'"
          [class]="activeFeed === 'metadata' ? 'active' : ' '" id="defaultOpen">Metadata</span>
        <span id="designTab" tabindex="0" class="tablinks design" (click)="snowplowAnalytics('Design');activeFeed = 'design'"
          [class]="activeFeed === 'design' ? 'active' : ' '">Design</span>
        <span id="animationTab" tabindex="0" class="tablinks animation" (click)="snowplowAnalytics('Animation');activeFeed = 'animation'"
          [class]="activeFeed === 'animation' ? 'active' : ' '">Animation</span>
      </div>
      <ng-container [ngSwitch]="activeFeed">
        <ng-container *ngSwitchCase="'metadata'">
          <div class="tabcontent" id="allStories" style="display: block;">

        <ng-container *ngIf="(disabledPreviews.length < 2) && !showWebStoriesTab">
          <div class="preview padb20 fl100">Preview
            <span class="right fr">
              <a #preivewMobile tabindex="0" (click)="openPreview('mobile')" *ngIf="disabledPreviews.indexOf('mobile') === -1">
                <span class="molineLink">
                  <i class="icon-mobile"></i>Mobile</span>
              </a>
              <a #preivewDesktop tabindex="0" (click)="openPreview('desktop')" *ngIf="disabledPreviews.indexOf('desktop') === -1">
                <span class="desktopLink">
                  <i class="icon-desktop"></i>Desktop</span>
              </a>
            </span>
          </div>
          </ng-container>
          <ng-container *ngIf="enableAMPValidation && !showWebStoriesTab">
          <div class="ampValidatorBlock">

            <h4>AMP Validator <span [class]="ampButtonColor" (click)="ampValidation()"></span></h4>
            <span *ngIf="showAmpDetails" class="showDetails" (click)="openAmpValidate()">Show Details</span>
          </div>
        </ng-container>
        <!--  <ng-container *ngIf="!showLanuageTab">
          <div class="tabs tabBlue">
              <span class="tablinks" (click)="togglePreview = true ; languageTrans=false" [ngClass]="{'active': togglePreview}">Meta</span>
              <span class="tablinks" (click)="togglePreview = false ; languageTrans=true" [ngClass]="{'active': !togglePreview}">Language</span>
            </div>

          </ng-container>  -->

          <!--
          <div class="tabcontent" id="language" *ngIf="!togglePreview">
              <div class="translatorview">
                <h2>{{originalStory?.headline}}</h2>
                <h3>{{(originalStory && originalStory.story && originalStory.story[0] && originalStory.story[0].summary) ? originalStory.story[0].summary : ''}}</h3>

                <p [innerHTML]='(originalStory && originalStory.story && originalStory.story[0] && originalStory.story[0].content) ? originalStory.story[0].content: "" '></p>
              </div>
          </div> -->
          <div class="tabcontent" id="meta">
          <div class="usermeta blocks marb20">
            <div class="head">Metadata</div>
            <div class="form" *ngIf="this.storyType !== 'deadlink'">

              <ul class="bylineBlock">
                <li [class]="setCheckForErrorIndication(4) ? 'errorInput' : ''">
                  <label>By Line</label>
                  <div class="dataField">
                    <tags-creator #firstMeta [autoSuggest]="true" [autocompletelist]="authorsSuggestion" (focusoutfn)="disableInnerFocus($event)"
                      [editable]="!storyEditMode" [data]="getCurrentDataSet(authorFieldSet)" [setFocus]="innerFocusFlag"
                      [displayText]="authorFieldSet.inputPlaceholder" (clickfn)="customFunc($event)" (changefn)="setMetadata($event, authorFieldSet)"
                      (focusedfn)="catchTagFocus($event)" [isDataKeyValuePair]="isAuthorIdEnabled"></tags-creator>
                  </div>
                </li>
                <ng-container *ngIf="disabledMetaFields.indexOf('postedBy') === -1">
                  <li *ngIf="disableElement('meta-more') ? storyData.metadata.postedByList ? storyData.metadata.postedByList.length > 0 : false : true">
                    <label>Posted By</label>
                    <div class="dataField">
                      <tags-creator #firstMeta [autoSuggest]="true" [autocompletelist]="authorsSuggestion" (focusoutfn)="disableInnerFocus($event)"
                        [editable]="!storyEditMode" [data]="getCurrentDataSet(postedByFieldSet)" [setFocus]="innerFocusFlag"
                        [displayText]="postedByFieldSet.inputPlaceholder" (clickfn)="customFunc($event)" (changefn)="setMetadata($event, postedByFieldSet)"
                        (focusedfn)="catchTagFocus($event)" [isDataKeyValuePair]="isAuthorIdEnabled"></tags-creator>
                    </div>
                  </li>
                </ng-container>
                <ng-container *ngFor="let field of fieldSet">
                  <ng-container *ngIf="disabledMetaFields.indexOf(field.metadataModelId) === -1">
                  <li *ngIf="disableElement('meta-more') ? storyData.metadata[field.metadataModelId] ? storyData.metadata[field.metadataModelId].length > 0 : false : true">
                    <ng-container *ngIf="!field.auto">
                      <label>{{field.labelName}}</label>

                      <div class="dataField">
                        <ul id="myAuthors">
                          <tags-creator [data]="getCurrentDataSet(field)" [editable]="!storyEditMode" [displayText]="field.inputPlaceholder"
                            (clickfn)="customFunc($event)" (changefn)="setMetadata($event, field)"
                            (focusedfn)="catchTagFocus($event)"></tags-creator>
                        </ul>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="field.auto">
                      <label>{{field.labelName}}</label>
                      <div class="dataField">
                        <ul id="myAuthors">
                          <tags-creator [autoSuggest]="true" [autocompletelist]="authorsSuggestion" [setFocus]="field.focusFlag"
                            [editable]="!storyEditMode" [data]="getCurrentDataSet(field)" [displayText]="field.inputPlaceholder"
                            (clickfn)="customFunc($event)" (changefn)="setMetadata($event, field)"
                            (focusedfn)="catchTagFocus($event)" [isDataKeyValuePair]="isAuthorIdEnabled"></tags-creator>
                        </ul>
                      </div>
                    </ng-container>
                  </li>
                </ng-container>
                </ng-container>
                <ng-container *ngIf="disabledMetaFields.indexOf('column') === -1">
                <li *ngIf="(storyType === 'liveblog' || storyType === 'gallery' || storyType === 'video' || storyData.metadata.sponsored || storyData.metadata.breakingNews || storyData.metadata.bigStory) ? false : (!insideColumn ? (disableElement('meta-more') ? (storyData.metadata.column ? (storyData.metadata.column.trim() !== '') : false) : true) : true)">
                  <label>Column</label>
                  <div class="dataField">
                    <input type="text" [class]="'textBox'" #columnInput [readonly]="!storyEditMode" placeholder="Add Column here."
                      [(ngModel)]="columnQuery" (keyup)="filterAutoCompleteUp($event ,'column')" (keydown)="filterAutoCompleteDown($event ,'column')"
                      (focus)="focusInSuggest('column')" (focusout)="false">
                    <ng-container *ngIf="storyEditMode">
                      <div #columnList class="autosuggestion block" *ngIf="filteredColumnSuggestion && filteredColumnSuggestion.length > 0">
                        <ul *ngFor="let item of filteredColumnSuggestion; let i = index">
                          <li (click)="selectAutoComplete('column', item)" [class.active]="i === currentSelection">
                            <span class="name">{{item}}</span>
                          </li>
                        </ul>
                      </div>
                      <ng-container *ngIf="insideColumn && (1 > filteredColumnSuggestion.length)">
                        <div class="autosuggestion block">
                          <ul>
                            <li>
                              <span class="name">No Results</span>
                            </li>
                          </ul>
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </li>
                </ng-container>
                <ng-container *ngIf="disabledMetaFields.indexOf('attribution') === -1">
                  <li *ngIf="(storyType === 'liveblog' || storyType === 'gallery' || storyType === 'video' || storyData.metadata.sponsored || storyData.metadata.breakingNews || storyData.metadata.bigStory) ? false : (!insideAttribution ? (disableElement('meta-more') ? (storyData.metadata.attribution ? (storyData.metadata.attribution.trim() !== '') : false) : true) : true)">
                      <label>Attribution</label>
                      <div class="dataField">
                        <input type="text" #attributionInput [class]="'textBox'" [readonly]="!storyEditMode" placeholder="Add Attribution here."
                          [(ngModel)]="attributionQuery" (keyup)="filterAutoCompleteUp($event ,'attribution')" (keydown)="filterAutoCompleteDown($event ,'attribution')"
                          (focus)="focusInSuggest('attribution')" (focusout)="false">
                          <ng-container *ngIf="insideAttribution && storyEditMode">
                            <div #attributionList class="autosuggestion block" *ngIf="filteredAttributionSuggestion && filteredAttributionSuggestion.length > 0">
                              <ul *ngFor="let item of filteredAttributionSuggestion; let i = index">
                                <li (click)="selectAutoComplete('attribution', item)" [class.active]="i === currentSelection">
                                  <span class="name">{{item}}</span>
                                </li>
                              </ul>
                            </div>
                            <ng-container *ngIf="insideAttribution && (filteredAttributionSuggestion && 1 > filteredAttributionSuggestion.length)">
                              <div class="autosuggestion block">
                                <ul>
                                  <li>
                                    <span class="name">No Results</span>
                                  </li>
                                </ul>
                              </div>
                            </ng-container>
                          </ng-container>
                      </div>
                  </li>
                  </ng-container>
                <ng-container *ngIf="isMoreButtonEnabled">
                <li>
                  <span [class]="(disableElement('meta-more') ? 'more' : 'less') + ' spImg_story'" (click)="metaToggleFlag = !metaToggleFlag">
                    {{disableElement('meta-more') ? 'more' : 'less'}}
                  </span>
                </li>
              </ng-container>
              </ul>
              <ul>
                <li [class]="setCheckForErrorIndication(4) ? 'errorInput' : ''">
                  <label>Agency</label>
                  <div class="dataField">
                    <input type="text" class="textBox" #agencyInput [readonly]="!storyEditMode" placeholder="Add Agency here."
                      [(ngModel)]="agencyQuery" (keyup)="filterAutoCompleteUp($event ,'agency')" (keydown)="filterAutoCompleteDown($event ,'agency')"
                      (focus)="focusInSuggest('agency')" (focusout)="false">
                    <ng-container *ngIf="storyEditMode">
                      <div #agencyList class="autosuggestion block" *ngIf="filteredAgencySuggestion && filteredAgencySuggestion.length > 0">
                        <ul *ngFor="let item of filteredAgencySuggestion; let i = index">
                          <li (click)="selectAutoComplete('agency', item)" [class.active]="i === currentSelection">
                            <span class="name">{{item}}</span>
                            <!-- <span class="emails">(nitesh.rawal@htdigital.in)</span> -->
                          </li>
                        </ul>
                      </div>
                      <ng-container *ngIf="insideAgency && (1 > filteredAgencySuggestion.length)">
                        <div class="autosuggestion block">
                          <ul>
                            <li>
                              <span class="name">No Results</span>
                            </li>
                          </ul>
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </li>
                
                <li [class]="setCheckForErrorIndication(2) ? 'errorInput' : ''">
                  <label>
                    Section
                  </label>
                  <div class="dataField">
                    <input type="text" class="textBox" #sectionInput [readonly]="!storyEditMode" placeholder="Add Section here."
                      [(ngModel)]="sectionQuery" (keyup)="filterAutoCompleteUp($event ,'section')" (keydown)="filterAutoCompleteDown($event ,'section')"
                      (focus)="focusInSuggest('section')" (focusout)="false">
                    <ng-container *ngIf="storyEditMode">
                      <div #sectionList class="autosuggestion block" *ngIf="filteredSectionSuggestion && filteredSectionSuggestion.length > 0 && insideSection">
                        <ul *ngFor="let item of filteredSectionSuggestion;let i = index">
                          <li (click)="selectAutoComplete('section', item)" [class.active]="i === currentSelection">
                            <span class="name">{{item}}</span>
                            <!-- <span class="emails">(nitesh.rawal@htdigital.in)</span> -->
                          </li>
                        </ul>
                      </div>
                      <ng-container *ngIf="insideSection && (1 > filteredSectionSuggestion.length)">
                        <div class="autosuggestion block">
                          <ul>
                            <li>
                              <span class="name">No Results</span>
                            </li>
                          </ul>
                        </div>
                      </ng-container>
                    </ng-container>

                  </div>
                </li>
                <li [class]="setCheckForErrorIndication(3) ? 'errorInput' : ''">
                  <label>Sub-section
                  </label>

                  <div class="dataField">
                    <input type="text" class="textBox" #subSectionInput [readonly]="!storyEditMode && flagForSubSection"
                      placeholder="Add SubSection here." [(ngModel)]="subSectionQuery" (keyup)="filterAutoCompleteUp($event ,'subSection')"
                      (keydown)="filterAutoCompleteDown($event ,'subSection')" (focus)="focusInSuggest('subSection')"
                      (focusout)="false">
                    <ng-container *ngIf="storyEditMode">
                      <div #subSectionList class="autosuggestion block" *ngIf="filteredSubSectionSuggestion && filteredSubSectionSuggestion.length > 0">
                        <ul *ngFor="let item of filteredSubSectionSuggestion; let i = index">
                          <li (click)="selectAutoComplete('subSection', item)" [class.active]="i === currentSelection">
                            <span class="name">{{item}}</span>
                            <!-- <span class="emails">(nitesh.rawal@htdigital.in)</span> -->
                          </li>
                        </ul>
                      </div>
                      <ng-container *ngIf="insideSubSection && (1 > filteredSubSectionSuggestion.length)">
                        <div class="autosuggestion block">
                          <ul>
                            <li>
                              <span class="name">No Results</span>
                            </li>

                          </ul>
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </li>
                 <!-- Subsection-l2 -->
              <li>
                <label>Sub section l2
                </label>

                <div class="dataField">
                  <input type="text" class="textBox" #subSectionL2Input [readonly]="!storyEditMode"
                    placeholder="Add Sub sub section here." id="inputAddSubSectionText" [(ngModel)]="subSectionL2Query" (keyup)="filterAutoCompleteUp($event ,'subSectionL2')"
                    (keydown)="filterAutoCompleteDown($event ,'subSectionL2')" (focus)="focusInSuggest('subSectionL2')"
                    (focusout)="false">
                  <ng-container *ngIf="storyEditMode">
                    <div #subSectionList class="autosuggestion block" *ngIf="filteredSubSectionL2Suggestion && filteredSubSectionL2Suggestion.length > 0">
                      <ul *ngFor="let item of filteredSubSectionL2Suggestion; let i = index">
                        <li (click)="selectAutoComplete('subSectionL2', item)" [class.active]="i === currentSelection">
                          <span class="name">{{item}}</span>
                          <!-- <span class="emails">(nitesh.rawal@htdigital.in)</span> -->
                        </li>
                      </ul>
                    </div>
                    <ng-container *ngIf="!filteredSubSectionL2Suggestion || (insideSubSectionL2 && (1 > filteredSubSectionL2Suggestion.length))">
                      <div class="autosuggestion block">
                        <ul>
                          <li>
                            <span class="name">No Results</span>
                          </li>

                        </ul>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </li>
              <!--  -->
                <ng-container *ngIf="secondarySectionsNeeded()">
                  <li>
                <app-secondary-section [section]="storyData.metadata.section" [secondarySectionData]="storyData.metadata.secondarySections" [sectionSuggestionList]="sectionSuggestion"
                [subsectionSuggestionList]="subSectionSuggestion" [storyEditMode]="storyEditMode" [listOfAllSubsections]="allSubSections"
                (secondarySectionChanged)="secondarySectionChangesHandler($event)"></app-secondary-section>
                </li>
              </ng-container>
              <ng-container *ngIf="disabledMetaFields.indexOf('topic') === -1">
                <li>
                  <label>Topic</label>
                  <div class="dataField">
                    <tags-creator [autoSuggest]="true" [autocompletelist]="[]" [data]="storyData.metadata.topic"
                      [editable]="!storyEditMode" [idInput]="'inputAddTopicText'" [displayText]="'Enter text to search Topics..'" (clickfn)="customFunc($event)"
                      (changefn)="getNewTopicToAdd($event)" (focusedfn)="catchTagFocus($event)" [isTopicFlag]="true"></tags-creator>
                    </div>
                </li>
              </ng-container>
                <li [class]="setCheckForErrorIndication(9) ? 'errorInput' : ''">
                  <label>Keywords</label>
                  <div class="dataField">
                    <tags-creator [data]="storyData.metadata.keywords" [editable]="!storyEditMode" [displayText]="'Add keywords here..'"
                      (clickfn)="customFunc($event)" (changefn)="storyData.metadata.keywords = $event" (focusedfn)="catchTagFocus($event)"
                      [storyTags]="true" [marketSuggest]="automatedMarketFlag" [enableDrag]="enableKeywordsDrag"
                      (keypress)="specialCharBlock($event)"
                      ></tags-creator>
                      <ng-container *ngIf="isRecosense">
                        <p (click)="getKeywordsForStory()" class="moretags">
                          <a>Get Keywords</a>
                          </p>
                      </ng-container>

                  </div>

                </li>
                <ng-container *ngIf="disabledMetaFields.indexOf('tags') === -1">
                <li>
                  <label>Tags</label>
                  <div class="dataField">
                    <tags-creator [data]="storyData.metadata.tags" [editable]="!storyEditMode" [displayText]="'Add Tags here..'"
                      [suggestions]="suggestTags" (suggestionAddfn)="removeTagFromSuggest($event)" (clickfn)="customFunc($event)"
                      (changefn)="getNewTagsToAdd($event)" (focusedfn)="catchTagFocus($event)" [storyTags]="true"
                      (keypress)="specialCharBlock($event)"
                      ></tags-creator>

                    <p *ngIf="storyEditMode && getTagsEnable()" (click)="getTagsForStory()" class="moretags">
                      <a>{{(suggestTagsTemp.length > 0) ? 'more tags' : 'get tags'}}</a>
                    </p>
                  </div>
                </li>
                </ng-container>
                <ng-container *ngIf="disabledMetaFields.indexOf('source') === -1">
                <li>
                  <label>Source</label>
                  <div class="dataField" >
                      <label class="radioBlock" *ngFor="let item of sourceList">
                          <input type="radio" name="options"
                          [checked]="item === storyData.metadata.storyType"
                          (click)="setSource(item)" />
                          <span class="radiomark"></span>
                          {{item | titlecase}}
                      </label>
                  </div>
                </li>
                </ng-container>
                <ng-container *ngIf="isPrimaryLocationEnabled()">
                  <li [class]="setCheckForErrorIndication(13) ? 'errorInput' : ''">
                    <label>Location</label>
                    <div class="dataField">
                      <input type="text" class="textBox" #primaryLocationInput [readOnly]="!storyEditMode || (storyData.metadata && storyData.metadata.status === 'PUBLISHED')" placeholder="Add Location here.."
                        [(ngModel)]="primaryLocationQuery" (keyup)="filterAutoCompleteUp($event ,'primaryLocation')" (keydown)="filterAutoCompleteDown($event ,'primaryLocation')"
                        (focus)="focusInSuggest('primaryLocation')" (focusout)="false">
                      <ng-container *ngIf="storyEditMode && storyData.metadata && storyData.metadata.status !== 'PUBLISHED'">
                        <div #primaryLocationList class="autosuggestion block" *ngIf="filteredPrimaryLocationSuggestion && filteredPrimaryLocationSuggestion.length > 0">
                          <ul *ngFor="let item of filteredPrimaryLocationSuggestion; let i = index">
                            <li (click)="selectAutoComplete('primaryLocation', item)" [class.active]="i === currentSelection">
                              <span class="name">{{item.toLowerCase()}}</span>
                              <!-- <span class="emails">(nitesh.rawal@htdigital.in)</span> -->
                            </li>
                          </ul>
                        </div>
                        <ng-container *ngIf="insidePrimaryLocation && (1 > filteredPrimaryLocationSuggestion.length)">
                          <div class="autosuggestion block">
                            <ul>
                              <li>
                                <span class="name">No Results</span>
                              </li>
                            </ul>
                          </div>
                        </ng-container>
                      </ng-container>
                    </div>
                  </li>
                  <li>
                    <label>Secondary Location</label>
                    <div class="dataField">
                      <tags-creator [autoSuggest]="true" [autocompletelist]="getLocationList()"
                            [editable]="!storyEditMode" [data]="storyData.metadata.location" [displayText]="'Add Secondary Location here..'"
                            (clickfn)="customFunc($event)" (changefn)="storyData.metadata.location = $event"
                            (focusedfn)="catchTagFocus($event)" [noMinReq]="true"></tags-creator>
                    </div>
                  </li>
                </ng-container>
                <ng-container *ngIf="!isPrimaryLocationEnabled() && !isLocationDisabled() && (disabledMetaFields.indexOf('location') === -1)">
                  <li>
                    <label>Location</label>
                    <div class="dataField">
                      <tags-creator [data]="storyData.metadata.location" [editable]="!storyEditMode" [displayText]="'Add Location here..'"
                        (clickfn)="customFunc($event)" (changefn)="storyData.metadata.location = $event" (focusedfn)="catchTagFocus($event)"></tags-creator>
                    </div>
                  </li>
                </ng-container>
                <ng-container *ngIf="disabledMetaFields.indexOf('canonicalUrl') === -1">
                <li>
                  <label>Canonical URL</label>
                  <div class="dataField">
                    <input [readonly]="!storyEditMode || isCanonicalReadoOnly" [(ngModel)]="storyData.metadata.canonicalUrl" type="text" class="textBox"
                      placeholder="Add Canonical URL here">
                  </div>
                </li>
              </ng-container>
              <ng-container *ngIf="domainConfig['config']['story']['seoUrl']">
                <li>
                  <label>SEO URL</label>
                  <div class="dataField">
                    <input [readonly]="!storyEditMode || storyData.metadata.status == 'PUBLISHED'" [ngModel]="getSeoURL()" (ngModelChange)="updateSeoURL($event)" type="text" class="textBox"
                      placeholder="Add SEO URL here">
                  </div>
                </li>
              </ng-container>
              <ng-container *ngIf="disabledMetaFields.indexOf('externalUrl') === -1">
                <li>
                  <label>External URL</label>
                  <div class="dataField">
                    <input [readonly]="!storyEditMode" [(ngModel)]="storyData.metadata.externalUrl" type="text" class="textBox"
                      placeholder="Add External URL here">
                  </div>
                </li>
              </ng-container>
              <ng-container *ngIf="domainConfig['config']['story']['metaTitle']">
                <li>
                  <label>Meta Title</label>
                  <div class="dataField">
                    <input [readonly]="!storyEditMode" [ngModel]="getMetaTitle()" [disabled]="ismetaTitle" (ngModelChange)="updateMetaTitle($event)" type="text" class="textBox"
                      placeholder="Add meta title here">
                  </div>
                </li>
              </ng-container>
              <ng-container *ngIf="domainConfig['config']['story']['metaDescription']">
                <li>
                  <label>Meta Description</label>
                  <div class="dataField">
                    <textarea type="text" class="textBox" [ngModel]="getMetaDescription()" [disabled]="ismetaDescription" (ngModelChange)="updateMetaDescription($event)" [(ngModel)]="storyData.metadata.metaDescription" placeholder="Enter meta description here…" tabindex="0" cdkTextareaAutosize></textarea>
                  </div>
                </li>
                <ng-container>
                  <li>
                    <label>Copy from Headline and Summary</label>
                    <div class="dataField">
                      <label class="checkblock" tabindex="0" (keydown)="callToggles($event, 'copyFromHeadline')">
                        <input type="checkbox" (click)="toggleSwitch('copyFromHeadline')"
                          [checked]="storyData.metadata.copyFromHeadline">
                        <span class="checkmark"></span>
                      </label>
                    </div>
                  </li>
                </ng-container>
              </ng-container>
              
              <ng-container *ngFor="let newMeta of newMetas; index as i">
                <ng-container *ngIf="(newMeta.storyType.indexOf(storyType) > -1) && newMeta.active">
                    <new-metadata [editable]="storyEditMode" [addedMeta]="newMeta" [checkedField]="getStoryDynamicMetaIndex(newMeta.field)"
                    (emitToggleValue)="saveDynamicMetaValue($event,newMeta.field)">
                    </new-metadata>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="disabledMetaFields.indexOf('webcast') === -1">
                <li *ngIf="storyType === 'video'">
                  <label>Webcast</label>
                  <div class="dataField">
                    <label class="switch" tabindex="0" (keydown)="callToggles($event, 'webcast')">
                      <input type="checkbox" (click)="toggleSwitch('webcast')" [disabled]="(!storyEditMode) ? true : false"
                        [checked]="storyData.metadata.videoMetadata?.webcast">
                      <span class="slider round"></span>
                    </label>
                  </div>
                </li>
                </ng-container>
                <ng-container *ngIf="(sharedService.isdomainConfig('story','premiumStory') && (disabledMetaFields.indexOf('syndicationFeed') === -1)) || (sharedService.isdomainConfig('story','premiumContent'))">
                <li *ngIf="isSyndicationToggleEnabled() || sharedService.isdomainConfig('story','premiumContent')">
                  <label>Premium Story</label>
                  <div class="dataField">
                    <label class="switch" tabindex="0" (keydown)="callToggles($event, 'syndicationFeed')">
                      <input type="checkbox" (click)="toggleSwitch('syndicationFeed')"
                        [disabled]="(!storyEditMode && storyData.metadata) ? true : false"
                        [checked]="storyData.metadata.premiumStory">
                      <span class="slider round"></span>
                    </label>
                  </div>
                </li>
              </ng-container>

  <!-- Add Brand and Model for HT Auto -->
              <ng-container *ngIf="isBrandModelEnable">

                <!-- Add Category Brand and Model for HT Tech -->

                <ng-container *ngIf="enableCategory">
                  <li [class]="setCheckForErrorIndication(21) ? 'errorInput' : ''">
                    <label>Category</label>
                    <div class="dataField">
                      <input type="text" class="textBox" #categoryInput [readonly]="!storyEditMode" placeholder="Add Category here."
                        [(ngModel)]="categoryQuery" (keyup)="filterAutoCompleteUp($event ,'category')"
                        (keydown)="filterAutoCompleteDown($event ,'category')" (focus)="focusInSuggest('category')" (focusout)="false">
                      <ng-container *ngIf="storyEditMode">
                        <div #categoryList class="autosuggestion block"
                          *ngIf="filteredCategorySuggestion && filteredCategorySuggestion.length > 0 && insideCategory">
                          <ul *ngFor="let item of filteredCategorySuggestion;let i = index">
                            <li (click)="selectAutoComplete('category', item)" [class.active]="i === currentSelection">
                              <span class="name">{{item}}</span>
                            </li>
                          </ul>
                        </div>
                        <ng-container *ngIf="insideCategory && filteredCategorySuggestion && (1 > filteredCategorySuggestion.length)">
                          <div class="autosuggestion block">
                            <ul>
                              <li>
                                <span class="name">No Results</span>
                              </li>
                            </ul>
                          </div>
                        </ng-container>
                      </ng-container>
                    </div>
                  </li>
                </ng-container>

  <!---------------------------------------------->

                <li [class]="setCheckForErrorIndication(21) ? 'errorInput' : ''">
                  <label>Brand</label>
                  <div class="dataField">
                  <input type="text" class="textBox" #brandInput [readonly]="!storyEditMode" placeholder="Add Brand here."
                    [(ngModel)]="brandQuery" (keyup)="filterAutoCompleteUp($event ,'brand')"
                    (keydown)="filterAutoCompleteDown($event ,'brand')" (focus)="focusInSuggest('brand')" (focusout)="false">
                    <ng-container *ngIf="storyEditMode">
                      <div #brandList class="autosuggestion block"
                        *ngIf="filteredBrandSuggestion && filteredBrandSuggestion.length > 0 && insideBrand">
                        <ul *ngFor="let item of filteredBrandSuggestion;let i = index">
                          <li (click)="selectAutoComplete('brand', item)" [class.active]="i === currentSelection">
                            <span class="name">{{item}}</span>
                          </li>
                        </ul>
                      </div>
                    <ng-container *ngIf="insideBrand && filteredBrandSuggestion && (1 > filteredBrandSuggestion.length)">
                      <div class="autosuggestion block">
                        <ul>
                          <li>
                            <span class="name">No Results</span>
                          </li>
                        </ul>
                      </div>
                    </ng-container>
                    </ng-container>
                  </div>
                </li>

                <li [class]="setCheckForErrorIndication(22) ? 'errorInput' : ''">
                  <label>Model</label>
                  <div class="dataField">
                    <input type="text" class="textBox" #modelInput [readonly]="!storyEditMode"
                      placeholder="Add Model here." [(ngModel)]="modelQuery" (keyup)="filterAutoCompleteUp($event ,'model')"
                      (keydown)="filterAutoCompleteDown($event ,'model')" (focus)="focusInSuggest('model')" (focusout)="false">
                    <ng-container *ngIf="storyEditMode">
                      <div #modelList class="autosuggestion block"
                        *ngIf="filteredModelSuggestion && filteredModelSuggestion.length > 0 && insideModel">
                        <ul *ngFor="let item of filteredModelSuggestion; let i = index">
                          <li (click)="selectAutoComplete('model', item)" [class.active]="i === currentSelection">
                            <span class="name">{{item}}</span>
                          </li>
                        </ul>
                      </div>
                      <ng-container *ngIf="insideModel && filteredModelSuggestion && (1 > filteredModelSuggestion.length)">
                        <div class="autosuggestion block">
                          <ul>
                            <li><span class="name">No Results</span></li>
                          </ul>
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </li>
              </ng-container>

              <ng-container *ngIf="secondaryBrandsNeeded()">
                <li>
                  <app-secondary-brand [brand]="storyData.metadata.brand" [model]="storyData.metadata.model" [secondaryBrandData]="storyData.metadata.secondaryBrands" [brandSuggestionList]="brandSuggestionMain"
                    [modelSuggestionList]="modelSuggestionMain" [storyEditMode]="storyEditMode" [listOfAllModels]="allModels"
                    (secondaryBrandChanged)="secondaryBrandChangesHandler($event)"></app-secondary-brand>
                </li>
              </ng-container>
  <!------------------------------------->
              </ul>
            </div>
            <div class="form" *ngIf="this.storyType === 'deadlink'">
              <li [class]="setCheckForErrorIndication(2) ? 'errorInput' : ''">
                <label>
                  Section
                </label>
                <div class="dataField">
                  <input type="text" class="textBox" #sectionInput [readonly]="!storyEditMode" placeholder="Add Section here."
                    [(ngModel)]="sectionQuery" (keyup)="filterAutoCompleteUp($event ,'section')" (keydown)="filterAutoCompleteDown($event ,'section')"
                    (focus)="focusInSuggest('section')" (focusout)="false">
                  <ng-container *ngIf="storyEditMode">
                    <div #sectionList class="autosuggestion block" *ngIf="filteredSectionSuggestion && filteredSectionSuggestion.length > 0 && insideSection">
                      <ul *ngFor="let item of filteredSectionSuggestion;let i = index">
                        <li (click)="selectAutoComplete('section', item)" [class.active]="i === currentSelection">
                          <span class="name">{{item}}</span>
                          <!-- <span class="emails">(nitesh.rawal@htdigital.in)</span> -->
                        </li>
                      </ul>
                    </div>
                    <ng-container *ngIf="insideSection && (1 > filteredSectionSuggestion.length)">
                      <div class="autosuggestion block">
                        <ul>
                          <li>
                            <span class="name">No Results</span>
                          </li>
                        </ul>
                      </div>
                    </ng-container>
                  </ng-container>

                </div>
              </li>
              <li [class]="setCheckForErrorIndication(3) ? 'errorInput' : ''">
                <label>Sub-section
                </label>

                <div class="dataField">
                  <input type="text" class="textBox" #subSectionInput [readonly]="!storyEditMode && flagForSubSection"
                    placeholder="Add SubSection here." [(ngModel)]="subSectionQuery" (keyup)="filterAutoCompleteUp($event ,'subSection')"
                    (keydown)="filterAutoCompleteDown($event ,'subSection')" (focus)="focusInSuggest('subSection')"
                    (focusout)="false">
                  <ng-container *ngIf="storyEditMode">
                    <div #subSectionList class="autosuggestion block" *ngIf="filteredSubSectionSuggestion && filteredSubSectionSuggestion.length > 0">
                      <ul *ngFor="let item of filteredSubSectionSuggestion; let i = index">
                        <li (click)="selectAutoComplete('subSection', item)" [class.active]="i === currentSelection">
                          <span class="name">{{item}}</span>
                          <!-- <span class="emails">(nitesh.rawal@htdigital.in)</span> -->
                        </li>
                      </ul>
                    </div>
                    <ng-container *ngIf="insideSubSection && (1 > filteredSubSectionSuggestion.length)">
                      <div class="autosuggestion block">
                        <ul>
                          <li>
                            <span class="name">No Results</span>
                          </li>

                        </ul>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </li>
                <li>
                  <label>Deadlink URL</label>
                  <div class="dataField">
                    <input [readonly]="!storyEditMode" [(ngModel)]="storyData.metadata.deadLinkUrl" type="text" class="textBox"
                      placeholder="Add Deadlink URL here">
                  </div>
                </li>
            </div>
            <ng-container *ngIf="sharedService.isdomainConfig('story','autoBacklinking') && storyType === 'story'">
              <button type="button" name="unlock" tabindex="0" (click)="deleteBacklinking()"
              class="add blue ml10">Remove All Hyperlinks</button>
            </ng-container>
          </div>

          <div class="headlines blocks marb20" *ngIf="(isHomepageOptionsEnabled() > 0) && (storyType === 'liveblog')">
            <div class="head">Homepage</div>
            <div class="form">
              <ul>
                <li>
                  <label>HT Homepage</label>
                  <div class="dataField">
                    <label class="switch" tabindex="0" (keydown)="callToggles($event, 'homepage')">
                      <input type="checkbox" [disabled]="(!storyEditMode) ? true : false" (click)="toggleSwitch('homepage')"
                        [checked]="homepageToggle">
                      <span class="slider round"></span>
                    </label>
                  </div>
                </li>

                <ng-container *ngIf="homepageToggle">
                <li>
                  <label>Position</label>
                  <div class="dataField">
                    <input [readonly]="!storyEditMode" (input)="onPositionChange($event)" type="text" class="textBox"
                      placeholder="Add position here" nuberInput maxLength="isHomepageOptionsEnabled()" [value]="(storyData.metadata && storyData.metadata.homePagePosition) ? storyData.metadata.homePagePosition : 0">
                  </div>
                </li>

                <li>
                  <label>HomePage End Time</label>
                  <div class="dataField">
                    <input #homepageDate class="textBox homePageInput" name="createCard" [disabled]="(!storyEditMode) ? true : false"
                      daterangepicker [options]="homepageCalendarConfig" (selected)="dateSelectedForHomepageOption($event)"
                      (cancelDaterangepicker)="dateEventHandlerForHomepageOption($event)"
                      (applyDaterangepicker)="dateEventHandlerForHomepageOption($event)">
                  </div>
                </li>
                </ng-container>
              </ul>
            </div>
          </div>

          <div class="systemmeta blocks marb20">
            <div class="head">Story Info</div>
            <div class="form">
              <ul>
                <li *ngIf="storyType !== 'deadlink'">
                  <label>URL</label>
                  <div class="dataField"><a href="{{(storyData.metadata.status &&
                    (storyData.metadata.status
                    !== 'KILLED')) ? (storyData.metadata.url ?
                    ((this.storyData.metadata.url.charAt(0) !== '/') ? this.storyData.metadata.url : (sharedService.currentDomainUrl
                    +
                    storyData.metadata.url)) : '')
                    : storyData.metadata.redirectUrl}}" target="_blank">
                    <span class="link">{{(storyData.metadata.status &&
                      (storyData.metadata.status
                      !== 'KILLED')) ? (storyData.metadata.url ?
                      ((this.storyData.metadata.url.charAt(0) !== '/') ? this.storyData.metadata.url : (sharedService.currentDomainUrl
                      +
                      storyData.metadata.url)) : '')
                      : storyData.metadata.redirectUrl}}</span></a>
                      <span class="editBtn">
                      <span><i (click)="copystoryUrl()" class="icon-cards"></i></span></span>
                  </div>
                </li>
                <li>
                  <label>Format</label>
                  <div class="dataField">
                    <span class="">{{storyData.type}}</span>
                  </div>
                </li>
                <li *ngIf="!showWebStoriesTab">
                  <label>Word Count</label>
                  <div class="dataField">
                    <span class="">{{storyWordCount ? storyWordCount : 0}}</span>
                  </div>
                </li>
                <li *ngIf="enableSeoScore && !showWebStoriesTab">
       <div class="dataField wid100 center" *ngIf="seoScoreShowDetail">
                    <span class="details" (click)="openSeoScore()">Show Details</span>
                  </div>

                  <ng-container *ngIf="seoScoreShowScore">
                    <label>Overall SEO Score</label>
                    <div class="dataField">
                      <span class="">{{seoOverallScore}} / 100</span>
                    </div>
                  </ng-container>
                </li>
                <ng-container *ngIf="domainConfig['config']['story']['readibilityEase'] === 'true' && storyType === 'story'">
                  <li>
                    <label>Readibility Score</label>
                    <div class="dataField">
                      <span class="">{{storyData.readabilityEase | number:'1.0-0'}}</span>
                    </div>
                  </li>
                  <li>
                    <ng-container *ngIf='checkReadibilityEase()'>
                      <label>Readibility Ease</label>
                      <div class="dataField">
                          <span class="">{{readibilityType}}</span>
                      </div>
                    </ng-container>
                  </li>
                </ng-container>
              </ul>
            </div>
          </div>


          <div class="systemmeta lastModi blocks marb20">
            <div class="head">Last Modified Info</div>
            <div class="form">
              <ul>
                <li>
                  <label>Last Modified By :</label>
                  <div class="dataField">
                    <span>
                      {{storyData.lastModifiedBy}}
                    </span>
                  </div>
                  </li>
                  <li>
                    <label>Last Modified At :</label>
                    <div class="dataField">
                      <span>
                        {{getNewTypeDate(storyData.lastModifiedDate)}}
                      </span>
                    </div>
                    </li>
              </ul>
              </div>
            </div>

        </div>
        </div>
        </ng-container>
        <ng-container *ngSwitchCase="'design'">
          <div class="tabcontent" id="design" style="display: block;" tabindex="0">
            <div class="designBlock">
              <div [ngClass]="{'disableDesign':(webStoryElementRef?.currentTextboxOrButtonElementIndex == null || webStoryElementRef?.currentTextboxOrButtonElementIndex == undefined || !storyEditMode)}">
              <div class="bgDisableClass"></div>
                <label>Alignment</label>
              <div class="alignment">
                <ul class="divideAlign top">
                  <li>
                    <label class="radioBlock">
                      <input id="designTopAlign" type="radio" name="topBottomPosition" [checked]="(webStoryElementRef?.currentTextboxOrButtonElements && (webStoryElementRef?.currentTextboxOrButtonElementIndex != null) && webStoryElementRef?.currentTextboxOrButtonElements[webStoryElementRef?.currentTextboxOrButtonElementIndex]?.top)" value='top' (change)="align($event)"/>
                      <span class="radiomark"></span>
                      Top
                    </label>
                  </li>
                  <li>
                    <label class="radioBlock">
                      <input id="designBottomAlign" type="radio" name="topBottomPosition" [checked]="(webStoryElementRef?.currentTextboxOrButtonElements && (webStoryElementRef?.currentTextboxOrButtonElementIndex != null) && webStoryElementRef?.currentTextboxOrButtonElements[webStoryElementRef?.currentTextboxOrButtonElementIndex]?.bottom)" value='bottom' (change)="align($event)"/>
                      <span class="radiomark"></span>
                      Bottom
                    </label>
                  </li>
                  <li>
                    <label class="radioBlock">
                      <input id="designTopBottomCenterAlign" type="radio" name="topBottomPosition" [checked]="(webStoryElementRef?.currentTextboxOrButtonElements && (webStoryElementRef?.currentTextboxOrButtonElementIndex != null) && webStoryElementRef?.currentTextboxOrButtonElements[webStoryElementRef?.currentTextboxOrButtonElementIndex]?.topBottomCenter)" value='topBottomCenter' (change)="align($event)"/>
                      <span class="radiomark"></span>
                      Center
                    </label>
                  </li>
                <!-- <img src="assets/images/webstories/icon-left-arrow.svg" style="transform: rotateZ(90deg);"> -->
                 <!-- <i class="icon-add-headline"></i></li> -->
                  <!-- <li><img src="assets/images/webstories/icon-right-arrow.svg"  style="transform: rotateZ(90deg);">Bottom <i class="icon-add-headline"></i></li>
                   -->
                </ul>
                <ul class="divideAlign">
                  <li>
                    <label class="radioBlock">
                      <input id="designLeftAlign" type="radio" name="leftRightPosition" [checked]="(webStoryElementRef?.currentTextboxOrButtonElements && (webStoryElementRef?.currentTextboxOrButtonElementIndex != null) && webStoryElementRef?.currentTextboxOrButtonElements[webStoryElementRef?.currentTextboxOrButtonElementIndex]?.left)" value='left' (change)="align($event)"/>
                      <span class="radiomark"></span>
                      Left
                    </label>
                  </li>
                  <li>
                    <label class="radioBlock">
                      <input id="designRightAlign" type="radio" name="leftRightPosition" [checked]="(webStoryElementRef?.currentTextboxOrButtonElements && (webStoryElementRef?.currentTextboxOrButtonElementIndex != null) && webStoryElementRef?.currentTextboxOrButtonElements[webStoryElementRef?.currentTextboxOrButtonElementIndex]?.right)" value='right' (change)="align($event)"/>
                      <span class="radiomark"></span>
                      Right
                    </label>
                  </li>
                  <li>
                    <label class="radioBlock">
                      <input id="designLeftRightCenterAlign" type="radio" name="leftRightPosition" [checked]="(webStoryElementRef?.currentTextboxOrButtonElements && (webStoryElementRef?.currentTextboxOrButtonElementIndex != null) && webStoryElementRef?.currentTextboxOrButtonElements[webStoryElementRef?.currentTextboxOrButtonElementIndex]?.leftRightCenter)" value='leftRightCenter' (change)="align($event)"/>
                      <span class="radiomark"></span>
                      Center
                    </label>
                  </li>

                  <!-- <li><img src="assets/images/webstories/icon-left-arrow.svg">Left <i class="icon-add-headline"></i></li>
                  <li><img src="assets/images/webstories/icon-right-arrow.svg">Right <i class="icon-add-headline"></i></li> -->
                </ul>
                <!-- <ul>
                  <li><img src="assets/images/webstories/icon-1.svg"></li>
                  <li><img src="assets/images/webstories/icon-2.svg"></li>
                  <li><img src="assets/images/webstories/icon-3.svg"></li>
                  <li><img src="assets/images/webstories/icon-4.svg"></li>
                  <li><img src="assets/images/webstories/icon-5.svg"></li>
                  <li><img src="assets/images/webstories/icon-6.svg"></li>
                  <li><img src="assets/images/webstories/icon-7.svg"></li>
                  <li><img src="assets/images/webstories/icon-8.svg"></li>
                </ul> -->
             <!--   <div class="alignOption">
                   <div class="alignWH">
                    <ul>
                      <li>W<input type="text" class="textBox"></li>
                      <li>H<input type="text" class="textBox"></li>
                    </ul>
                  </div>
                  <div class="alignXY">
                    <ul>
                      <li>X<input type="text" class="textBox"></li>
                      <li>Y<input type="text" class="textBox"></li>
                    </ul>
                  </div>
                  <div class="alignRotation">
                    <ul>
                      <li>R<input type="text" class="textBox"></li>
                      <li>&nbsp;</li>
                    </ul>
                  </div>
                </div> -->

              <label>Postion Change</label>

                <ul class="divideAlign top">
                  <li [ngClass]="{'disable-action':(webStoryElementRef?.currentTextboxOrButtonElements && (webStoryElementRef?.currentTextboxOrButtonElementIndex != null) && webStoryElementRef?.currentTextboxOrButtonElements[webStoryElementRef?.currentTextboxOrButtonElementIndex]?.top)}" (click)="changeMargin('top')">
                    Top+5 <i class="icon-add-headline"></i>
                    </li>
                    <li [ngClass]="{'disable-action':(webStoryElementRef?.currentTextboxOrButtonElements && (webStoryElementRef?.currentTextboxOrButtonElementIndex != null) && webStoryElementRef?.currentTextboxOrButtonElements[webStoryElementRef?.currentTextboxOrButtonElementIndex]?.bottom)}" (click)="changeMargin('bottom')">
                      Bottom+5 <i class="icon-add-headline"></i>
                      </li>

                </ul>
                <ul class="divideAlign">
                  <li [ngClass]="{'disable-action':(webStoryElementRef?.currentTextboxOrButtonElements && (webStoryElementRef?.currentTextboxOrButtonElementIndex != null) && webStoryElementRef?.currentTextboxOrButtonElements[webStoryElementRef?.currentTextboxOrButtonElementIndex]?.left)}" (click)="changeMargin('left')">
                    Left+5 <i class="icon-add-headline"></i>
                    </li>
                    <li [ngClass]="{'disable-action':(webStoryElementRef?.currentTextboxOrButtonElements && (webStoryElementRef?.currentTextboxOrButtonElementIndex != null) && webStoryElementRef?.currentTextboxOrButtonElements[webStoryElementRef?.currentTextboxOrButtonElementIndex]?.right)}" (click)="changeMargin('right')">
                      Right+5 <i class="icon-add-headline"></i>
                      </li>
                </ul>
                <div class="sizeBlock">
                <label>Size</label>
                <div class="textBlock">
                  <div class="slidecontainer">
                    <input type="range" step="0.1" min="13.3" max="100" [(ngModel)]="webStoryElementRef.width" (change)="sizeChange('width', $event)" class="slider countSl" id="sizeBox">
                  </div>
                </div>
                <label>Top Padding</label>
                <div class="textBlock">
                  <div class="slidecontainer">
                    <input type="range" step="0.1" min="1.25" max="10" [(ngModel)]="webStoryElementRef.topPadding" (change)="sizeChange('topPadding', $event)" class="slider countSl" id="topPad">
                  </div>
                </div>
                <label>Bottom Padding</label>
                <div class="textBlock">
                  <div class="slidecontainer">
                    <input type="range" step="0.1" min="1.25" max="10" [(ngModel)]="webStoryElementRef.bottomPadding" (change)="sizeChange('bottomPadding', $event)" class="slider countSl" id="botPad">
                  </div>
                </div>
              </div>
              </div>
              <label>Text</label>
              <div class="textBlock">
                <div class="dataField">
                  <select name="designFontFamily" [(ngModel)]="webStoryElementRef.fontFamily" (change)="changeFontFamily()" id="designFontFamily">
                    <option value="'Times New Roman', Times, serif">Times New Roman</option>
                    <option value="Arial, Helvetica, sans-serif">Arial</option>
                    <option value="Tahoma, sans-serif">Tahoma</option>
                    <option value="'Lucida Console', 'Courier New', monospace">Courier New</option>
                    <option value="Calibri, sans-serif">Calibri</option>
                  </select>
                </div>
                <div class="dataField">
                  <div class="fontSize">
                    <select name="designFontSize" [(ngModel)]="webStoryElementRef.fontSize" (change)="changeFontSize()" id="designFontSize">
                      <option value="10px">10</option>
                      <option value="11px">11</option>
                      <option value="12px">12</option>
                      <option value="13px">13</option>
                      <option value="14px">14</option>
                      <option value="15px">15</option>
                      <option value="16px">16</option>
                      <option value="17px">17</option>
                      <option value="18px">18</option>
                      <option value="19px">19</option>
                      <option value="20px">20</option>
                      <option value="21px">21</option>
                      <option value="22px">22</option>
                      <option value="23px">23</option>
                      <option value="24px">24</option>
                      <option value="25px">25</option>
                      <option value="26px">26</option>
                      <option value="27px">27</option>
                      <option value="28px">28</option>
                      <option value="32px">32</option>
                      <option value="36px">36</option>
                      <option value="40px">40</option>
                      <option value="44px">44</option>
                      <option value="48px">48</option>
                      <option value="52px">52</option>
                      <option value="56px">56</option>
                      <option value="60px">60</option>
                    </select>
                  </div>
                  <div class="fontWeight">
                    <select name="designFontWeight" [(ngModel)]="webStoryElementRef.fontStyle" (change)="changeFontStyle()" id="designFontWeight">
                      <option value="400">Light</option>
                      <option value="500">Normal</option>
                      <option value="700">Bold</option>
                      <option value="900">Bolder</option>
                    </select>
                  </div>
                </div>
                <div class="dataField">
                  <div class="alignBlock">
                    <ul>
                      <li [ngClass]="{'active':(webStoryElementRef?.currentTextboxOrButtonElements && (webStoryElementRef?.currentTextboxOrButtonElementIndex != null) && webStoryElementRef?.currentTextboxOrButtonElements[webStoryElementRef?.currentTextboxOrButtonElementIndex]?.textAlignment == 'left')}" (click)="changeTextAlignment('left')"><img src="assets/images/webstories/leftalign.svg"></li>
                      <li [ngClass]="{'active':(webStoryElementRef?.currentTextboxOrButtonElements && (webStoryElementRef?.currentTextboxOrButtonElementIndex != null) && webStoryElementRef?.currentTextboxOrButtonElements[webStoryElementRef?.currentTextboxOrButtonElementIndex]?.textAlignment == 'center')}" (click)="changeTextAlignment('center')"><img src="assets/images/webstories/centeralign.svg"></li>
                      <li [ngClass]="{'active':(webStoryElementRef?.currentTextboxOrButtonElements && (webStoryElementRef?.currentTextboxOrButtonElementIndex != null) && webStoryElementRef?.currentTextboxOrButtonElements[webStoryElementRef?.currentTextboxOrButtonElementIndex]?.textAlignment == 'right')}" (click)="changeTextAlignment('right')"><img src="assets/images/webstories/rightalign.svg"></li>
                    </ul>
                  </div>
                  <!--div class="fontStyleBlock">
                    <ul>
                      <li [ngClass]="{'active':(webStoryElementRef?.currentTextboxOrButtonElements && (webStoryElementRef?.currentTextboxOrButtonElementIndex != null) && webStoryElementRef?.currentTextboxOrButtonElements[webStoryElementRef?.currentTextboxOrButtonElementIndex]?.textTransform == 'uppercase')}" (click)="changeTextTransform('uppercase')"><img src="assets/images/webstories/TT1.svg"></li>
                      <li [ngClass]="{'active':(webStoryElementRef?.currentTextboxOrButtonElements && (webStoryElementRef?.currentTextboxOrButtonElementIndex != null) && webStoryElementRef?.currentTextboxOrButtonElements[webStoryElementRef?.currentTextboxOrButtonElementIndex]?.textTransform == 'lowercase')}" (click)="changeTextTransform('lowercase')"><img src="assets/images/webstories/TT2.svg"></li>
                      <li [ngClass]="{'active':(webStoryElementRef?.currentTextboxOrButtonElements && (webStoryElementRef?.currentTextboxOrButtonElementIndex != null) && webStoryElementRef?.currentTextboxOrButtonElements[webStoryElementRef?.currentTextboxOrButtonElementIndex]?.textTransform == 'capitalize')}" (click)="changeTextTransform('capitalize')"><img src="assets/images/webstories/TT3.svg"></li>
                    </ul>
                  </div-->
                </div>
                <div class="dataField">
                  <div class="colorBox">
                    <div class="fontColor">
                      <ul>
                        <li>
                          <!--label class="checkblock" tabindex="0">
                            <input id="designFontColorCheckBox" type="checkbox">
                            <span class="checkmark"></span>
                          </label-->
                          <input id="designFontColorCheckBox" type="checkbox" [checked]="(webStoryElementRef.fontColor != null)" (change)="setAsFontColor($event)">
                      </li>
                        <!--li><span class="color" style="background: #000000;"></span></li>
                        <li>Font Color</li>
                        <li><img src="assets/images/webstories/icon-md-color-filter.svg"></li-->
                        <input id="designFontColor" [disabled]="(webStoryElementRef.fontColor == null) ? true : false" [value]="webStoryElementRef.fontColor" [style.background]="webStoryElementRef.fontColor" [cpAlphaChannel]="'always'" [cpOutputFormat]="'hex'" [colorPicker]="webStoryElementRef.fontColor" (colorPickerChange)="changeFontColor($event)" (colorPickerClose)="closeColorPicker($event)"/>
                        <li>Font Color</li>
                      </ul>
                    </div>
                    <div class="borderColor">
                      <ul>
                        <li>
                          <!--label class="checkblock" tabindex="0">
                            <input id="designBorderColorCheckBox" type="checkbox">
                            <span class="checkmark"></span>
                          </label-->
                          <input id="designBorderColorCheckBox" type="checkbox" [checked]="(webStoryElementRef.borderColor != null)" (change)="setAsBorderColor($event)">
                        </li>
                        <!--li><span class="color" style="background: #53C17D;"></span></li>
                        <li>Border Color</li>
                        <li><img src="assets/images/webstories/icon-md-color-filter.svg"></li-->
                        <input id="designBorderColor" [disabled]="(webStoryElementRef.borderColor == null) ? true : false" [value]="webStoryElementRef.borderColor" [style.background]="webStoryElementRef.borderColor" [cpAlphaChannel]="'always'" [cpOutputFormat]="'hex'" [colorPicker]="webStoryElementRef.borderColor" (colorPickerChange)="changeBorderColor($event)" (colorPickerClose)="closeColorPicker($event)"/>
                        <li>Border Color</li>
                      </ul>
                    </div>
                    <div class="bgColor">
                      <ul>
                        <li>
                          <!--label class="checkblock" tabindex="0">
                            <input id="designBGColorCheckBox" type="checkbox">
                            <span class="checkmark"></span>
                          </label-->
                          <input id="designBGColorCheckBox" type="checkbox" [checked]="(webStoryElementRef.backgroundColor != null)" (change)="setAsBackgroundColor($event)">
                        </li>
                        <!--li><span class="color" style="background: #53C17D;"></span></li>
                        <li>BG Color</li>
                        <li><img src="assets/images/webstories/icon-md-color-filter.svg"></li-->
                        <input id="designBGColor" [disabled]="(webStoryElementRef.backgroundColor == null) ? true : false" [value]="webStoryElementRef.backgroundColor" [style.background]="webStoryElementRef.backgroundColor" [cpAlphaChannel]="'always'" [cpOutputFormat]="'hex'" [colorPicker]="webStoryElementRef.backgroundColor" (colorPickerChange)="changeBackgroundColor($event)" (colorPickerClose)="closeColorPicker($event)"/>
                        <li>BG Color</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <label>Border Style</label>
              <div class="borderBlock">
              <div class="dataField">
                <div class="borderWeight">
                  <select name="designBorderStyle" [(ngModel)]="webStoryElementRef.borderStyle" (change)="changeBorderStyle()" id="designBorderStyle">
                    <option value="solid">Solid</option>
                    <option value="dashed">Dashed</option>
                    <option value="dotted">Dotted</option>
                  </select>
                </div>
              </div>
              <div class="dataField">
                <div class="borderBox">
                    <ul>
                      <li [ngClass]="{'active':(webStoryElementRef?.currentTextboxOrButtonElements && (webStoryElementRef?.currentTextboxOrButtonElementIndex != null) && webStoryElementRef?.currentTextboxOrButtonElements[webStoryElementRef?.currentTextboxOrButtonElementIndex]?.borderLeft)}" (click)="changeBorderLeft()"><img src="assets/images/webstories/border1.svg"></li>
                      <li [ngClass]="{'active':(webStoryElementRef?.currentTextboxOrButtonElements && (webStoryElementRef?.currentTextboxOrButtonElementIndex != null) && webStoryElementRef?.currentTextboxOrButtonElements[webStoryElementRef?.currentTextboxOrButtonElementIndex]?.borderTop)}" (click)="changeBorderTop()"><img src="assets/images/webstories/border2.svg"></li>
                      <li [ngClass]="{'active':(webStoryElementRef?.currentTextboxOrButtonElements && (webStoryElementRef?.currentTextboxOrButtonElementIndex != null) && webStoryElementRef?.currentTextboxOrButtonElements[webStoryElementRef?.currentTextboxOrButtonElementIndex]?.borderRight)}" (click)="changeBorderRight()"><img src="assets/images/webstories/border3.svg"></li>
                      <li [ngClass]="{'active':(webStoryElementRef?.currentTextboxOrButtonElements && (webStoryElementRef?.currentTextboxOrButtonElementIndex != null) && webStoryElementRef?.currentTextboxOrButtonElements[webStoryElementRef?.currentTextboxOrButtonElementIndex]?.borderBottom)}" (click)="changeBorderBottom()"><img src="assets/images/webstories/border4.svg"></li>
                      <li [ngClass]="{'active':(webStoryElementRef?.currentTextboxOrButtonElements && (webStoryElementRef?.currentTextboxOrButtonElementIndex != null) && webStoryElementRef?.currentTextboxOrButtonElements[webStoryElementRef?.currentTextboxOrButtonElementIndex]?.border)}" (click)="changeBorder()"><img src="assets/images/webstories/border5.svg"></li>
                    </ul>
                </div>
              </div>
              </div>
              <label>Border size</label>
              <div class="radiusBlock">
                <div class="dataField">
                  <select name="designCornerRadius" [(ngModel)]="webStoryElementRef.cornerRadius" (change)="changeCornerRadius()" id="designCornerRadius">
                    <option value="1px">1px</option>
                    <option value="2px">2px</option>
                    <option value="3px">3px</option>
                    <option value="4px">4px</option>
                    <option value="5px">5px</option>
                    <option value="6px">6px</option>
                  </select>
                </div>
              </div>
              <!-- <label>Button URL</label>
              <div class="dataField">
                <input type="text" id="designButtonUrl" [readonly]="!storyEditMode" [(ngModel)]="webStoryElementRef.buttonUrl" (change)="updateWebStoryButtonUrl()" [class]="'textBox dTBox'" placeholder="Add Button URL.">
              </div> -->

            </div>

            <div class="seBl creditBox" *ngIf="!webStoryElementRef?.emptyWebStory && webStoryElementRef?.currentSlideElement">
              <label>Slide Word Count<span class="countSlideWord">{{webStoryElementRef.currentSlideWords}}</span></label>
              <!-- <div class="dataField">
                <input class="textBox" placeholder="Total Word Count" type="text" disabled>
              </div> -->
            </div>
            <div class="seBl creditBox" *ngIf="!webStoryElementRef?.emptyWebStory && webStoryElementRef?.currentSlideElement">
              <label>Credit Info</label>
              <div class="dataField">
                <input id="slideCreditInfo" class="textBox" [readonly]="!storyEditMode" [(ngModel)]="webStoryElementRef.currentSlideElement.creditInfo" (focus)="editData('creditInfo')" (blur)="updateCreditInfo($event)" placeholder="Add Credit Info" type="text">
              </div>
            </div>
            <div class="metaDesignBlock" *ngIf="!webStoryElementRef?.emptyWebStory && webStoryElementRef?.currentSlideElement">
              <label class="head">Seo Block</label>
            <div class="seBl">
              <label>Alt Text</label>
              <div class="dataField">
                <input id="slideAltText" class="textBox" [readonly]="!storyEditMode" [(ngModel)]="webStoryElementRef.currentSlideElement.altText" (focus)="editData('altText')" (blur)="updateAltText($event)" placeholder="Add Slide Alt Text Here" type="text">
              </div>
            </div>
            <div class="seBl">
              <label>Slide Meta Title</label>
              <div class="dataField">
                <input id="slideMetaTitle" class="textBox" [readonly]="!storyEditMode" [(ngModel)]="webStoryElementRef.currentSlideElement.metaTitle" (focus)="editData('metaTitle')" (blur)="updateSlideMetaTitle($event)" placeholder="Add Slide Meta Title Here" type="text">
              </div>
            </div>
            <div class="seBl">
              <label>Slide Meta Description</label>
              <div class="dataField">
                <textarea id="slideMetaDescription" class="textBox" [readonly]="!storyEditMode" [(ngModel)]="webStoryElementRef.currentSlideElement.metaDescription" (focus)="editData('metaDescription')" (blur)="updateSlideMetaDescription($event)" placeholder="Enter Slide Meta Description Here…" tabindex="0" type="text"></textarea>
              </div>
            </div>
            <div class="seBl">
              <label>Key Words</label>
              <!--div class="dataField">
                <input class="textBox" placeholder="Add Slide Keyword Here" type="text">
              </div-->
              <div class="dataField">
                <tags-creator [data]="webStoryElementRef?.currentSlideElement?.keywords" [editable]="!storyEditMode" [displayText]="'Add Slide Keyword Here'"
                  (clickfn)="customFunc($event)" (changefn)="updateSlideKeywords($event)" (focusedfn)="catchTagFocus($event)"
                  [storyTags]="true" [marketSuggest]="automatedMarketFlag" [enableDrag]="enableKeywordsDrag"></tags-creator>
              </div>
            </div>
          </div>
            </div>
        </div>
        </ng-container>
        <ng-container *ngSwitchCase="'animation'">
          <div class="tabcontent" id="animation" tabindex="0" style="display: block;">
            <div class="animationBlock" [ngClass]="{'disable-action':!storyEditMode}">
              <label>Effect</label>
              <div class="dataField pdBot15">
                <select id="animationSelect" (change)="selectAnimation($event)">
                  <option [selected]="storyData?.slideAnimation == 'None'">None</option>
                  <option [selected]="storyData?.slideAnimation == 'Fade In'">Fade In</option>
                  <option [selected]="storyData?.slideAnimation == 'Fade Out'">Fade Out</option>
                  <option [selected]="storyData?.slideAnimation == 'Ease In'">Ease In</option>
                  <option [selected]="storyData?.slideAnimation == 'Ease Out'">Ease Out</option>
                </select>
              </div>
              <!-- <div [ngClass]="{'disableDesign':(webStoryElementRef?.currentTextboxOrButtonElementIndex != null && webStoryElementRef?.currentTextboxOrButtonElementIndex != undefined)}">
                <div class="bgDisableClass"></div> -->
                <label>Title</label>
                <div class="dataField">
                  <input id="storyHeadline" type="text" [class]="'textBox dTBox'" [readonly]="!storyEditMode" [(ngModel)]="headline" (change)="updateWebStoryHeadline()"  placeholder="Add Web Story Title.">
                </div>
                
                <ng-container *ngIf="storyData.type === 'web-story' && disabledMetaFields.indexOf('urlHeadline') === -1">
                  <li>
                    <label>URL Headline</label>
                    <!-- <div class="dataField"> -->
                      <input id="storyHeadline" [class]="'textBox dTBox'" [readonly]="!storyEditMode" [(ngModel)]="storyData.urlHeadline"  type="text" class="textBox"
                        placeholder="Add URL Headline here">
                    <!-- </div> -->
                  </li>
                </ng-container>
                <label>Summary</label>
                <div class="dataField">
                  <input id="storySummary" type="text" [class]="'textBox dTBox'" [readonly]="!storyEditMode" [(ngModel)]="summary" (change)="updateWebStorySummary()"  placeholder="Add Web Story Summary.">
                </div>
                <label for="useAsTemplate">Use as template
                <input type="checkbox" id="useAsTemplate" [disabled]="!storyEditMode ? true : false" class="useAsTemplate" name="useAsTemplate" [checked]="storyData.webStoryTemplate" (change)="setAsTemplate($event)">
                </label>
                <label>Cover Image</label>
                <div class="borderBlock">
                <div class="dataField">

                  <div [ngClass]="{'disable-action':!storyEditMode}" class="uploadSection coverImage">
                    <div class="blockContain">
                      <div class="uploadimage">
                        <div class="upload-btn-wrapper" *ngIf="storyData.coverImageUrl == undefined || storyData.coverImageUrl == null">
                          <span class="btn" (click)="uploadCoverImage($event)">Add Template Cover Image</span>
                          <!--span class="btn">Add Template Cover Image</span>
                          <input id="addCoverImage" accept="image/*" name="myfile" type="file" (change)="uploadCoverImage($event)"-->
                        </div>
                        <div tabindex="0" id="changeCoverImage" class="upload-btn-wrapper" (click)="lightBoxCoverImage()" *ngIf="storyData.coverImageUrl != undefined && storyData.coverImageUrl != null">
                          <span class="btn">Change Template Cover Image</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="lightBox block lightBoxCoverImage" *ngIf="isLightboxCoverImage">
                    <div class="headerLight">
                      <div class="close fl spImg" (click)="closeLightBoxCoverImage()"></div>
                    </div>
                    <div class="lightContent">
                      <div class="websiteLogo">
                        <img src="{{storyData.coverImageUrl}}">
                      </div>
                      <div class="uploadSection coverImage">
                        <div class="blockContain">
                          <div class="uploadimage">
                            <div class="upload-btn-wrapper">
                              <span class="btn" (click)="uploadCoverImage($event)">Upload New Cover Image</span>
                              <!--span class="btn">Upload New Cover Image</span>
                              <input accept="image/*" name="myfile" type="file" (change)="uploadCoverImage($event)"-->
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--div class="textBlock">
                        <label>Template Name</label>
                        <input type="text" class="textBox">
                      </div-->
                      <div class="btnAction">
                        <button class="createSlideBtn blue" (click)="removeCoverImage()">Remove Cover Image</button>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
                <label>Upload Logo</label>
                <div class="logoBlock">
                <div class="dataField" [ngClass]="{'disable-action':!storyEditMode}">
                  <ul>
                    <li><img tabindex="0" id="addLogoImage" (click)="lightBoxLogo()" src="{{logoUrl}}"></li>
                    <!--li><img src="assets/images/webstories/logoHT.png"></li-->
                  </ul>
                </div>
                <div class="lightBox block lightBoxLogo" *ngIf="isLightboxLogo">
                  <div class="headerLight">
                    <div class="close fl spImg" (click)="closeLightBoxLogo()"></div>
                  </div>
                  <div class="lightContent">
                    <div class="websiteLogo"><img src="{{logoUrl}}"></div>
                    <div class="logoPosition">
                      <ul>
                        <li>
                          <label class="radioBlock">
                            <input type="radio" name="top" value="Top-Left" [checked]="webStoryElementRef?.currentSlideElement?.logoPosition=='Top-Left'" (change)="selecttLogoPosition($event)"/>
                            <span class="radiomark"></span>Top-Left
                          </label>
                        </li>
                        <li>
                          <label class="radioBlock">
                            <input type="radio" name="top" value="Bottom-Left" [checked]="webStoryElementRef?.currentSlideElement?.logoPosition=='Bottom-Left'" (change)="selecttLogoPosition($event)"/>
                            <span class="radiomark"></span>Bottom-Left
                          </label>
                        </li>
                        <li>
                          <label class="radioBlock">
                            <input type="radio" name="top" value="Top-Right" [checked]="webStoryElementRef?.currentSlideElement?.logoPosition=='Top-Right'" (change)="selecttLogoPosition($event)"/>
                            <span class="radiomark"></span>Top-Right
                          </label>
                        </li>
                        <li>
                          <label class="radioBlock">
                            <input type="radio" name="top" value="Bottom-Right" [checked]="webStoryElementRef?.currentSlideElement?.logoPosition=='Bottom-Right'" (change)="selecttLogoPosition($event)"/>
                            <span class="radiomark"></span>Bottom-Right
                          </label>
                        </li>
                      </ul>
                    </div>
                    <div class="btnAction">
                      <button class="createSlideBtn blue" (click)="setLogoPosition()">Add Logo on Slide</button>
                    </div>
                  </div>
                </div>
                </div>
              <!-- </div> -->
            </div>
        </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
 </ng-container>
<!-- </div> -->

<ng-container *ngIf="!showWebStoriesTab">
    <div [class]="!togglePreview ? 'thirdContainScroll' : 'thirdContainScroll'">
      <div class="thirdContainer marb20">
        <ng-container *ngIf="disabledPreviews.length < 2">
        <div class="preview padb20 fl100">Preview
          <span class="right fr">
            <a #preivewMobile tabindex="0" (click)="openPreview('mobile')" *ngIf="disabledPreviews.indexOf('mobile') === -1">
              <span id="previewMobileButton" class="molineLink">
                <i class="icon-mobile"></i>Mobile</span>
            </a>
            <a #preivewDesktop tabindex="0" (click)="openPreview('desktop')" *ngIf="disabledPreviews.indexOf('desktop') === -1">
              <span id="previewDesktopButton" class="desktopLink">
                <i class="icon-desktop"></i>Desktop</span>
            </a>
          </span>
        </div>
        </ng-container>
        <ng-container *ngIf="enableAMPValidation">
        <div class="ampValidatorBlock">

          <h4>AMP Validator <span [class]="ampButtonColor" (click)="ampValidation()"></span></h4>
          <span *ngIf="showAmpDetails" class="showDetails" (click)="openAmpValidate()">Show Details</span>
        </div>
      </ng-container>
      <!--  <ng-container *ngIf="!showLanuageTab">
        <div class="tabs tabBlue">
            <span class="tablinks" (click)="togglePreview = true ; languageTrans=false" [ngClass]="{'active': togglePreview}">Meta</span>
            <span class="tablinks" (click)="togglePreview = false ; languageTrans=true" [ngClass]="{'active': !togglePreview}">Language</span>
          </div>

        </ng-container>  -->

        <!--
        <div class="tabcontent" id="language" *ngIf="!togglePreview">
            <div class="translatorview">
              <h2>{{originalStory?.headline}}</h2>
              <h3>{{(originalStory && originalStory.story && originalStory.story[0] && originalStory.story[0].summary) ? originalStory.story[0].summary : ''}}</h3>

              <p [innerHTML]='(originalStory && originalStory.story && originalStory.story[0] && originalStory.story[0].content) ? originalStory.story[0].content: "" '></p>
            </div>
        </div> -->
        <div class="tabcontent" id="meta">
        <div class="usermeta blocks marb20">
          <div class="head">Metadata</div>
          <div class="form" *ngIf="this.storyType !== 'deadlink'">

            <ul class="bylineBlock">
              <li [class]="setCheckForErrorIndication(4) ? 'errorInput' : ''">
                <label>By Line</label>
                <div class="dataField">
                  <tags-creator #firstMeta [idInput]="'inputAddByLineText'" [autoSuggest]="true" [autocompletelist]="authorsSuggestion" (focusoutfn)="disableInnerFocus($event)"
                    [editable]="!storyEditMode" [data]="getCurrentDataSet(authorFieldSet)" [setFocus]="innerFocusFlag"
                    [displayText]="authorFieldSet.inputPlaceholder" (clickfn)="customFunc($event)" (changefn)="setMetadata($event, authorFieldSet)"
                    (focusedfn)="catchTagFocus($event)" [isDataKeyValuePair]="isAuthorIdEnabled"></tags-creator>
                </div>
              </li>
              <ng-container *ngIf="disabledMetaFields.indexOf('postedBy') === -1">
                <li *ngIf="disableElement('meta-more') ? storyData.metadata.postedByList ? storyData.metadata.postedByList.length > 0 : false : true">
                  <label>Posted By</label>
                  <div class="dataField">
                    <tags-creator #firstMeta [autoSuggest]="true" [autocompletelist]="authorsSuggestion" (focusoutfn)="disableInnerFocus($event)"
                      [editable]="!storyEditMode" [data]="getCurrentDataSet(postedByFieldSet)" [setFocus]="innerFocusFlag"
                      [displayText]="postedByFieldSet.inputPlaceholder" (clickfn)="customFunc($event)" (changefn)="setMetadata($event, postedByFieldSet)"
                      (focusedfn)="catchTagFocus($event)" [isDataKeyValuePair]="isAuthorIdEnabled"></tags-creator>
                  </div>
                </li>
              </ng-container>
              <ng-container *ngFor="let field of fieldSet">
                <ng-container *ngIf="disabledMetaFields.indexOf(field.metadataModelId) === -1">
                <li *ngIf="disableElement('meta-more') ? storyData.metadata[field.metadataModelId] ? storyData.metadata[field.metadataModelId].length > 0 : false : true">
                  <ng-container *ngIf="!field.auto">
                    <label>{{field.labelName}}</label>

                    <div class="dataField">
                      <ul id="myAuthors">
                        <tags-creator [data]="getCurrentDataSet(field)" [editable]="!storyEditMode" [displayText]="field.inputPlaceholder"
                          (clickfn)="customFunc($event)" (changefn)="setMetadata($event, field)"
                          (focusedfn)="catchTagFocus($event)"></tags-creator>
                      </ul>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="field.auto">
                    <label>{{field.labelName}}</label>
                    <div class="dataField">
                      <ul id="myAuthors">
                        <tags-creator [autoSuggest]="true" [autocompletelist]="authorsSuggestion" [setFocus]="field.focusFlag"
                          [editable]="!storyEditMode" [data]="getCurrentDataSet(field)" [displayText]="field.inputPlaceholder"
                          (clickfn)="customFunc($event)" (changefn)="setMetadata($event, field)"
                          (focusedfn)="catchTagFocus($event)" [isDataKeyValuePair]="isAuthorIdEnabled"></tags-creator>
                      </ul>
                    </div>
                  </ng-container>
                </li>
              </ng-container>
              </ng-container>
              <ng-container *ngIf="disabledMetaFields.indexOf('column') === -1">
              <li *ngIf="(storyType === 'liveblog' || storyType === 'gallery' || storyType === 'video' || storyData.metadata.sponsored || storyData.metadata.breakingNews || storyData.metadata.bigStory) ? false : (!insideColumn ? (disableElement('meta-more') ? (storyData.metadata.column ? (storyData.metadata.column.trim() !== '') : false) : true) : true)">
                <label>Column</label>
                <div class="dataField">
                  <input type="text" [class]="'textBox'" #columnInput [readonly]="!storyEditMode" placeholder="Add Column here."
                    [(ngModel)]="columnQuery" (keyup)="filterAutoCompleteUp($event ,'column')" (keydown)="filterAutoCompleteDown($event ,'column')"
                    (focus)="focusInSuggest('column')" (focusout)="false">
                  <ng-container *ngIf="storyEditMode">
                    <div #columnList class="autosuggestion block" *ngIf="filteredColumnSuggestion && filteredColumnSuggestion.length > 0">
                      <ul *ngFor="let item of filteredColumnSuggestion; let i = index">
                        <li (click)="selectAutoComplete('column', item)" [class.active]="i === currentSelection">
                          <span class="name">{{item}}</span>
                        </li>
                      </ul>
                    </div>
                    <ng-container *ngIf="insideColumn && (1 > filteredColumnSuggestion.length)">
                      <div class="autosuggestion block">
                        <ul>
                          <li>
                            <span class="name">No Results</span>
                          </li>
                        </ul>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </li>
              </ng-container>
              <ng-container *ngIf="disabledMetaFields.indexOf('attribution') === -1">
                <li *ngIf="(storyType === 'liveblog' || storyType === 'gallery' || storyType === 'video' || storyData.metadata.sponsored || storyData.metadata.breakingNews || storyData.metadata.bigStory) ? false : (!insideAttribution ? (disableElement('meta-more') ? (storyData.metadata.attribution ? (storyData.metadata.attribution.trim() !== '') : false) : true) : true)">
                    <label>Attribution</label>
                    <div class="dataField">
                      <input type="text" #attributionInput [class]="'textBox'" [readonly]="!storyEditMode" placeholder="Add Attribution here."
                        [(ngModel)]="attributionQuery" (keyup)="filterAutoCompleteUp($event ,'attribution')" (keydown)="filterAutoCompleteDown($event ,'attribution')"
                        (focus)="focusInSuggest('attribution')" (focusout)="false">
                        <ng-container *ngIf="insideAttribution && storyEditMode">
                          <div #attributionList class="autosuggestion block" *ngIf="filteredAttributionSuggestion && filteredAttributionSuggestion.length > 0">
                            <ul *ngFor="let item of filteredAttributionSuggestion; let i = index">
                              <li (click)="selectAutoComplete('attribution', item)" [class.active]="i === currentSelection">
                                <span class="name">{{item}}</span>
                              </li>
                            </ul>
                          </div>
                          <ng-container *ngIf="insideAttribution && (filteredAttributionSuggestion && 1 > filteredAttributionSuggestion.length)">
                            <div class="autosuggestion block">
                              <ul>
                                <li>
                                  <span class="name">No Results</span>
                                </li>
                              </ul>
                            </div>
                          </ng-container>
                        </ng-container>
                    </div>
                </li>
                </ng-container>
              <ng-container *ngIf="isMoreButtonEnabled">
              <li>
                <span [class]="(disableElement('meta-more') ? 'more' : 'less') + ' spImg_story'" (click)="metaToggleFlag = !metaToggleFlag">
                  {{disableElement('meta-more') ? 'more' : 'less'}}
                </span>
              </li>
            </ng-container>
            </ul>
            <ul>
              <li [class]="setCheckForErrorIndication(4) ? 'errorInput' : ''">
                <label>Agency</label>
                <div class="dataField">
                  <input type="text" class="textBox" #agencyInput [readonly]="!storyEditMode" placeholder="Add Agency here."
                    [(ngModel)]="agencyQuery" (keyup)="filterAutoCompleteUp($event ,'agency')" (keydown)="filterAutoCompleteDown($event ,'agency')"
                    (focus)="focusInSuggest('agency')" (focusout)="false">
                  <ng-container *ngIf="storyEditMode">
                    <div #agencyList class="autosuggestion block" *ngIf="filteredAgencySuggestion && filteredAgencySuggestion.length > 0">
                      <ul *ngFor="let item of filteredAgencySuggestion; let i = index">
                        <li (click)="selectAutoComplete('agency', item)" [class.active]="i === currentSelection">
                          <span class="name">{{item}}</span>
                          <!-- <span class="emails">(nitesh.rawal@htdigital.in)</span> -->
                        </li>
                      </ul>
                    </div>
                    <ng-container *ngIf="insideAgency && (1 > filteredAgencySuggestion.length)">
                      <div class="autosuggestion block">
                        <ul>
                          <li>
                            <span class="name">No Results</span>
                          </li>
                        </ul>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </li>
              <li [class]="setCheckForErrorIndication(2) ? 'errorInput' : ''">
                <label>
                  Section
                </label>
                <div class="dataField">
                  <input type="text" class="textBox"  #sectionInput [readonly]="!storyEditMode" placeholder="Add Section here."
                    [(ngModel)]="sectionQuery" (keyup)="filterAutoCompleteUp($event ,'section')" (keydown)="filterAutoCompleteDown($event ,'section')"
                    (focus)="focusInSuggest('section')" (focusout)="false">
                  <ng-container *ngIf="storyEditMode">
                    <div #sectionList class="autosuggestion block" id="inputAddSectionActiveText" *ngIf="filteredSectionSuggestion && filteredSectionSuggestion.length > 0 && insideSection">
                      <ul *ngFor="let item of filteredSectionSuggestion;let i = index">
                        <li (click)="selectAutoComplete('section', item)" [class.active]="i === currentSelection">
                          <span class="name">{{item}}</span>
                          <!-- <span class="emails">(nitesh.rawal@htdigital.in)</span> -->
                        </li>
                      </ul>
                    </div>
                    <ng-container *ngIf="insideSection && (1 > filteredSectionSuggestion.length)">
                      <div class="autosuggestion block">
                        <ul>
                          <li>
                            <span class="name">No Results</span>
                          </li>
                        </ul>
                      </div>
                    </ng-container>
                  </ng-container>

                </div>
              </li>
              <li [class]="setCheckForErrorIndication(3) ? 'errorInput' : ''">
                <label>Sub-section
                </label>

                <div class="dataField">
                  <input type="text" class="textBox" #subSectionInput [readonly]="!storyEditMode && flagForSubSection"
                    placeholder="Add SubSection here." id="inputAddSubSectionText" [(ngModel)]="subSectionQuery" (keyup)="filterAutoCompleteUp($event ,'subSection')"
                    (keydown)="filterAutoCompleteDown($event ,'subSection')" (focus)="focusInSuggest('subSection')"
                    (focusout)="false">
                  <ng-container *ngIf="storyEditMode">
                    <div #subSectionList class="autosuggestion block" *ngIf="filteredSubSectionSuggestion && filteredSubSectionSuggestion.length > 0">
                      <ul *ngFor="let item of filteredSubSectionSuggestion; let i = index">
                        <li (click)="selectAutoComplete('subSection', item)" [class.active]="i === currentSelection">
                          <span class="name">{{item}}</span>
                          <!-- <span class="emails">(nitesh.rawal@htdigital.in)</span> -->
                        </li>
                      </ul>
                    </div>
                    <ng-container *ngIf="insideSubSection && (1 > filteredSubSectionSuggestion.length)">
                      <div class="autosuggestion block">
                        <ul>
                          <li>
                            <span class="name">No Results</span>
                          </li>

                        </ul>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </li>
              <!-- Subsection-l2 -->
              <li>
                <label>Sub section l2
                </label>

                <div class="dataField">
                  <input type="text" class="textBox" #subSectionL2Input [readonly]="!storyEditMode"
                    placeholder="Add Sub sub section here." id="inputAddSubSectionText" [(ngModel)]="subSectionL2Query" (keyup)="filterAutoCompleteUp($event ,'subSectionL2')"
                    (keydown)="filterAutoCompleteDown($event ,'subSectionL2')" (focus)="focusInSuggest('subSectionL2')"
                    (focusout)="false">
                  <ng-container *ngIf="storyEditMode">
                    <div #subSectionList class="autosuggestion block" *ngIf="filteredSubSectionL2Suggestion && filteredSubSectionL2Suggestion.length > 0">
                      <ul *ngFor="let item of filteredSubSectionL2Suggestion; let i = index">
                        <li (click)="selectAutoComplete('subSectionL2', item)" [class.active]="i === currentSelection">
                          <span class="name">{{item}}</span>
                          <!-- <span class="emails">(nitesh.rawal@htdigital.in)</span> -->
                        </li>
                      </ul>
                    </div>
                    <ng-container *ngIf="!filteredSubSectionL2Suggestion || (insideSubSectionL2 && (1 > filteredSubSectionL2Suggestion.length))">
                      <div class="autosuggestion block">
                        <ul>
                          <li>
                            <span class="name">No Results</span>
                          </li>

                        </ul>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </li>
              <!--  -->
              <ng-container *ngIf="secondarySectionsNeeded()">
                <li>
              <app-secondary-section [section]="storyData.metadata.section" [secondarySectionData]="storyData.metadata.secondarySections" [sectionSuggestionList]="sectionSuggestion"
              [subsectionSuggestionList]="subSectionSuggestion" [storyEditMode]="storyEditMode" [listOfAllSubsections]="allSubSections"
              (secondarySectionChanged)="secondarySectionChangesHandler($event)"></app-secondary-section>
              </li>
            </ng-container>
            <ng-container *ngIf="disabledMetaFields.indexOf('topic') === -1">
              <li>
                <label>Topic</label>
                <div class="dataField">
                  <tags-creator [autoSuggest]="true" [autocompletelist]="[]" [data]="storyData.metadata.topic"
                    [editable]="!storyEditMode" [idInput]="'inputAddTopicText'" [displayText]="'Enter text to search Topics..'" (clickfn)="customFunc($event)"
                    (changefn)="getNewTopicToAdd($event)" (focusedfn)="catchTagFocus($event)" [isTopicFlag]="true"></tags-creator>
                  </div>
              </li>
            </ng-container>
              <li [class]="setCheckForErrorIndication(9) ? 'errorInput' : ''">
                <label>Keywords</label>
                <div class="dataField">
                  <tags-creator [data]="storyData.metadata.keywords" [editable]="!storyEditMode" [displayText]="'Add keywords here..'"
                    (clickfn)="customFunc($event)" [idInput]="'inputAddKeywordText'" (changefn)="storyData.metadata.keywords = $event" (focusedfn)="catchTagFocus($event)"
                    [storyTags]="true" [marketSuggest]="automatedMarketFlag" [enableDrag]="enableKeywordsDrag"
                    (keypress)="specialCharBlock($event)"
                    ></tags-creator>
                    <ng-container *ngIf="isRecosense">
                      <p (click)="getKeywordsForStory()" class="moretags">
                        <a>Get Keywords</a>
                        </p>
                    </ng-container>

                </div>

              </li>
              <ng-container *ngIf="disabledMetaFields.indexOf('tags') === -1">
              <li>
                <label>Tags</label>
                <div class="dataField">
                  <tags-creator [data]="storyData.metadata.tags" [editable]="!storyEditMode" [displayText]="'Add Tags here..'"
                    [suggestions]="suggestTags" (suggestionAddfn)="removeTagFromSuggest($event)" (clickfn)="customFunc($event)"
                    (changefn)="getNewTagsToAdd($event)" (focusedfn)="catchTagFocus($event)" [storyTags]="true"
                    (keypress)="specialCharBlock($event)"
                    ></tags-creator>

                  <p *ngIf="storyEditMode && getTagsEnable()" (click)="getTagsForStory()" class="moretags">
                    <a>{{(suggestTagsTemp.length > 0) ? 'more tags' : 'get tags'}}</a>
                  </p>
                </div>
              </li>
              </ng-container>
              <ng-container *ngIf="disabledMetaFields.indexOf('source') === -1">
              <li>
                <label>Source</label>
                <div class="dataField" >
                    <label class="radioBlock" *ngFor="let item of sourceList">
                        <input type="radio" name="options"
                        [checked]="item === storyData.metadata.storyType"
                        (click)="setSource(item)" />
                        <span class="radiomark"></span>
                        {{item | titlecase}}
                    </label>
                </div>
              </li>
              </ng-container>
              <ng-container *ngIf="isPrimaryLocationEnabled()">
                <li [class]="setCheckForErrorIndication(13) ? 'errorInput' : ''">
                  <label>Location</label>
                  <div class="dataField">
                    <input type="text" class="textBox" #primaryLocationInput [readOnly]="!storyEditMode || (storyData.metadata && storyData.metadata.status === 'PUBLISHED')" placeholder="Add Location here.."
                      [(ngModel)]="primaryLocationQuery" (keyup)="filterAutoCompleteUp($event ,'primaryLocation')" (keydown)="filterAutoCompleteDown($event ,'primaryLocation')"
                      (focus)="focusInSuggest('primaryLocation')" (focusout)="false">
                    <ng-container *ngIf="storyEditMode && storyData.metadata && storyData.metadata.status !== 'PUBLISHED'">
                      <div #primaryLocationList class="autosuggestion block" *ngIf="filteredPrimaryLocationSuggestion && filteredPrimaryLocationSuggestion.length > 0">
                        <ul *ngFor="let item of filteredPrimaryLocationSuggestion; let i = index">
                          <li (click)="selectAutoComplete('primaryLocation', item)" [class.active]="i === currentSelection">
                            <span class="name">{{item.toLowerCase()}}</span>
                            <!-- <span class="emails">(nitesh.rawal@htdigital.in)</span> -->
                          </li>
                        </ul>
                      </div>
                      <ng-container *ngIf="insidePrimaryLocation && (1 > filteredPrimaryLocationSuggestion.length)">
                        <div class="autosuggestion block">
                          <ul>
                            <li>
                              <span class="name">No Results</span>
                            </li>
                          </ul>
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </li>
                <li>
                  <label>Secondary Location</label>
                  <div class="dataField">
                    <tags-creator [autoSuggest]="true" [autocompletelist]="getLocationList()"
                          [editable]="!storyEditMode" [data]="storyData.metadata.location" [displayText]="'Add Secondary Location here..'"
                          (clickfn)="customFunc($event)" (changefn)="storyData.metadata.location = $event"
                          (focusedfn)="catchTagFocus($event)" [noMinReq]="true"></tags-creator>
                  </div>
                </li>
              </ng-container>
              <ng-container *ngIf="!isPrimaryLocationEnabled() && !isLocationDisabled() && (disabledMetaFields.indexOf('location') === -1)">
                <li>
                  <label>Location</label>
                  <div class="dataField">
                    <tags-creator [data]="storyData.metadata.location" [editable]="!storyEditMode" [idInput]="'inputAddLocationText'" [displayText]="'Add Location here..'"
                      (clickfn)="customFunc($event)" (changefn)="storyData.metadata.location = $event" (focusedfn)="catchTagFocus($event)"></tags-creator>
                  </div>
                </li>
              </ng-container>
              <ng-container *ngIf="disabledMetaFields.indexOf('canonicalUrl') === -1">
              <li>
                <label>Canonical URL</label>
                <div class="dataField">
                  <input [readonly]="!storyEditMode || isCanonicalReadoOnly" [(ngModel)]="storyData.metadata.canonicalUrl" type="text" class="textBox"
                    placeholder="Add Canonical URL here">
                </div>
              </li>
            </ng-container>
            <ng-container *ngIf="domainConfig['config']['story']['seoUrl']">
              <li>
                <label>SEO URL</label>
                <div class="dataField">
                  <input id="inputAddSeoUrlText" [readonly]="!storyEditMode || storyData.metadata.status == 'PUBLISHED'" [ngModel]="getSeoURL()" (ngModelChange)="updateSeoURL($event)" type="text" class="textBox"
                    placeholder="Add SEO URL here">
                </div>
              </li>
            </ng-container>
            <ng-container *ngIf="disabledMetaFields.indexOf('externalUrl') === -1">
              <li>
                <label>External URL</label>
                <div class="dataField">
                  <input id="inputAddExternalUrlText" [readonly]="!storyEditMode" [(ngModel)]="storyData.metadata.externalUrl" type="text" class="textBox"
                    placeholder="Add External URL here">
                </div>
              </li>
            </ng-container>
            <ng-container *ngIf="domainConfig['config']['story']['metaTitle']">
              <li>
                <label>Meta Title</label>
                <div class="dataField">
                  <input id="inputAddMetaTitleText" [readonly]="!storyEditMode" [disabled]="ismetaTitle" [ngModel]="getMetaTitle()" (ngModelChange)="updateMetaTitle($event)" type="text" class="textBox"
                    placeholder="Add meta title here">
                </div>
              </li>
            </ng-container>
            <ng-container *ngIf="domainConfig['config']['story']['metaDescription']">
              <li>
                <label>Meta Description</label>
                <div class="dataField">
                  <textarea type="text" class="textBox" [ngModel]="getMetaDescription()" [disabled]="ismetaDescription" (ngModelChange)="updateMetaDescription($event)" placeholder="Enter meta description here…" tabindex="0" cdkTextareaAutosize></textarea>
                </div>
              </li>
            </ng-container>
            <ng-container>
              <li>
                <label>Copy from Headline and Summary</label>
                <div class="dataField">
                  <label class="checkblock" tabindex="0" (keydown)="callToggles($event, 'copyFromHeadline')">
                    <input type="checkbox" (click)="toggleSwitch('copyFromHeadline')"
                      [checked]="storyData.metadata.copyFromHeadline">
                    <span class="checkmark"></span>
                  </label>
                </div>
              </li>
            </ng-container>

            <div class="seBl" *ngIf="storyType === 'video'">
              <label>Duration</label>
              <div class="dataField dataFieldAdd">
                <!-- <textarea maxlength="2" class="textBoxSmall" style="width: 48%; float: left;"  placeholder="Hours" tabindex="0" type="text" (keydown)="validateKeyPressForNumberOnlyField($event)" (keyup)="validateMaxPositionValue($event)"></textarea>
                <textarea maxlength="2" class="textBoxSmall" style="width: 48%; float: right;"  placeholder="Minutes" tabindex="0" type="text" (keydown)="validateKeyPressForNumberOnlyField($event)" (keyup)="validateMaxPositionValue($event)"></textarea> -->

                <span class="spaceWidth"><textarea maxlength="2" [(ngModel)]="minuteMeta" class="textBoxSmall"  placeholder="Minutes" tabindex="0" type="text" (keydown)="changeCheck($event, 'minute')" (keyup)="durationSet()"></textarea>Minutes</span>
                <span class="spaceWidth"><textarea maxlength="2" [(ngModel)]="secondMeta" class="textBoxSmall"   placeholder="Seconds" tabindex="0" type="text" (keydown)="changeCheck($event, 'seconds')" (keyup)="durationSet()"></textarea>Seconds</span>

              </div>
            </div>
           
<!-- Content Bucket -->
<li *ngIf="enableContentBucketInput && enableContentBucketStories.indexOf(storyType)>-1">
  <label>Content Bucket</label>
  <div class="dataField">
    <input type="text" class="textBox" #contentBucketInput [readonly]="!storyEditMode" placeholder="Add Content here."
      [(ngModel)]="contentBucketQuery" (keyup)="filterAutoCompleteUp($event ,'contentBucket')" (keydown)="filterAutoCompleteDown($event ,'contentBucket')"
      (focus)="focusInSuggest('contentBucket')" (focusout)="false">
    <ng-container *ngIf="storyEditMode">
      <div #contentBucketList class="autosuggestion block" *ngIf="filteredContentBucketSuggestion && filteredContentBucketSuggestion.length > 0">
        <ul *ngFor="let item of filteredContentBucketSuggestion; let i = index">
          <li (click)="selectAutoComplete('contentBucket', item)" [class.active]="i === currentSelection">
            <span class="name">{{item}}</span>
           
          </li>
        </ul>
      </div>
      <ng-container *ngIf="insideContentBucket && (1 > filteredContentBucketSuggestion.length)">
        <div class="autosuggestion block">
          <ul>
            <li>
              <span class="name">No Results</span>
            </li>
          </ul>
        </div>
      </ng-container>
    </ng-container>
  </div>
</li>
<!--  -->
            <!-- Add Brand and Model for HT Auto -->
            <ng-container *ngIf="isBrandModelEnable">

                <!-- Add Category Brand and Model for HT Tech -->

                <ng-container *ngIf="enableCategory">
                  <li [class]="setCheckForErrorIndication(21) ? 'errorInput' : ''">
                    <label>Category</label>
                    <div class="dataField">
                      <input type="text" class="textBox" #categoryInput [readonly]="!storyEditMode" placeholder="Add Category here."
                        [(ngModel)]="categoryQuery" (keyup)="filterAutoCompleteUp($event ,'category')"
                        (keydown)="filterAutoCompleteDown($event ,'category')" (focus)="focusInSuggest('category')" (focusout)="false">
                      <ng-container *ngIf="storyEditMode">
                        <div #categoryList class="autosuggestion block"
                          *ngIf="filteredCategorySuggestion && filteredCategorySuggestion.length > 0 && insideCategory">
                          <ul *ngFor="let item of filteredCategorySuggestion;let i = index">
                            <li (click)="selectAutoComplete('category', item)" [class.active]="i === currentSelection">
                              <span class="name">{{item}}</span>
                            </li>
                          </ul>
                        </div>
                        <ng-container *ngIf="insideCategory && filteredCategorySuggestion && (1 > filteredCategorySuggestion.length)">
                          <div class="autosuggestion block">
                            <ul>
                              <li>
                                <span class="name">No Results</span>
                              </li>
                            </ul>
                          </div>
                        </ng-container>
                      </ng-container>
                    </div>
                  </li>
                </ng-container>

  <!---------------------------------------------->

              <li [class]="setCheckForErrorIndication(21) ? 'errorInput' : ''">
                <label>Brand</label>
                <div class="dataField">
                <input type="text" class="textBox" id="inputAddBrandText" #brandInput [readonly]="!storyEditMode" placeholder="Add Brand here."
                  [(ngModel)]="brandQuery" (keyup)="filterAutoCompleteUp($event ,'brand')"
                  (keydown)="filterAutoCompleteDown($event ,'brand')" (focus)="focusInSuggest('brand')" (focusout)="false">
                  <ng-container *ngIf="storyEditMode">
                    <div #brandList class="autosuggestion block"
                      *ngIf="filteredBrandSuggestion && filteredBrandSuggestion.length > 0 && insideBrand">
                      <ul *ngFor="let item of filteredBrandSuggestion;let i = index">
                        <li (click)="selectAutoComplete('brand', item)" [class.active]="i === currentSelection">
                          <span class="name">{{item}}</span>
                        </li>
                      </ul>
                    </div>
                  <ng-container *ngIf="insideBrand && filteredBrandSuggestion && (1 > filteredBrandSuggestion.length)">
                    <div class="autosuggestion block">
                      <ul>
                        <li>
                          <span class="name">No Results</span>
                        </li>
                      </ul>
                    </div>
                  </ng-container>
                  </ng-container>
                </div>
              </li>

              <li [class]="setCheckForErrorIndication(22) ? 'errorInput' : ''">
                <label>Model</label>
                <div class="dataField">
                  <input type="text" class="textBox" id="inputAddModelText" #modelInput [readonly]="!storyEditMode"
                    placeholder="Add Model here." [(ngModel)]="modelQuery" (keyup)="filterAutoCompleteUp($event ,'model')"
                    (keydown)="filterAutoCompleteDown($event ,'model')" (focus)="focusInSuggest('model')" (focusout)="false">
                  <ng-container *ngIf="storyEditMode">
                    <div #modelList class="autosuggestion block"
                      *ngIf="filteredModelSuggestion && filteredModelSuggestion.length > 0 && insideModel">
                      <ul *ngFor="let item of filteredModelSuggestion; let i = index">
                        <li (click)="selectAutoComplete('model', item)" [class.active]="i === currentSelection">
                          <span class="name">{{item}}</span>
                        </li>
                      </ul>
                    </div>
                    <ng-container *ngIf="insideModel && filteredModelSuggestion && (1 > filteredModelSuggestion.length)">
                      <div class="autosuggestion block">
                        <ul>
                          <li><span class="name">No Results</span></li>
                        </ul>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </li>
            </ng-container>
              <!-- same config using for toggle as fetch manual auto quick read -->
            <ng-container *ngIf="secondaryBrandsNeeded()">
              <li>
                <app-secondary-brand [brand]="storyData.metadata.brand" [model]="storyData.metadata.model" [secondaryBrandData]="storyData.metadata.secondaryBrands" [brandSuggestionList]="brandSuggestionMain"
                  [modelSuggestionList]="modelSuggestionMain" [storyEditMode]="storyEditMode" [listOfAllModels]="allModels"
                  (secondaryBrandChanged)="secondaryBrandChangesHandler($event)"></app-secondary-brand>
              </li>
            </ng-container>
<!------------------------------------->
            </ul>
          </div>
          <div class="form" *ngIf="this.storyType === 'deadlink'">
            <li [class]="setCheckForErrorIndication(2) ? 'errorInput' : ''">
              <label>
                Section
              </label>
              <div class="dataField">
                <input type="text" class="textBox" #sectionInput [readonly]="!storyEditMode" placeholder="Add Section here."
                  [(ngModel)]="sectionQuery" (keyup)="filterAutoCompleteUp($event ,'section')" (keydown)="filterAutoCompleteDown($event ,'section')"
                  (focus)="focusInSuggest('section')" (focusout)="false">
                <ng-container *ngIf="storyEditMode">
                  <div #sectionList class="autosuggestion block" *ngIf="filteredSectionSuggestion && filteredSectionSuggestion.length > 0 && insideSection">
                    <ul *ngFor="let item of filteredSectionSuggestion;let i = index">
                      <li (click)="selectAutoComplete('section', item)" [class.active]="i === currentSelection">
                        <span class="name">{{item}}</span>
                        <!-- <span class="emails">(nitesh.rawal@htdigital.in)</span> -->
                      </li>
                    </ul>
                  </div>
                  <ng-container *ngIf="insideSection && (1 > filteredSectionSuggestion.length)">
                    <div class="autosuggestion block">
                      <ul>
                        <li>
                          <span class="name">No Results</span>
                        </li>
                      </ul>
                    </div>
                  </ng-container>
                </ng-container>

              </div>
            </li>
            <li [class]="setCheckForErrorIndication(3) ? 'errorInput' : ''">
              <label>Sub-section
              </label>

              <div class="dataField">
                <input type="text" class="textBox" id="inputAddSubSectionText" #subSectionInput [readonly]="!storyEditMode && flagForSubSection"
                  placeholder="Add SubSection here." [(ngModel)]="subSectionQuery" (keyup)="filterAutoCompleteUp($event ,'subSection')"
                  (keydown)="filterAutoCompleteDown($event ,'subSection')" (focus)="focusInSuggest('subSection')"
                  (focusout)="false">
                <ng-container *ngIf="storyEditMode">
                  <div #subSectionList class="autosuggestion block" *ngIf="filteredSubSectionSuggestion && filteredSubSectionSuggestion.length > 0">
                    <ul *ngFor="let item of filteredSubSectionSuggestion; let i = index">
                      <li (click)="selectAutoComplete('subSection', item)" [class.active]="i === currentSelection">
                        <span class="name">{{item}}</span>
                        <!-- <span class="emails">(nitesh.rawal@htdigital.in)</span> -->
                      </li>
                    </ul>
                  </div>
                  <ng-container *ngIf="insideSubSection && (1 > filteredSubSectionSuggestion.length)">
                    <div class="autosuggestion block">
                      <ul>
                        <li>
                          <span class="name">No Results</span>
                        </li>

                      </ul>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </li>
              <li>
                <label>Deadlink URL</label>
                <div class="dataField">
                  <input id="inputAddDeadLinkText" [readonly]="!storyEditMode" [(ngModel)]="storyData.metadata.deadLinkUrl" type="text" class="textBox"
                    placeholder="Add Deadlink URL here">
                </div>
              </li>
          </div>
          

         
        </div>

        <div class="headlines blocks marb20" *ngIf="(isHomepageOptionsEnabled() > 0) && (storyType === 'liveblog')">
          <div class="head">Homepage</div>
          <div class="form">
            <ul>
              <li>
                <label>HT Homepage</label>
                <div class="dataField">
                  <label class="switch" tabindex="0" (keydown)="callToggles($event, 'homepage')">
                    <input type="checkbox" [disabled]="(!storyEditMode) ? true : false" (click)="toggleSwitch('homepage')"
                      [checked]="homepageToggle">
                    <span class="slider round"></span>
                  </label>
                </div>
              </li>

              <ng-container *ngIf="homepageToggle">
              <li>
                <label>Position</label>
                <div class="dataField">
                  <input id="inputAddPositionText" [readonly]="!storyEditMode" (input)="onPositionChange($event)" type="text" class="textBox"
                    placeholder="Add position here" nuberInput maxLength="isHomepageOptionsEnabled()" [value]="(storyData.metadata && storyData.metadata.homePagePosition) ? storyData.metadata.homePagePosition : 0">
                </div>
              </li>

              <li>
                <label>HomePage End Time</label>
                <div class="dataField">
                  <input #homepageDate class="textBox homePageInput" name="createCard" [disabled]="(!storyEditMode) ? true : false"
                    daterangepicker [options]="homepageCalendarConfig" (selected)="dateSelectedForHomepageOption($event)"
                    (cancelDaterangepicker)="dateEventHandlerForHomepageOption($event)"
                    (applyDaterangepicker)="dateEventHandlerForHomepageOption($event)">
                </div>
              </li>
              </ng-container>
            </ul>
          </div>
        </div>
        <div class="systemmeta blocks marb20">
          <div class="head">Story Info</div>
          <div class="form">
            <ul>
              <li *ngIf="storyType !== 'deadlink'">
                <label>URL</label>
                <div class="dataField"><a href="{{getStoryUrl()}}" target="_blank">
                  <span id="storyUrl" class="link">{{getStoryUrl()}}</span></a>
                    <span class="editBtn">
                    <span><i (click)="copystoryUrl()" class="icon-cards"></i></span></span>
                </div>
              </li>
              <li>
                <label>Format</label>
                <div class="dataField">
                  <span class="">{{storyData.type}}</span>
                </div>
              </li>
              <li>
                <label>Word Count</label>
                <div class="dataField">
                  <span class="">{{storyWordCount ? storyWordCount : 0}}</span>
                </div>
              </li>
              <ng-container *ngIf="domainConfig['config']['story']['readibilityEase'] === 'true' && storyType === 'story'">
                <li>
                  <label>Readibility Score</label>
                  <div class="dataField">
                    <span class="">{{storyData.readabilityEase | number:'1.0-0'}}</span>
                  </div>
                </li>
                <li>
                  <ng-container *ngIf='checkReadibilityEase()'>
                    <label>Readibility Ease</label>
                    <div class="dataField">
                        <span class="">{{readibilityType}}</span>
                    </div>
                  </ng-container>
                </li>
              </ng-container>
            </ul>
          </div>
        </div>
 
        <div class="systemmeta lastModi blocks marb20">
          <div class="head">Last Modified Info</div>
          <div class="form">
            <ul>
              <li>
                <label>Last Modified By :</label>
                <div class="dataField">
                  <span>
                    {{storyData.lastModifiedByUserName}}
                  </span>
                </div>
                </li>
                <li>
                  <label>Last Modified At :</label>
                  <div class="dataField">
                    <span>
                      {{getNewTypeDate(storyData.lastModifiedDate)}}
                    </span>
                  </div>
                  </li>
            </ul>
            </div>
          </div>
      </div>
      </div>
    </div>
    </ng-container>

  <div class="lightBox storyVersion inlineImage block" *ngIf="showStoryVersion">
      <div class="headerLight">
        <div class="close fl spImg" (click)="closeStoryVersion()"></div>
      </div>
      <div class="story-version" [indexClicked]="storyVersionindex" [versionHistory]="versionHistory" (restoreClicked)="restoreStory($event)" [currentVersion]="storyData"></div>
  </div>

  <div [class]="inlineImageFlag ? 'lightBox photogallerylist inlineImage block' : 'lightBox'">
    <div class="headerLight">
      <div class="close fl spImg" (click)="disableInlineImage()"></div>
    </div>
    <ng-container *ngIf="sharedService.isdomainConfig('story','multipleInlineImage')">
      <div class="photo-listing" [photogalleryId]="true" (emitIdfn)="addMultipleInlineImages($event)" *ngIf="inlineImageFlag"></div>
    </ng-container>
    <ng-container *ngIf="!sharedService.isdomainConfig('story','multipleInlineImage')">
      <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="addInlineImageEmit($event)" *ngIf="inlineImageFlag"></div>
    </ng-container>
  </div>

  <div [class]="sampleGalleryFlag ? 'lightBox photogallerylist inlineImage block' : 'lightBox'">
    <div class="headerLight">
      <div class="close fl spImg" (click)="disableSampleImage()"></div>
    </div>
      <div class="photo-listing" [photogalleryId]="true" (emitIdfn)="addMultipleSampleImages($event)"></div>
  </div>

  <div [class]="howToStepsInlineImageFlag ? 'lightBox photogallerylist inlineImage block' : 'lightBox'">
    <div class="headerLight">
      <div class="close fl spImg" (click)="disableStepsInlineImage()"></div>
    </div>
    <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="addStepsInlineImageEmit($event, 'howToSteps')" *ngIf="howToStepsInlineImageFlag"></div>
  </div>

  <div [class]="recipeInlineImageFlag ? 'lightBox photogallerylist inlineImage block' : 'lightBox'">
    <div class="headerLight">
      <div class="close fl spImg" (click)="disableStepsInlineImage()"></div>
    </div>
    <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="addStepsInlineImageEmit($event, 'recipe')" *ngIf="recipeInlineImageFlag"></div>
  </div>


  <div [class]="showPodcastPopup ? 'lightBox photogallerylist inlineImage block' : 'lightBox'">
    <div class="headerLight">
      <div class="close fl spImg" (click)="closePodcastPopup()"></div>
    </div>
    <div class="podcast-listing" (sendPodcastToParentfn)="getPodcastCardDetails($event)" *ngIf="showPodcastPopup"></div>
  </div>

  <div [class]="showRelatedStoryPopup ? 'lightBox listrelatedstories block' : 'lightBox'">
    <div class="headerLight">
      <div class="close fl spImg" (click)="closeRelatedStoryModal(null)"></div>
    </div>
    <div class="related-story-listing" [chooseMultiple]="relatedStoryMultipleSelectFlag" (sendIdListToParentfn)="getRelatedStoryIds($event)" (sendRelatedStoryDataHowto)="getRelatedStoryHowtoIds($event)"
      (closePopupEmit)="closeRelatedStoryModal($event)"  *ngIf="showRelatedStoryPopup" [storyId]="id" [relatedStoryType]="relatedStoryType"></div>
  </div>

  <div [class]="showAlsoReadStoryPopup ? 'lightBox listrelatedstories block' : 'lightBox'">
    <div class="headerLight">
      <div class="close fl spImg" (click)="closeRelatedStoryModal(null)"></div>
    </div>
    <div class="related-story-listing" [chooseMultiple]="relatedStoryMultipleSelectFlag" (sendIdListToParentfn)="getRelatedStoryIds($event)" (sendRelatedStoryDataHowto)="getRelatedStoryHowtoIds($event)"
      (closePopupEmit)="closeRelatedStoryModal($event)" (sendAlsoReadData)="getAlsoReadIds($event)" *ngIf="showAlsoReadStoryPopup" [storyId]="id" [relatedStoryType]="relatedStoryType"></div>
  </div>

  <div class="lightBox videoblock block" *ngIf="autoBacklinkingInProgress">
    <div class="fr wid100 autoBackBtn">
      <button type="button" name="unlock" tabindex="0" (click)="cancelAutobacklinking()" class="add blue ml10">Cancel</button>
    </div>
  </div>

  <div class="lightBox videoblock block" *ngIf="automatedChartAdditionInProgress">
    <div class="fr wid100 autoCmpChartBtn">
      <button type="button" name="unlock" tabindex="0" (click)="cancelAutomatedChartAddition()" class="add blue ml10">Processing...</button>
    </div>
  </div>

  <div class="lightBox videoblock block" *ngIf="videoUrlPopup">
    <div class="unlockStory">
      <div class="wid100 pad30">
        <h3>Add Video Embed</h3>
        <label>Add embed for the video</label>
        <textarea type="text" class="textBox" [(ngModel)]="videoUrl" placeholder="Enter Video Embed here…" tabindex="0"></textarea>

        <label>Add video duration</label>
        <input type="text" class="textBox"
        placeholder="Add duration here" nuberInput maxLength="isHomepageOptionsEnabled()"
        [(ngModel)]="videoDuration">

      </div>
      <div class="fr wid100 right padlr30 ptb15">
        <button type="button" name="cancel" tabindex="0" routerLink="/dash/workspace" class="cancel gray ml10">Cancel</button>
        <button type="button" name="unlock" tabindex="0" (click)="saveVideo()" class="add blue ml10" [disabled]="videoUrl.trim() === ''">Done</button>
      </div>
    </div>
  </div>

  <div class="lightBox videoblock block" *ngIf="changeURLBody">
    <div class="unlockStory">
      <div class="wid100 pad30">
        <h3>Add headline for URL</h3>
        <label>Change URL</label>
        <textarea type="text" class="textBox" id="addUrlForHeadline" [(ngModel)]="urlBody" placeholder="Enter URL body here…" tabindex="0"
        (ngModelChange)="isValid(urlBody)"></textarea>
        <span class="fieldValidation" *ngIf="urlValidationFlag && invalidData">Please Enter English Characters Only</span>
      </div>
      <div class="fr wid100 right padlr30 ptb15">
        <button type="button" name="cancel" tabindex="0" (click)="closeURLbody()" class="cancel gray ml10">Cancel</button>
        <button id="buttonSubmitUrlForHeadline" type="button" name="unlock" tabindex="0" (click)="changeURL()" class="add blue ml10"
        [disabled]="invalidData || (urlBody.trim() === '')" >Done</button>
      </div>
    </div>
  </div>

  <div class="lightBox videoblock block" *ngIf="killStoryPopup">
    <div class="unlockStory">
      <div class="wid100 pad30">
        <h3>Add Redirect URL</h3>
        <label>Leave blank for 404</label>
        <textarea id="addUrlForKillStory" type="text" class="textBox" [(ngModel)]="killURL" placeholder="Enter Redirect URL here…" tabindex="0"></textarea>
      </div>
      <div class="fr wid100 right padlr30 ptb15">
        <button type="button" tabindex="0" name="cancel" (click)="closeKillURL()" class="cancel gray ml10">Cancel</button>
        <button id="submitUrlForKillStory" type="button" tabindex="0" name="unlock" (click)="killStory()" class="add blue ml10">Done</button>
      </div>
    </div>
  </div>


  <div class="lightBox embeddblock block" *ngIf="marketPopup">
    <div class="unlockStory">
      <div class="wid100 pad30">
        <h3>Add Market or Mutual Fund</h3>
        <ng-container *ngIf="showMutualFunds !== 'true'">
        <label class="toggleName">Company/Index Name</label>
        <div class="selectBoxCompany">
          <select [(ngModel)]="marketCode" (change)="getSelectedOptionText($event)">
            <option [value]="42">TELCOM</option>
            <option [value]="15">AUTO</option>
            <option [value]="73">SML250</option>
            <option [value]="21">REALTY</option>
            <option [value]="11">TECK</option>
            <option [value]="19">SMLCAP</option>
            <option [value]="8">BSE CD</option>
            <option [value]="62">MIDSEL</option>
            <option [value]="75">MSL400</option>
            <option [value]="72">MID150</option>
            <option [value]="18">MIDCAP</option>
            <option [value]="40">INDSTR</option>
            <option [value]="9">BSE HC</option>
            <option [value]="5">BSE IT</option>
            <option [value]="17">OILGAS</option>
            <option [value]="36">CDGS</option>
            <option [value]="35">BASMTR</option>
            <option [value]="68">SNXT50</option>
            <option [value]="60">MFG</option>
            <option [value]="61">SMLSEL</option>
            <option [value]="24">SHA50</option>
            <option [value]="46">ALLCAP</option>
            <option [value]="4">BSE500</option>
            <option [value]="23">BSEIPO</option>
            <option [value]="41">ENERGY</option>
            <option [value]="70">ESG100</option>
            <option [value]="74">LMI250</option>
            <option [value]="3">BSE200</option>
            <option [value]="2">BSE100</option>
            <option [value]="12">BSEPSU</option>
            <option [value]="45">LRGCAP</option>
            <option [value]="67">SNSX50</option>
            <option [value]="1">SENSEX</option>
            <option [value]="10">DOL200</option>
            <option [value]="30">CPSE</option>
            <option [value]="7">BSE CG</option>
            <option [value]="20">DOL100</option>
            <option [value]="6">BSEFMC</option>
            <option [value]="14">BANKEX</option>
            <option [value]="13">DOL30</option>
            <option [value]="69">BHRT22</option>
            <option [value]="27">SMEIPO</option>
            <option [value]="37">FIN</option>
            <option [value]="16">METAL</option>
            <option [value]="43">UTILS</option>
            <option [value]="22">POWER</option>
            <option [value]="151">NIFTYMEDIA</option>
            <option [value]="159">LIQ15</option>
            <option [value]="148">NIFTYAUTO</option>
            <option [value]="142">NIFTYREALTY</option>
            <option [value]="144">INDIA VIX</option>
            <option [value]="177">NIFTYSMALLCAP250</option>
            <option [value]="156">NIFTYALPHA</option>
            <option [value]="145">NIFTYSMALL</option>
            <option [value]="179">NIFTYSMALLCAP50</option>
            <option [value]="181">NIFTYMIDSMALL400</option>
            <option [value]="136">NIFTYMNC</option>
            <option [value]="176">NIFTYMIDCAP150</option>
            <option [value]="139">NIFTYPHARMA</option>
            <option [value]="130">MIDCAP50</option>
            <option [value]="182">NIFTY100WEIGHT</option>
            <option [value]="124">NIFTYIT</option>
            <option [value]="128">NIFTYMIDCAP</option>
            <option [value]="125">NIFTYJR</option>
            <option [value]="147">NIFTYCONSUMP</option>
            <option [value]="141">NIFTYINFRAST</option>
            <option [value]="190">NIFTY 11-15 YR GSEC</option>
            <option [value]="186">NIFTY8-13 YR GSEC</option>
            <option [value]="170">NIFTYTR1X</option>
            <option [value]="171">NIFTYPR1X</option>
            <option [value]="167">NSEQ30</option>
            <option [value]="208">NIFTYGSCOMP</option>
            <option [value]="187">NIFTY 10 YR BMGSEC</option>
            <option [value]="188">NIFTY 10YRBMSECCP</option>
            <option [value]="189">NIFTY 4-8 YR GESC</option>
            <option [value]="175">NIFTYPTBNK</option>
            <option [value]="165">LIX 15 MIDCAP</option>
            <option [value]="129">NIFTY500</option>
            <option [value]="126">NIFTYDEFTY</option>
            <option [value]="155">NIFTYDIV</option>
            <option [value]="206">NIFTY200QLTY30</option>
            <option [value]="150">NIFTY200</option>
            <option [value]="127">BANKNIFTY</option>
            <option [value]="137">NIFTYSERVICE</option>
            <option [value]="131">NIFTY100</option>
            <option [value]="192">NIFTY15YRABOVEGSEC</option>
            <option [value]="123">NIFTY</option>
            <option [value]="152">NIFTYCDTY</option>
            <option [value]="138">NIFTYENERGY</option>
            <option [value]="143">NIFTYPSUBANK</option>
            <option [value]="168">NIFTYTR2X</option>
            <option [value]="169">NIFTYPR2X</option>
            <option [value]="166">NV20</option>
            <option [value]="146">NIFTYPSE</option>
            <option [value]="134">NIFTYFMCG</option>
            <option [value]="164">NI15</option>
            <option [value]="154">NIFTYDIVOPPT</option>
            <option [value]="153">NIFTYFINANCE</option>
            <option [value]="162">NIFTYCPSE</option>
            <option [value]="149">NIFTYMETAL</option>
            <option [value]="132921">Adani Ports and Special Economic Zone Ltd.</option>
            <option [value]="100820">Asian Paints Ltd.</option>
            <option [value]="132215">Axis Bank Ltd.</option>
            <option [value]="200132">Bajaj Auto Ltd.</option>
            <option [value]="100034">Bajaj Finance Ltd.</option>
            <option [value]="205198">Bajaj Finserv Ltd.</option>
            <option [value]="132454">Bharti Airtel Ltd.</option>
            <option [value]="209967">Bharti Infratel Ltd.</option>
            <option [value]="100547">Bharat Petroleum Corporation Ltd.</option>
            <option [value]="100825">Britannia Industries Ltd.</option>
            <option [value]="100087">Cipla Ltd.</option>
            <option [value]="219300">Coal India Ltd.</option>
            <option [value]="100124">Dr. Reddys Laboratories Ltd.</option>
            <option [value]="105200">Eicher Motors Ltd.</option>
            <option [value]="132155">GAIL (India) Ltd.</option>
            <option [value]="100300">Grasim Industries Ltd.</option>
            <option [value]="132281">HCL Technologies Ltd.</option>
            <option [value]="100010">Housing Development Finance Corporation Ltd.</option>
            <option [value]="100180">HDFC Bank Ltd.</option>
            <option [value]="100182">Hero MotoCorp Ltd.</option>
            <option [value]="100440">Hindalco Industries Ltd.</option>
            <option [value]="100696">Hindustan Unilever Ltd.</option>
            <option [value]="132174">ICICI Bank Ltd.</option>
            <option [value]="130965">Indian Oil Corporation Ltd.</option>
            <option [value]="132187">IndusInd Bank Ltd.</option>
            <option [value]="100209">Infosys Ltd.</option>
            <option [value]="100875">ITC Ltd.</option>
            <option [value]="100228">JSW Steel Ltd.</option>
            <option [value]="100247">Kotak Mahindra Bank Ltd.</option>
            <option [value]="100510">Larsen & Toubro Ltd.</option>
            <option [value]="100520">Mahindra & Mahindra Ltd.</option>
            <option [value]="132500">Maruti Suzuki India Ltd.</option>
            <option [value]="100790">Nestle India Ltd.</option>
            <option [value]="132555">NTPC Ltd.</option>
            <option [value]="100312">Oil & Natural Gas Corporation Ltd.</option>
            <option [value]="132898">Power Grid Corporation Of India Ltd.</option>
            <option [value]="100325">Reliance Industries Ltd.</option>
            <option [value]="100112">State Bank Of India</option>
            <option [value]="100387">Shree Cement Ltd.</option>
            <option [value]="124715">Sun Pharmaceutical Industries Ltd.</option>
            <option [value]="100570">Tata Motors Ltd.</option>
            <option [value]="100470">Tata Steel Ltd.</option>
            <option [value]="293521">Tata Steel Ltd. - (TATASTEELPP)</option>
            <option [value]="132540">Tata Consultancy Services Ltd.</option>
            <option [value]="132755">Tech Mahindra Ltd.</option>
            <option [value]="100114">Titan Company Ltd.</option>
            <option [value]="132538">Ultratech Cement Ltd.</option>
            <option [value]="112070">UPL Ltd.</option>
            <option [value]="100295">Vedanta Ltd.</option>
            <option [value]="107685">Wipro Ltd.</option>
            <option [value]="105537">Zee Entertainment Enterprises Ltd.</option>
          </select>
        </div>
        </ng-container>
        <ng-container *ngIf="showMutualFunds === 'true'">
          <label class="toggleName">Company/Index Name</label>
          <tags-creator [textEdit]="deactivateMarketSuggestion" [autoSuggest]="true" [autocompletelist]="getMarketSuggestion()"
          [editable]="!storyEditMode" [data]="marketList"
          [displayText]="'Enter Index / Company\'s Names...'" (clickfn)="customFunc($event)" (changefn)="setMarketIndex($event)"
          [isDataKeyValuePair]="true" [isMarket]="true"></tags-creator>

          <label class="toggleName">Mutual Fund Name</label>
          <tags-creator [textEdit]="deactivateMarketSuggestion" [autoSuggest]="true" [autocompletelist]="getMFSuggestion()"
          [editable]="!storyEditMode" [data]="mutualFundList"
          [displayText]="'Enter Mutual Fund Names...'" (clickfn)="customFunc($event)" (changefn)="setMutualFunds($event)"
           [isDataKeyValuePair]="true" [isMarket]="true"></tags-creator>

           <label class="toggleName">NEW - Company/Index Name</label>
           <tags-creator [textEdit]="deactivateMarketSuggestion" [autoSuggest]="true" [autocompletelist]="getNewMarketSuggestion()"
           [editable]="!storyEditMode" [data]="newMarketList"
           [displayText]="'Enter NEW - Index / Company\'s Names...'" (clickfn)="customFunc($event)" (changefn)="setNewMarket($event)"
           [isDataKeyValuePair]="true" [isMarket]="true" [searchByCode]="true"></tags-creator>

        </ng-container>
      </div>
      <div class="fr wid100 right padlr30 ptb15">
        <button type="button" tabindex="0" name="cancel" (click)="closeMarketPopup()"
          class="cancel gray ml10">Cancel</button>
        <button type="button" tabindex="0" name="unlock" (click)="saveMarketEmbed()"
          class="add blue ml10" id="buttonSubmitForMarket">Done</button>
      </div>
    </div>
  </div>
  <div class="lightBox embeddblock addProductEle block" *ngIf="showCategoryProductPopup">
    <div class="unlockStory">
      <div class="wid100 pad30">
        <h3>Create Product Element</h3>
          <label class="toggleName">Category</label>
          <div class="dataField">
            <input #categoryEleInput type="text" class="textBox" #brandInput [readonly]="!storyEditMode" placeholder="Add Category here."
              [(ngModel)]="categoryEleQuery" (keyup)="filterAutoCompleteUp($event ,'categoryEle')"
               (focus)="focusEleSuggest('categoryEle')" (focusout)="false">
              <ng-container *ngIf="storyEditMode">
                <div #brandList class="autosuggestion block"
                  *ngIf="filteredCategorySuggestion && filteredCategorySuggestion.length > 0 && insideCategoryEle">
                  <ul *ngFor="let item of filteredCategorySuggestion;let i = index">
                    <li (click)="selectAutoComplete('categoryEle', item)" [class.active]="i === currentSelection">
                      <span class="name">{{item.categoryName}}</span>
                    </li>
                  </ul>
                </div>
              <ng-container *ngIf="insideCategoryEle && filteredCategorySuggestion && (1 > filteredCategorySuggestion.length)">
                <div class="autosuggestion block">
                  <ul>
                    <li>
                      <span class="name">No Results</span>
                    </li>
                  </ul>
                </div>
              </ng-container>
              </ng-container>
            </div>

            <label class="toggleName">Brand</label>
            <div class="dataField">
              <input #brandEleInput type="text" class="textBox" [readonly]="!storyEditMode" placeholder="Add Brand here."
                [(ngModel)]="brandEleQuery" (keyup)="filterAutoCompleteUp($event ,'brandEle')"
                (focus)="focusEleSuggest('brandEle')" (focusout)="false">
                <ng-container *ngIf="storyEditMode">
                  <div class="autosuggestion block"
                    *ngIf="filteredBrandSuggestion && filteredBrandSuggestion.length > 0 && insideBrandEle">
                    <ul *ngFor="let item of filteredBrandSuggestion;let i = index">
                      <li (click)="selectAutoComplete('brandEle', item)" [class.active]="i === currentSelection">
                        <span (click)="selectAutoComplete('brandEle', item)" class="name">{{item}}</span>
                      </li>
                    </ul>
                  </div>
                <ng-container *ngIf="insideBrandEle && filteredBrandSuggestion && (1 > filteredBrandSuggestion.length)">
                  <div class="autosuggestion block">
                    <ul>
                      <li>
                        <span class="name">No Results</span>
                      </li>
                    </ul>
                  </div>
                </ng-container>
                </ng-container>
              </div>

          <label class="toggleName">Model</label>
          <li [class]="setCheckForErrorIndication(22) ? 'errorInput' : ''">
            <div class="dataField">
              <input type="text" class="textBox" #modelEleInput [readonly]="!storyEditMode"
                placeholder="Add Model here." [(ngModel)]="modelEleQuery" (keyup)="filterAutoCompleteUp($event ,'modelCategoryEle')"
                (focus)="focusEleSuggest('modelEle')" (focusout)="false">
              <ng-container *ngIf="storyEditMode">
                <div class="autosuggestion block"
                  *ngIf="filteredModelSuggestion && filteredModelSuggestion.length > 0 && insideModelEle">
                  <ul *ngFor="let item of filteredModelSuggestion; let i = index">
                    <li (click)="selectAutoComplete('modelEle', item)" [class.active]="i === currentSelection">
                      <span class="name">{{item}}</span>
                    </li>
                  </ul>
                </div>
                <ng-container *ngIf="insideModelEle && filteredModelSuggestion && (1 > filteredModelSuggestion.length)">
                  <div class="autosuggestion block">
                    <ul>
                      <li><span class="name">No Results</span></li>
                    </ul>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </li>
      </div>
      <div class="fr wid100 right padlr30 ptb15">
        <button type="button" tabindex="0" name="cancel" (click)="closeProductPopup()"
          class="cancel gray ml10">Cancel</button>
        <button type="button" tabindex="0" name="unlock" (click)="saveCategoryProductElement()"
          class="add blue ml10" id="buttonSubmitForMarket">Done</button>
      </div>
    </div>
  </div>


  <div class="lightBox embeddblock addProductEle block" *ngIf="showProductPopup">
    <div class="unlockStory">
      <div class="wid100 pad30">
        <h3>Create Product Element</h3>
            <label class="toggleName">Brand</label>
            <div class="dataField">
              <input #brandEleInput type="text" class="textBox" [readonly]="!storyEditMode" placeholder="Add Brand here."
                [(ngModel)]="brandEleQuery" (keyup)="filterAutoCompleteUp($event ,'brandEle')"
                (focus)="focusEleSuggest('brandEle')" (focusout)="false">
                <ng-container *ngIf="storyEditMode">
                  <div class="autosuggestion block"
                    *ngIf="filteredBrandSuggestion && filteredBrandSuggestion.length > 0 && insideBrandEle">
                    <ul *ngFor="let item of filteredBrandSuggestion;let i = index">
                      <li (click)="selectAutoComplete('brandEle', item)" [class.active]="i === currentSelection">
                        <span (click)="selectAutoComplete('brandEle', item)" class="name">{{item}}</span>
                      </li>
                    </ul>
                  </div>
                <ng-container *ngIf="insideBrandEle && filteredBrandSuggestion && (1 > filteredBrandSuggestion.length)">
                  <div class="autosuggestion block">
                    <ul>
                      <li>
                        <span class="name">No Results</span>
                      </li>
                    </ul>
                  </div>
                </ng-container>
                </ng-container>
              </div>

          <label class="toggleName">Model</label>
          <li [class]="setCheckForErrorIndication(22) ? 'errorInput' : ''">
            <div class="dataField">
              <input type="text" class="textBox" #modelEleInput [readonly]="!storyEditMode"
                placeholder="Add Model here." [(ngModel)]="modelEleQuery" (keyup)="filterAutoCompleteUp($event ,'modelEle')"
                (focus)="focusEleSuggest('modelEle')" (focusout)="false">
              <ng-container *ngIf="storyEditMode">
                <div class="autosuggestion block"
                  *ngIf="filteredModelSuggestion && filteredModelSuggestion.length > 0 && insideModelEle">
                  <ul *ngFor="let item of filteredModelSuggestion; let i = index">
                    <li (click)="selectAutoComplete('modelEle', item)" [class.active]="i === currentSelection">
                      <span class="name">{{item}}</span>
                    </li>
                  </ul>
                </div>
                <ng-container *ngIf="insideModelEle && filteredModelSuggestion && (1 > filteredModelSuggestion.length)">
                  <div class="autosuggestion block">
                    <ul>
                      <li><span class="name">No Results</span></li>
                    </ul>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </li>
      </div>
      <div class="fr wid100 right padlr30 ptb15">
        <button type="button" tabindex="0" name="cancel" (click)="closeProductPopup()"
          class="cancel gray ml10">Cancel</button>
        <button type="button" tabindex="0" name="unlock" (click)="saveProductElement()"
          class="add blue ml10" id="buttonSubmitForMarket">Done</button>
      </div>
    </div>
  </div>

  <div class="lightBox embeddblock matchBlock block" *ngIf="matchPopup">
    <app-match-component (sendPopupValueToParentfn)="getPopupValueToParentfn($event)"
    (sendMatchDetailsToParentfn) = getMatchDetailsToParentfn($event)
    ></app-match-component>
  </div>


  <div class="lightBox embeddblock block" *ngIf="embedPopup">
    <div class="unlockStory">
      <div class="wid100 pad30">
        <h3>Add Embed</h3>

        <li *ngIf="amazonAdDisplay===true">
          <div class="amazonAds">
          <label>Amazon Meta</label>
          <div class="dataField" >
            <label class="switch" tabindex="0">
              <input type="checkbox" (click)="toggleSwitch('amazonMeta')" [disabled]="(!storyEditMode) ? true : false"
                [checked]="showAmazonMeta">
              <span class="slider round"></span>
            </label>
          </div>
        </div>
        </li>
        <li *ngIf="lShapeBandDisplay===true">
          <div class="amazonAds">
          <label>Ads L-Band</label>
          <div class="dataField">
            <label class="switch" tabindex="0">
              <input type="checkbox" (click)="toggleSwitch('lShapeBand')" [disabled]="(!storyEditMode) ? true : false"
                [checked]="showLShapeBand">
              <span class="slider round"></span>
            </label>
          </div>
        </div>
        </li>
        <ng-container *ngIf="showAmazonMeta != true">
        <label>{{getEmbedPopupTitle()}}</label>
        <textarea type="text" id="inputAddEmbedUrl" class="textBox" [(ngModel)]="embedCode" placeholder="Enter for the Facebook, tweet, etc here…"
          tabindex="0"></textarea>
          <label>Source URL</label>
          <textarea type="text" id="inputAddEmbedSourceUrl" class="textBoxSmall" [(ngModel)]="embedSourceUrl" placeholder="Enter Source url here" tabindex="0"></textarea>
          <label>Subtype</label>
          <textarea type="text" class="textBoxSmall" [(ngModel)]="embedSubType" placeholder="Enter Subtype here" tabindex="0"></textarea>
        </ng-container>
          <ng-container *ngIf="showAmazonMeta===true">
            <div class="amazonAds"><label>Add Amazon Custom Ads</label>
            <span id="headline1" class="plusHeadline" (click)="addAmazonMeta()">
              <i class="icon-add-headline"></i>
            </span>
          </div>
          <textarea type="text" class="textBoxSmall marBot10" [(ngModel)]="adTitle" placeholder="Enter Ad title here" tabindex="0"></textarea>
            <ng-container *ngIf="amazonNewAd">

              <textarea type="text" class="textBoxSmall marBot10" [(ngModel)]="newAdName" placeholder="Enter Ad Name here" tabindex="0"></textarea>
              <textarea type="text" class="textBoxSmall" [(ngModel)]="newAdEmbed" placeholder="Enter Ad Embed here" tabindex="0"></textarea>
              <button type="button" tabindex="0" name="unlock" (click)="saveAmazonEmbed()" class="add blue ml10 amazonAddSpace">Add</button>
            </ng-container>
            <ng-container *ngFor="let amazonAd of amazonAds; let i =index">
              <textarea type="text" class="textBoxSmall marBot10" [(ngModel)]="amazonAd.key" placeholder="Enter ad name here..." tabindex="0"></textarea>
              <textarea type="text" class="textBoxSmall" [(ngModel)]="amazonAd.value" placeholder="Enter Custom {{amazonAd.key}} here" tabindex="0"></textarea>
              <span class="deleteHeadline amazonAddSpace" id="headline2" (click)="deleteAmazonAd(amazonAd)">
                <i class="icon-delete"></i>
              </span>
            </ng-container>
          </ng-container>
          <div class="search-link">
            <a  *ngIf="adTitle.split('').length>0 && enableAffiliate && addIconClick" tabindex="0" (click)="openCloseAmazonAdSearchPopup(true)" class="add blue ml10 ">Search Product</a>
          </div>
      </div>
      <div class="fr wid100 right padlr30 ptb15">
        <ng-container *ngIf="dataFormAmazonList.length<=0">

          <button type="button" tabindex="0" name="cancel" (click)="closeEmbedPopup()" class="cancel gray ml10">Cancel</button>
          <button type="button" id="buttonSubmitEmbed" tabindex="0" name="unlock" (click)="saveEmbed()" class="add blue ml10 ">Done</button>
        </ng-container>
        <ng-container *ngIf="dataFormAmazonList.length>0">

          <button type="button" tabindex="0" name="cancel" (click)="closeEmbedPopup()" class="cancel gray ml10">Cancel</button>
          <button type="button" id="buttonSubmitEmbed" tabindex="0" name="unlock" (click)="saveEmbedAmazon()" class="add blue ml10 ">Done</button>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="lightBox faqblock block" *ngIf="showFaqPopup">
    <div class="unlockStory">
      <div class="wid100">
        <h3 class="pad30">Add FAQs</h3><span class="shortCutsKeyPopup">(<i>Press cmd+k/ctrl+k for hyperlink</i>)</span>
        <form [formGroup]="tempFaqData">
          <li>
            <div class="headingBlock">
            <label>Heading of the FAQ section<span>(Max. 100 characters)</span></label>
            <div class="dataField">
                <textarea maxlength="100" class="textBoxSmall" formControlName="heading" placeholder="Enter the heading" tabindex="0" type="text"></textarea>
                <span class="requiredField" *ngIf="tempFaqData.get('heading').touched && !tempFaqData.get('heading').valid &&
                tempFaqData.get('heading').errors?.required">Heading is required</span>
              </div>
          </div>
          </li>
          <div class="faqQueAnsw">
          <ng-container formArrayName="faqs"
              *ngFor="let faq of tempFaqData.get('faqs').controls; let i = index;">
            <div class="faqBlockQue">
              <i *ngIf="tempFaqData.get('faqs').controls.length > 1" class="icon-delete" (click)="deleteFaq(i)"></i>
            <ng-container [formGroupName]="i">

                <li>
                  <div class="">
                  <label>Question {{i+1}}
                    <!-- <span>(Max. 100 characters)</span> -->
                  </label>
                  <div class="dataField">
                      <textarea  class="textBoxSmall" formControlName="key" placeholder="Enter the question" type="text"></textarea>
                      <span class="requiredField" *ngIf="tempFaqData.get('faqs')['controls'][i].get('key').touched && !tempFaqData.get('faqs')['controls'][i].get('key').valid &&
                      tempFaqData.get('faqs')['controls'][i].get('key').errors?.required">Question is required</span>
                  </div>
                </div>
                </li>
                <li>
                  <div class="answer">
                  <label>Answer {{i+1}}
                    <!-- <span>(Max. 500 characters)</span> -->
                  </label>

                      <ckeditor [editor]="Editor"   [config]="ckconfig"
                      formControlName="value" placeholder="Enter the answer"></ckeditor>
                      <span class="requiredField" *ngIf="tempFaqData.get('faqs')['controls'][i].get('value').touched && !tempFaqData.get('faqs')['controls'][i].get('value').valid &&
                      tempFaqData.get('faqs')['controls'][i].get('value').errors?.required">Answer is required</span>

                </div>
                </li>
            </ng-container>
          </div>
          </ng-container>
        </div>
        </form>
      </div>
      <div class="fr wid100 right padlr30 ptb15">
        <button type="button" tabindex="0" name="cancel" (click)="addFaq()" class="cancel btnFaq">+ Add another QnA</button>
        <button type="button" tabindex="0" name="cancel" (click)="closeFaqPopup()" class="cancel gray ml10">Cancel</button>
        <button type="button" tabindex="0" name="unlock" class="add blue ml10 " (click)="saveFaqs()">Done</button>
      </div>
    </div>
  </div>

  <div class="lightBox stepblock block" *ngIf="showStepPopup" style="z-index: 10 !important;">
    <div class="unlockStory">
      <div class="wid100">
        <h3 class="pad30">Add How-to Steps</h3><span class="shortCutsKeyPopup">(<i>Press cmd+k/ctrl+k for hyperlink</i>)</span>
        <form [formGroup]="tempHowToStepsData">
          <div class="stepScroll">
            <li>
              <div class="">
              <label>Heading</label>
              <div class="dataField">
                  <textarea class="textBoxSmall" formControlName="heading" placeholder="Enter the heading" tabindex="0" type="text"></textarea>
                  <span class="requiredField" *ngIf="tempHowToStepsData.get('heading').touched && !tempHowToStepsData.get('heading').valid &&
                  tempHowToStepsData.get('heading').errors?.required">Heading is required</span>
              </div>
            </div>
            </li>
            <li>
              <div class="">
              <label>Time to complete</label>
              <div class="dataField">
                <textarea maxlength="2" class="textBoxSmall" style="width: 48%; float: left;" formControlName="timeToCompleteinHrs" placeholder="Hours" tabindex="0" type="text" (keydown)="validateKeyPressForNumberOnlyField($event)" (keyup)="validateMaxPositionValue($event)"></textarea>
                <span class="requiredField" *ngIf="tempHowToStepsData.get('timeToCompleteinHrs').touched && !tempHowToStepsData.get('timeToCompleteinHrs').valid &&
                tempHowToStepsData.get('timeToCompleteinHrs').errors?.required">Time is required</span>
                <textarea maxlength="2" class="textBoxSmall" style="width: 48%; float: right;" formControlName="timeToComplete" placeholder="Minutes" tabindex="0" type="text" (keydown)="validateKeyPressForNumberOnlyField($event)" (keyup)="validateMaxPositionValue($event)"></textarea>
                <span class="requiredField" *ngIf="tempHowToStepsData.get('timeToComplete').touched && !tempHowToStepsData.get('timeToComplete').valid &&
                tempHowToStepsData.get('timeToComplete').errors?.required">Time is required</span>
              </div>
              </div>
            </li>
            <li>
              <div class="">
              <label>Supplies<span>(Use comma to add multiple items)</span></label>
              <div class="dataField">
                <tags-creator [data]="tempHowToStepsData.get('supplies').value" [editable]="false" [displayText]="'Add supplies here'"
                    (clickfn)="customFunc($event)" (changefn)="suppliesChangeFunc($event)"
                    [storyTags]="true" [marketSuggest]="false" [supplyTags]="true"></tags-creator>
              </div>
            </div>
            </li>
            <li>
              <div class="">
              <label>Tools<span>(Use comma to add multiple items)</span></label>
              <div class="dataField">
                <tags-creator [data]="tempHowToStepsData.get('tools').value" [editable]="false" [displayText]="'Add tools here..'"
                (clickfn)="customFunc($event)" (changefn)="toolsChangeFunc($event)"
                [storyTags]="true" [marketSuggest]="false" [toolTags]="true"></tags-creator>
              </div>
            </div>
            </li>
            <ng-container formArrayName="steps"
              *ngFor="let step of tempHowToStepsData.get('steps').controls; let i = index;">
              <div class="howStepImageBlock">
              <i *ngIf="tempHowToStepsData.get('steps').controls.length > 1" class="icon-delete test" (click)="deleteStep(i)"></i>
              <ng-container [formGroupName]="i">
                <div class="stepBlock">
                  <li>
                    <div class="">
                    <label>Step {{i+1}}</label>
                    <div class="dataField">
                      <ckeditor [editor]="Editor" class="textBoxSmall" formControlName="step" placeholder="Enter step" tabindex="0" type="text"></ckeditor>
                      <span class="requiredField" *ngIf="tempHowToStepsData.get('steps')['controls'][i].get('step').touched && !tempHowToStepsData.get('steps')['controls'][i].get('step').valid &&
                      tempHowToStepsData.get('steps')['controls'][i].get('step').errors?.required">Step information is required</span>
                    </div>
                  </div>
                  </li>
                  <li>
                    <div class="">
                      <ng-container *ngIf="tempHowToStepsData.get('steps')['controls'][i].get('stepImage').value == null || tempHowToStepsData.get('steps')['controls'][i].get('stepImage').value == ''">
                        <label>Upload Step {{i+1}} Image</label>
                        <div class="dataField">
                          <div class="stepsDropBlock">
                            <div class="imageInsert" (click)="updateCurrentHowToStep(i)">
                              <span>Upload from file</span>
                              <input type="file" name="myfile" accept="image/*" (change)="onFileChangeSingle($event, 'howToStepsImage')" />
                            </div>
                            <div class="imageLibrary" (click)="addStepsInlineImage(i, 'howToSteps')">
                              <span>Pick from Library</span>
                            </div>
                            </div>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="tempHowToStepsData.get('steps')['controls'][i].get('stepImage').value != null && tempHowToStepsData.get('steps')['controls'][i].get('stepImage').value != ''">
                        <label>Upload Step {{i+1}} Image</label>
                        <div class="dataField">
                          <div class="stepsDropBlock imageNameView">
                        {{getImageNameFromUrl(tempHowToStepsData.get('steps')['controls'][i].get('stepImage').value.images)}}

                        <span (click)="removeStepImage(i, 'howToSteps')" style="cursor: pointer;">( Remove Image )</span>
                      </div>
                      </div>
                      </ng-container>
                  </div>
                  </li>
                </div>
              </ng-container>
            </div>
            </ng-container>
          </div>
        </form>
      </div>
      <div class="fr wid100 right padlr30 ptb15">
        <button type="button" tabindex="0" name="cancel" (click)="addStep()" class="cancel btnFaq">+ Add steps</button>
        <button type="button" tabindex="0" name="cancel" (click)="closeStepPopup()" class="cancel gray ml10">Cancel</button>
        <button type="button" tabindex="0" name="unlock" (click)="saveHowToSteps()" class="add blue ml10 ">Done</button>
      </div>
    </div>
  </div>
  <div class="lightBox stepblock block" *ngIf="showRecipePopup" style="z-index: 10 !important;">
    <div class="unlockStory">
      <div class="wid100">
        <h3 class="pad30">Add Recipe</h3>
        <form [formGroup]="tempRecipeData">
          <div class="stepScroll">
            <li>
              <div class="">
              <label>Recipe Name</label>
              <div class="dataField">
                  <textarea class="textBoxSmall" formControlName="recipeName" placeholder="Enter the Recipe Name" tabindex="0" type="text"></textarea>
                  <span class="requiredField" *ngIf="tempRecipeData.get('recipeName').touched && !tempRecipeData.get('recipeName').valid &&
                  tempRecipeData.get('recipeName').errors?.required">Recipe Name is required</span>
              </div>
            </div>
            </li>
            <li>
              <div class="">
              <label>Description</label>
              <div class="dataField">
                  <textarea rows="4" class="textArea" formControlName="description" placeholder="Enter the Description" tabindex="0" type="text"></textarea>
              </div>
            </div>
            </li>
            <li>
              <div class="">
              <label>Recipe Yield</label>
              <div class="dataField">
                  <textarea class="textBoxSmall" formControlName="recipeYield" placeholder="Enter the Recipe Yield" tabindex="0" type="text"></textarea>
              </div>
            </div>
            </li>
            <li>
              <div class="">
              <label>Preparation Time</label>
              <div class="dataField">
                <textarea maxlength="2" class="textBoxSmall" style="width: 48%; float: left;" formControlName="preparationTimeHr" placeholder="Hours" tabindex="0" type="text" (keydown)="validateKeyPressForNumberOnlyField($event)" (keyup)="validateMaxPositionValue($event)"></textarea>
                <span class="requiredField" *ngIf="tempRecipeData.get('preparationTimeHr').touched && !tempRecipeData.get('preparationTimeHr').valid &&
                tempRecipeData.get('preparationTimeHr').errors?.required">Time is required</span>
                <textarea maxlength="2" class="textBoxSmall" style="width: 48%; float: right;" formControlName="preparationTimeMinute" placeholder="Minutes" tabindex="0" type="text" (keydown)="validateKeyPressForNumberOnlyField($event)" (keyup)="validateMaxPositionValue($event)"></textarea>
                <span class="requiredField" *ngIf="tempRecipeData.get('preparationTimeMinute').touched && !tempRecipeData.get('preparationTimeMinute').valid &&
                tempRecipeData.get('preparationTimeMinute').errors?.required">Time is required</span>
              </div>
              </div>
            </li>
            <li>
              <div class="">
              <label>Cooking Time</label>
              <div class="dataField">
                <textarea maxlength="2" class="textBoxSmall" style="width: 48%; float: left;" formControlName="cookingTimeHr" placeholder="Hours" tabindex="0" type="text" (keydown)="validateKeyPressForNumberOnlyField($event)" (keyup)="validateMaxPositionValue($event)"></textarea>
                <span class="requiredField" *ngIf="tempRecipeData.get('cookingTimeHr').touched && !tempRecipeData.get('cookingTimeHr').valid &&
                tempRecipeData.get('cookingTimeHr').errors?.required">Time is required</span>
                <textarea maxlength="2" class="textBoxSmall" style="width: 48%; float: right;" formControlName="cookingTimeMinute" placeholder="Minutes" tabindex="0" type="text" (keydown)="validateKeyPressForNumberOnlyField($event)" (keyup)="validateMaxPositionValue($event)"></textarea>
                <span class="requiredField" *ngIf="tempRecipeData.get('cookingTimeMinute').touched && !tempRecipeData.get('cookingTimeMinute').valid &&
                tempRecipeData.get('cookingTimeMinute').errors?.required">Time is required</span>
              </div>
              </div>
            </li>
            <li>
              <div class="">
              <label>Total Time</label>
              <div class="dataField">
                <textarea maxlength="2" class="textBoxSmall" style="width: 48%; float: left;" formControlName="totalTimeHr" placeholder="Hours" tabindex="0" type="text" (keydown)="validateKeyPressForNumberOnlyField($event)" (keyup)="validateMaxPositionValue($event)"></textarea>
                <span class="requiredField" *ngIf="tempRecipeData.get('totalTimeHr').touched && !tempRecipeData.get('totalTimeHr').valid &&
                tempRecipeData.get('totalTimeHr').errors?.required">Time is required</span>
                <textarea maxlength="2" class="textBoxSmall" style="width: 48%; float: right;" formControlName="totalTimeMinute" placeholder="Minutes" tabindex="0" type="text" (keydown)="validateKeyPressForNumberOnlyField($event)" (keyup)="validateMaxPositionValue($event)"></textarea>
                <span class="requiredField" *ngIf="tempRecipeData.get('totalTimeMinute').touched && !tempRecipeData.get('totalTimeMinute').valid &&
                tempRecipeData.get('totalTimeMinute').errors?.required">Time is required</span>
              </div>
              </div>
            </li>
            <li>
              <div class="">
              <label>Ingredients<span>(Use comma to add multiple items)</span></label>
              <div class="dataField">
                <tags-creator [data]="tempRecipeData.get('ingredients').value" [editable]="false" [displayText]="'Add ingredients here'"
                    (clickfn)="customFunc($event)" (changefn)="ingredientsChangeFunc($event)"
                     [marketSuggest]="false" [supplyTags]="false"></tags-creator>
              </div>
            </div>
            </li>
            <li>
              <div class="">
              <label>Recipe Cuisine</label>
              <div class="dataField">
                  <textarea class="textBoxSmall" formControlName="recipeCuisine" placeholder="Enter the Recipe Cuisine" tabindex="0" type="text"></textarea>
              </div>
            </div>
            </li>
            <li>
              <div class="">
              <label>Recipe Category</label>
              <div class="dataField">
                  <textarea class="textBoxSmall" formControlName="recipeCategory" placeholder="Enter the Recipe Category" tabindex="0" type="text"></textarea>
              </div>
            </div>
            </li>
            <li>
              <div class="">
              <label>keywords<span>(Use comma to add multiple items)</span></label>
              <div class="dataField">
                <tags-creator [data]="tempRecipeData.get('keywords').value" [editable]="false" [displayText]="'Add keywords here..'"
                (clickfn)="customFunc($event)" (changefn)="keywordsChangeFunc($event)"
                [storyTags]="true" [marketSuggest]="false" [toolTags]="true"></tags-creator>
              </div>
            </div>
            </li>
            <ng-container formArrayName="steps"
              *ngFor="let step of tempRecipeData.get('steps').controls; let i = index;">
              <div class="howStepImageBlock">
              <i *ngIf="tempRecipeData.get('steps').controls.length > 1" class="icon-delete test" (click)="deleteRecipeStep(i)"></i>
              <ng-container [formGroupName]="i">
                <div class="stepBlock">
                  <li>
                    <div class="">
                    <label>Step {{i+1}}</label>
                    <div class="dataField">
                      <ckeditor [editor]="Editor" class="textBoxSmall" formControlName="step" placeholder="Enter step" tabindex="0" type="text"></ckeditor>
                      <span class="requiredField" *ngIf="tempRecipeData.get('steps')['controls'][i].get('step').touched && !tempRecipeData.get('steps')['controls'][i].get('step').valid &&
                      tempRecipeData.get('steps')['controls'][i].get('step').errors?.required">Step information is required</span>
                    </div>
                  </div>
                  </li>
                  <li>
                    <div class="">
                      <ng-container *ngIf="tempRecipeData.get('steps')['controls'][i].get('stepImage').value == null || tempRecipeData.get('steps')['controls'][i].get('stepImage').value == ''">
                        <label>Upload Step {{i+1}} Image</label>
                        <div class="dataField">
                          <div class="stepsDropBlock">
                            <div class="imageInsert" (click)="updateCurrentHowToStep(i)">
                              <span>Upload from file</span>
                              <input type="file" name="myfile" accept="image/*" (change)="onFileChangeSingle($event, 'recipeImage')" />
                            </div>
                            <div class="imageLibrary" (click)="addStepsInlineImage(i, 'recipe')">
                              <span>Pick from Library</span>
                            </div>
                            </div>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="tempRecipeData.get('steps')['controls'][i].get('stepImage').value != null && tempRecipeData.get('steps')['controls'][i].get('stepImage').value != ''">
                        <label>Upload Step {{i+1}} Image</label>
                        <div class="dataField">
                          <div class="stepsDropBlock imageNameView">
                        {{getImageNameFromUrl(tempRecipeData.get('steps')['controls'][i].get('stepImage').value.images)}}

                        <span (click)="removeStepImage(i, 'recipe')" style="cursor: pointer;">( Remove Image )</span>
                      </div>
                      </div>
                      </ng-container>
                  </div>
                  </li>
                </div>
              </ng-container>
            </div>
            </ng-container>
          </div>
        </form>
      </div>
      <div class="fr wid100 right padlr30 ptb15">
        <button type="button" tabindex="0" name="cancel" (click)="addRecipeStep()" class="cancel btnFaq">+ Add steps</button>
        <button type="button" tabindex="0" name="cancel" (click)="closeRecipePopup()" class="cancel gray ml10">Cancel</button>
        <button type="button" tabindex="0" name="unlock" (click)="saveRecipe()" class="add blue ml10 ">Done</button>
      </div>
    </div>
  </div>
  <div id="headline3" class="lightBox headlineBox summaryPopup block" *ngIf="summaryPopup">
    <div class="headerLight">
      <!-- <div class="close fl spImg"></div> -->
    </div>
    <div class="lightContent headlineBox">
      <div class="addHeadline">
        <h3>Add Custom Summary</h3>
        <ul>
          <li>
            <label>Newsletter - {{htmlToPlaintext(tempStoryData.newsletterSummary).length}}/280</label>
            <div class="dataField">
              <span class="fieldValidation"
              *ngIf="summaryRestrictionChecks.includes('newsletterSummary')
              && sharedService.checkIfRestrictedCharactersArePresent(tempStoryData.newsletterSummary, 'summary')">
              Please remove (")</span>
              <textarea type="text" class="textBox" [(ngModel)]="tempStoryData.newsletterSummary" placeholder=""></textarea>
            </div>
          </li>
        </ul>
        <ng-container *ngIf="disabledMetaFields.indexOf('quickRead') === -1">
        <h3>Add Quick Read Summary</h3>
        <!-- lmDomain false -->
        <ng-template #domainDisabled>
        <ng-container>
          <ul>
            <li>
              <div class="dataField">
                <span class="fieldValidation"
                *ngIf="summaryRestrictionChecks.includes('newsletterSummary')
                && sharedService.checkIfRestrictedCharactersArePresent(tempStoryData.quickReadSummary, 'summary')">
                Please remove (")</span>
                <textarea type="text" class="textBox" [(ngModel)]="tempStoryData.quickReadSummary" placeholder=""></textarea>
              </div>
            </li>
          </ul>
        </ng-container>
      </ng-template>
        <!-- lmDomain true -->
        <ng-container *ngIf="enableQuickSummaryLength else domainDisabled">
          <ul>
            <li>
              <label *ngIf="tempStoryData?.quickReadSummary">{{htmlToPlaintext(tempStoryData.quickReadSummary).split(' ').length}}/{{quickReadMax}} words.</label>
              <div class="dataField heightQuickRead">
                <span class="fieldValidation"
                *ngIf="summaryRestrictionChecks.includes('newsletterSummary')
                && sharedService.checkIfRestrictedCharactersArePresent(tempStoryData.quickReadSummary, 'summary')">
                Please remove (")</span>
                <textarea type="text" class="textBox" [(ngModel)]="tempStoryData.quickReadSummary" placeholder=""></textarea>
              </div>
              <span id="quickSummaryError" *ngIf="tempStoryData && tempStoryData.quickReadSummary && (tempStoryData.quickReadSummary.trim().split(' ').length<quickReadMin || tempStoryData.quickReadSummary.trim().split(' ').length>quickReadMax)">
                words should be between {{quickReadMin}} - {{quickReadMax}}
              </span>

            </li>
          </ul>
        </ng-container>
        <em class="quick_read ptb15">
          <img alt="" src="assets/images/quick_reads.svg">
          <div class="arrow_box single">Status : {{storyData.quickReadStatus}}</div>
        </em>
        <button *ngIf="disabledMetaFields.indexOf('quickReadbutton') === -1" type="button" name="fetchsummary" [disabled]="fetching" (click)="fetchAutoQuickRead()" class="blue">Fetch Summary</button>
        <div style="color:rgb(0, 89, 255);size: 10px;" *ngIf="fetching">Fetching Quick Read Summary...</div>

        </ng-container>
        <ul>
          <li>
            <div class="right">
              <button type="button" name="discard" [disabled]="fetching" (click)="openSummaryPopup(false)" class="discard blue">Cancel</button>
              <ng-template #othersDisabled>
                <ng-container>
                  <button type="button" name="save" [disabled]="fetching" (click)="closeSummaryPopup()" [class]="(temporaryChangesFlag) ? 'save blue':'save grey'"
                  [disabled]="!temporaryChangesFlag">Save</button>
                </ng-container>
              </ng-template>
              <ng-container *ngIf="enableQuickSummaryLength else othersDisabled">
                <button type="button" name="save" [disabled]="fetching" (click)="closeSummaryPopup()" [class]="(temporaryChangesFlag) ? 'save blue':'save grey'"
                [disabled]="tempStoryData && tempStoryData.quickReadSummary && (tempStoryData.quickReadSummary.trim().split(' ').length<quickReadMin || tempStoryData.quickReadSummary.trim().split(' ').length>quickReadMax)">Save</button>
              </ng-container>

            </div>
          </li>
        </ul>
        <div class="clearBoth"></div>
      </div>
    </div>
  </div>

  <div id="headline3" class="lightBox headlineBox block" *ngIf="headlinePopup">
    <div class="headerLight">
      <!-- <div class="close fl spImg"></div> -->
    </div>
    <div class="lightContent headlineBox">
      <div class="addHeadline">
        <h3>Add Custom Headlines</h3>
        <ul>

          <ng-container *ngIf="(isStoryUrlCreatedFromHeadline);then storyUrlHeadlines else urlHeadlines"></ng-container>
          <ng-template #storyUrlHeadlines>
          <li>
            <label>URL/Story detail page headline (Long Headline) / Meta title -
              {{htmlToPlaintextExcludeItalic(tempStoryData.headline)? htmlToPlaintextExcludeItalic(tempStoryData.headline).length: '0'}}/120</label>

            <ng-container *ngIf="storyData && storyData.metadata && storyData.metadata.status">
              <div class="dataField" *ngIf="storyData.metadata.status !== 'PUBLISHED'">
                <span class="fieldValidation"
                *ngIf="headlineRestrictionChecks.includes('headline')
                && sharedService.checkIfRestrictedCharactersArePresent(tempStoryData.headline, 'headline')">
                Please remove ((") {{'{}'}} [])</span>
                <textarea type="text" id="landingPageHeadline" class="textBox" [(ngModel)]="tempStoryData.headline" placeholder=""
                (ngModelChange)="isValid(tempStoryData.headline)" autofocus required maxlength="120">
                  </textarea>
                  <span class="fieldValidation" *ngIf="urlValidationFlag && invalidData">Please Enter English Characters Only</span>
              </div>
              <div class="dataField" *ngIf="storyData.metadata.status === 'PUBLISHED'">
                <span class="fieldValidation"
                *ngIf="headlineRestrictionChecks.includes('headline')
                && sharedService.checkIfRestrictedCharactersArePresent(tempStoryData.headline, 'headline')">
                Please remove ((") {{'{}'}} [])</span>

                <textarea type="text" class="textBox" [(ngModel)]="tempStoryData.headline" placeholder="" [disabled]="true"
               autofocus required maxlength="120">
                  </textarea>
                  <span class="fieldValidation" *ngIf="urlValidationFlag && invalidData">Please Enter English Characters Only</span>
              </div>
            </ng-container>
          </li>

          <li>
            <label>Landing page headline </label>
            <div class="dataField">
            <textarea type="text" class="textBox" [(ngModel)]="tempStoryData.urlHeadline" placeholder=""
              required>
                  </textarea></div>
          </li>
        </ng-template>

        <ng-template #urlHeadlines>
          <li>
            <label>URL/Landing page headline</label>
            <ng-container *ngIf="storyData && storyData.metadata && storyData.metadata.status">
              <div class="dataField" *ngIf="storyData.metadata.status !== 'PUBLISHED'">
                <textarea type="text" class="textBox" [(ngModel)]="tempStoryData.urlHeadline" placeholder=""
                (ngModelChange)="isValid(tempStoryData.urlHeadline)" autofocus required>
                  </textarea>
                  <span class="fieldValidation" *ngIf="urlValidationFlag && invalidData">Please Enter English Characters Only</span>
              </div>
              <div class="dataField" *ngIf="storyData.metadata.status === 'PUBLISHED'">
                <textarea type="text" class="textBox" [ngModel]="tempStoryData.urlHeadline" [disabled]="true">
                  </textarea>
                  <span class="fieldValidation" *ngIf="urlValidationFlag && invalidData">Please Enter English Characters Only</span>
              </div>
            </ng-container>
          </li>
          <li>
            <label>Story detail page headline (Long Headline) / Meta title -
              {{htmlToPlaintextExcludeItalic(tempStoryData.headline)? htmlToPlaintextExcludeItalic(tempStoryData.headline).length: '0'}}/120</label>
            <div class="dataField">
              <span class="fieldValidation"
              *ngIf="headlineRestrictionChecks.includes('headline')
              && sharedService.checkIfRestrictedCharactersArePresent(tempStoryData.headline, 'headline')">
              Please remove ((") {{'{}'}} [])</span>
              <textarea type="text" class="textBox" [(ngModel)]="tempStoryData.headline" placeholder="" maxlength="120">
                </textarea>
            </div>
          </li>
        </ng-template>

          <li>
            <label>Mobile App Notification -
              {{htmlToPlaintext(tempStoryData.mobileAppNotificationHeadline)? htmlToPlaintext(tempStoryData.mobileAppNotificationHeadline).length: '0'}}/120</label>
            <div class="dataField">
              <span class="fieldValidation"
              *ngIf="headlineRestrictionChecks.includes('mobileAppNotificationHeadline')
              && sharedService.checkIfRestrictedCharactersArePresent(tempStoryData.mobileAppNotificationHeadline, 'headline')">
              Please remove ((") {{'{}'}} [])</span>
              <textarea type="text" class="textBox" [(ngModel)]="tempStoryData.mobileAppNotificationHeadline"
                placeholder=""></textarea>
            </div>
          </li>
          <li>
            <label>Browser Notification -
              {{htmlToPlaintext(tempStoryData.browserNotificationHeadline)? htmlToPlaintext(tempStoryData.browserNotificationHeadline).length: '0'}}/100</label>
            <div class="dataField">
              <span class="fieldValidation"
              *ngIf="headlineRestrictionChecks.includes('browserNotificationHeadline')
              && sharedService.checkIfRestrictedCharactersArePresent(tempStoryData.browserNotificationHeadline, 'headline')">
              Please remove ((") {{'{}'}} [])</span>
              <textarea type="text" class="textBox" [(ngModel)]="tempStoryData.browserNotificationHeadline" placeholder=""></textarea>
            </div>
          </li>
          <li>
            <label>Facebook</label>
            <div class="dataField">
              <span class="fieldValidation"
              *ngIf="headlineRestrictionChecks.includes('facebookHeadline')
              && sharedService.checkIfRestrictedCharactersArePresent(tempStoryData.facebookHeadline, 'headline')">
              Please remove ((") {{'{}'}} [])</span>
              <textarea type="text" class="textBox" [(ngModel)]="tempStoryData.facebookHeadline" placeholder=""></textarea>
            </div>
          </li>
          <li>
            <label>Twitter - {{htmlToPlaintext(tempStoryData.twitterHeadline)? htmlToPlaintext(tempStoryData.twitterHeadline).length: '0'}}/280</label>
            <div class="dataField">
              <span class="fieldValidation"
              *ngIf="headlineRestrictionChecks.includes('twitterHeadline')
              && sharedService.checkIfRestrictedCharactersArePresent(tempStoryData.twitterHeadline, 'headline')">
              Please remove ((") {{'{}'}} [])</span>
              <textarea type="text" class="textBox" [(ngModel)]="tempStoryData.twitterHeadline" placeholder=""
                maxlength="280"></textarea>
            </div>
          </li>
          <li *ngIf="isNewsletterFieldsEnabled()">
            <label>Newsletter - {{htmlToPlaintext(tempStoryData.newsletterHeadline)? htmlToPlaintext(tempStoryData.newsletterHeadline).length: '0'}}/120</label>
            <div class="dataField">
              <span class="fieldValidation"
              *ngIf="headlineRestrictionChecks.includes('newsletterHeadline')
              && sharedService.checkIfRestrictedCharactersArePresent(tempStoryData.newsletterHeadline, 'headline')">
              Please remove ((") {{'{}'}} [])</span>
              <textarea type="text" class="textBox" [(ngModel)]="tempStoryData.newsletterHeadline" placeholder=""
              maxlength="120"></textarea>
            </div>
          </li>
          <li *ngIf="isH2enabled()">
            <label>H2</label>
            <div class="dataField">
              <span class="fieldValidation"
              *ngIf="headlineRestrictionChecks.includes('h2HeaderHeadline')
              && sharedService.checkIfRestrictedCharactersArePresent(tempStoryData.h2HeaderHeadline, 'headline')">
              Please remove ((") {{'{}'}} [])</span>
              <textarea type="text" class="textBox" [(ngModel)]="tempStoryData.h2HeaderHeadline" placeholder=""
              ></textarea>
            </div>
          </li>
          <li *ngIf="isH3enabled()">
            <label>H3</label>
            <div class="dataField">
              <span class="fieldValidation"
              *ngIf="headlineRestrictionChecks.includes('h3HeaderHeadline')
              && sharedService.checkIfRestrictedCharactersArePresent(tempStoryData.h3HeaderHeadline, 'headline')">
              Please remove ((") {{'{}'}} [])</span>
              <textarea type="text" class="textBox" [(ngModel)]="tempStoryData.h3HeaderHeadline" placeholder=""
              ></textarea>
            </div>
          </li>
          <li>
            <div class="right">
              <button id="buttonCancelCoustomHeadline" type="button" name="discard" (click)="discareUrlChanges(false)" class="discard blue">cancel</button>
              <button type="button" id="saveButtonHeadline" name="save" (click)="setChangesUrls()" [class]="(temporaryChangesFlag) ? 'save blue':'save grey'"
                [disabled]="!temporaryChangesFlag">Save</button>
            </div>
          </li>
        </ul>
        <div class="clearBoth"></div>
      </div>
    </div>
  </div>

  <div class="lightBox readstory block" *ngIf="publishPopup">
    <div class="unlockStory">
      <div class="wid100 pad30">
        <h3>Publishing Story</h3>
        <p>Are you sure you want to publish this story.</p>
      </div>
      <div class="fr wid100 right padlr30 ptb15">
        <button type="button" name="cancel" (click)="cancelPublish()" class="cancel gray mtb15 ml10">No</button>
        <button type="button" name="unlock" (click)="finishPublish()" class="add blue mtb15 ml10 mr30">Yes</button>
      </div>
    </div>
  </div>

  <div class="viewPreview lightBox block" *ngIf="previewPopup">
    <div class="headerLight">
      <div id="previewCloseButton" class="close fl spImg" (click)="closePreview()"></div>
    </div>
    <ng-container *ngIf="previewUrl !== null">
      <div [class]="((previewPlatform === 'mobile') ? 'previewContainer mobile' : 'previewContainer desktop')">
        <!-- [innerHTML]="previewUrl"> -->
        <div class="loaderimage loaderimagepreview block">
          <div class="imagepreloader">
            <div class="a" style="--n: 5;">
              <div class="dot dot1" style="--i: 0;"></div>
              <div class="dot dot2" style="--i: 1;"></div>
              <div class="dot dot3" style="--i: 2;"></div>
              <div class="dot dot4" style="--i: 3;"></div>
            </div>
          </div>
        </div>
        <iframe appIframeTracker #previewFrame [src]="previewUrl" [style]="iframeStyle" (load)="iframeLoaded($event)"></iframe>
        <!-- (click)="return false" (dblclick)="return false" -->
      </div>
    </ng-container>
  </div>
  <div class="lightBox cropimagelightbox block" *ngIf="tablePopup">
      <div class="unlockStory">
        <div class="wid100">
          <h3 class=" pad30">Table</h3>
          <div class="cropimageblock pad30">
            <div class="cropAspectRatio">
                <ckeditor [editor]="Editor" [data]="tableHTML" [config]="tableConfig"
                (ready)="ckchanges($event, 'ready', 'table')" (change)="onChange($event,'tableHTML')"></ckeditor>
            </div>
          </div>
        </div>
        <div class="fr wid100 right padlr30 ptb15">
          <button type="button" name="cancel" (click)="closeTable()" class="cancel gray ml10">Cancel</button>
          <button type="button" name="unlock" (click)="changeTable()" class='add blue ml10'>Done</button>
        </div>
      </div>
  </div>

  <div class="image-cropper" *ngIf="showCropper" [cropperImageUrl]="cropperImageUrl" [storyType]="storyData.type"
  (finish)="finishCropping($event)" (cancel)="cancelCropping($event)" [leadMediaImageGif]="leadMediaImageGif" [isImageLead]="true" [verticalImageFlag]="false"
  ></div>
  <div class="image-cropper" *ngIf="showHowToStepsCropper" [cropperImageUrl]="cropperImageUrl" [storyType]="storyData.type"
  (finish)="finishCroppingStepsImage($event, 'howToSteps')" (cancel)="cancelCropping($event)" [isImageLead]="false" [verticalImageFlag]="false" [isHowToStepsImage]="true"
  ></div>
  <div class="image-cropper" *ngIf="showRecipeStepsCropper" [cropperImageUrl]="cropperImageUrl" [storyType]="storyData.type"
  (finish)="finishCroppingStepsImage($event, 'recipe')" (cancel)="cancelCropping($event)" [isImageLead]="false" [verticalImageFlag]="false" [isHowToStepsImage]="true"
  ></div>
  <div class="image-cropper" *ngIf="showLeadThumbnailCropper" [cropperImageUrl]="cropperImageUrl"
  (finish)="finishCropping($event)" (cancel)="cancelCropping($event)" [isImageLead]="true" [verticalImageFlag]="false" [leadVideoCropper]="true"
  ></div>


  <div class="lightBox block lightBoxVideo" *ngIf="isLightboxVideo">
    <div class="headerLight">
      <div class="close fl spImg" (click)="disableshowVideoGallery()"></div>
    </div>
    <div class="lightContent">
      <div class="headingPage">
        <ng-container *ngIf="enableJW === 'true'">
          <h2 class="tablinks all_stories"  (click)="showJW = true;showYT = false"
          [class]="showJW ? 'active' : ' '" id="defaultOpen">JW Videos</h2>
        </ng-container>
        <ng-container *ngIf="enableYT">
          <h2 class="tablinks my_workspace"  (click)="showJW = false;showYT = true"
        [class]="showYT ? 'active' : ' '"  id="wire" >Youtube Videos</h2>
        </ng-container>
      </div>
      <ng-container *ngIf="showJW">
        <div class="listing" pageId="videoStory"
        allApi="video_stories"
        searchApi="video_search"
        videoListing = "true"
        [showPagination]="true"
        [videogallery]="true"
        metaApi="" (sendIdVieoToParentfn)="getLeadMediaVideo($event)"
        search_label="Search Videos...">
      </div>
      </ng-container>
      <ng-container *ngIf="showYT">
        <youtube-listing (sendIdVieoToParentfn)="getLeadMediaVideo($event)"></youtube-listing>
      </ng-container>
    </div>
    <!--div class="lightContent">
      <div class="listing" pageId="videoStory"
        allApi="video_stories"
        searchApi="video_search"
        videoListing = "true"
        [showPagination]="true"
        [videogallery]="true"
        metaApi="" (sendIdVieoToParentfn)="getLeadMediaVideo($event)"
        search_label="Search Videos...">
      </div>
    </div-->
    <!--div class="lightContent" id="videoService">
      <youtube-listing (sendIdVieoToParentfn)="getLeadMediaVideo($event)"></youtube-listing>
    </div-->
  </div>
  <div class="lightBox videoblock block" *ngIf="quotePopup">
    <div class="unlockStory">
      <div class="wid100 pad30">
        <h3>Add Text for Quote</h3>
        <label></label>
        <textarea type="text" class="textBox" [(ngModel)]="quoteText" placeholder="Enter Quote text here…" tabindex="0"></textarea>
      </div>
      <div class="fr wid100 right padlr30 ptb15">
        <button type="button" name="cancel" tabindex="0" (click)="closeQuotePopup()" class="cancel gray ml10">Cancel</button>
        <button type="button" name="unlock" tabindex="0" (click)="saveQuote()" class="add blue ml10" [disabled]="quoteText.trim() === ''">Done</button>
      </div>
    </div>
  </div>
  <div class="lightBox listrelatedstories listTableElements listingFour block" *ngIf="showElementPopup">
    <div class="headerLight">
      <div class="close fl spImg" (click)="closeElementModal(null)"></div>
    </div>
    <div class="element-listing" (elementSelection)="addElementToStory($event)" [elementType]="'review'"
      (closePopupEmit)="closeElementModal($event)" [chooseMultiple]="relatedStoryMultipleSelectFlag"></div>
  </div>


  <div class="lightBox listrelatedstories listTableElements listingFour block" *ngIf="showAmazonPopup">
    <div class="headerLight">
      <div class="close fl spImg" (click)="closeElementModal(null)"></div>
    </div>
    <div class="element-listing" (elementSelection)="addElementToStory($event)" [elementType]="'embed,amazonMeta:true'"
      (closePopupEmit)="closeElementModal($event)" [chooseMultiple]="relatedStoryMultipleSelectFlag"></div>
  </div>

  <div class="lightBox listrelatedstories affiliateListing listTableElements listingFour block" *ngIf="amazonAdSearchPopup">
    <div class="headerLight">
      <!-- <div class="close fl spImg" (click)="openCloseAmazonAdSearchPopup(false)"></div> -->
    </div>
    <div class="app-affiliate-listing" [chooseMultiple]="relatedStoryMultipleSelectFlag" (sendIdListToParentfn)="getEmbedStoryIds($event)"
      (closePopupEmit)="closeEmbedeStoryModal($event)"  [storyId]="id"
      (openAmazonPopupEmit)="afterChooseStoryOpenAmazonModal($event)"
      ></div>
    <!-- <div class="app-affiliate-listing" (elementSelection)="addElementToStory($event)" [elementType]="'embed,amazonMeta:true'"
      (closePopupEmit)="openCloseAmazonAdSearchPopup($event)" [chooseMultiple]="relatedStoryMultipleSelectFlag"></div> -->
  </div>

  <div class="lightBox listrelatedstories listTableElements listingFour block" *ngIf="tableReusablePopup">
    <div class="headerLight">
      <div class="close fl spImg" (click)="closeElementModal(null)"></div>
    </div>
    <div class="element-listing" (elementSelection)="addElementToStory($event)" [elementType]="'table'"
      (closePopupEmit)="closeElementModal($event)" [chooseMultiple]="relatedStoryMultipleSelectFlag"></div>
  </div>

  <div *ngIf="showChartPopup" class='lightBox listChartListing block'>
    <div class="headerLight">
    <div class="close fl spImg" (click)="closeChartPopup()"></div>
    </div>
    <div class="chartListing">
    <app-chart-listing (elementSelection)="addChartToStory($event)"></app-chart-listing>
    </div>
  </div>


</ng-container>

<ng-template #loading>
  <div class="loaderimage block">
    <div class="imagepreloader">
      <div class="a" style="--n: 5;">
        <div class="dot dot1" style="--i: 0;"></div>
        <div class="dot dot2" style="--i: 1;"></div>
        <div class="dot dot3" style="--i: 2;"></div>
        <div class="dot dot4" style="--i: 3;"></div>
      </div>
    </div>
  </div>
</ng-template>

<div class="loaderimage block" *ngIf="showLoader">
  <div class="imagepreloader">
    <div class="a" style="--n: 5;">
      <div class="dot dot1" style="--i: 0;"></div>
      <div class="dot dot2" style="--i: 1;"></div>
      <div class="dot dot3" style="--i: 2;"></div>
      <div class="dot dot4" style="--i: 3;"></div>
    </div>
  </div>
</div>

<div [ngClass]="{'block': leadMediaImageToggle}" (click)="leadMediaImageToggle = false" class="closebg"></div>


<ng-container *ngIf="openSegmentPopup">
  <div class="lightBox sendNotifications createSegmentBlock" style="display:block;">
    <div class="notificationWindow">
      <div class="unlockStory">
        <div class="">
          <div class="salesReport ">
            <div class="sendNotificationBlock">
              <div class="sendNotification wid100 pad30">
                <ul class="twoLi">
                  <li [class]="mandatoryFieldSegment ? 'errorInput' : ''">
                    <label for="segmentName" class="control-label">Segment Name</label>
                    <input id="segmentName" name="segmentName" class="form-control" type="text" value="" size="20" maxlength="50"
                      [(ngModel)]="newSegment">
                  </li>
                </ul>
              </div>
              <div class="fr wid100 right padlr30 ptb15">
                <button class="cancel gray ml10" name="cancel" (click)="closeCreateSegmentPopup()"
                  type="button">Cancel</button>
                <button class="add blue ml10 " name="send" type="button" (click)="createSegment()">Add</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>


<ng-container *ngIf="openWebEngagePopup">
  <div class="lightBox sendNotifications" style="display:block;">
    <div class="notificationWindow">
      <div class="unlockStory">
        <div class="wid100 pad30">

          <div class="salesReport ">
            <div class="headerBlock">
            <h3 class="flSendNoti">Send Notification</h3>
            <div class="scheduledNoti">
              <ng-container *ngIf="enableMoEngage">
                <button name="createSegment" type="button" (click)="openCreateSegmentPopup()">Create Moengage Segment</button>
              </ng-container>
            <ng-container>
                    <button type="button" name="createCard" [disabled]="disableElement('story-save')" [class]="disableElement('story-save') ? '' : storyFlowArray[2][storyFlowIndex]"
                      daterangepicker [options]="singleCalendarConfig" (selected)="selectWebengageScheduleDate($event, 'sheduledStartTime', daterange)"
                      (cancelDaterangepicker)="calendarWebengageEventsHandler($event, 'webengage_schedule', 'removeScheduleWebengageNotification')"
                      (applyDaterangepicker)="calendarWebengageEventsHandler($event, 'webengage_schedule', 'scheduleWebengageNotification')">
                      Schedule Notification
                    </button>
                    <span *ngIf="storyData['webEngageScheduledDate']" class="schedultContent">{{ 'Notification is scheduled for - ' + getNewTypeDate(storyData['webEngageScheduledDate']) }}</span>
          </ng-container>
        </div>
      </div>
            <div class="sendNotificationBlock">
            <div class="sendNotification">
                <ul class="twoLi">
                    <li>
                        <label for="type" class="control-label">Notification Type</label>
                        <angular2-multiselect
                      [data]="notificationType"
                      [(ngModel)]="selectedNotificationType"
                      [settings]="notificationTypeDropdownSettings"
                      (onSelect)="onItemSelect($event, 'notificationType')"
                      (onSelectAll)="onSelectAll($event, 'notificationType')"
                      (onDeSelect)="onItemDeSelect($event, 'notificationType')"
                      (onDeSelectAll)="onDeSelectAll($event, 'notificationType')">
                      </angular2-multiselect>
                    </li>
                </ul>

                <ul class="twoLi">
                    <li>
                        <label for="appIds" class="control-label">Target Applications</label>
                        <angular2-multiselect
                      [data]="applications"
                      [(ngModel)]="selectedApplications"
                      [settings]="applicationDropdownSettings"
                      (onSelect)="onItemSelect($event, 'application')"
                      (onSelectAll)="onSelectAll($event, 'application')"
                      (onDeSelect)="onItemDeSelect($event, 'application')"
                      (onDeSelectAll)="onDeSelectAll($event, 'application')">
                      </angular2-multiselect>
                    </li>
                </ul>

                <ng-container *ngIf="enableWebEngage">
                  <ul class="twoLi">
                    <li id="segment-dropdown">
                        <label for="segments" class="control-label">Segment (Default All)</label>
                        <angular2-multiselect
                      [data]="segments"
                      [(ngModel)]="selectedSegments"
                      [settings]="segmentDropdownSettings"
                      (onSelect)="onItemSelect($event,'segment')"
                      (onSelectAll)="onSelectAll($event,'segment')"
                      (onDeSelect)="onItemDeSelect($event, 'segment')"
                      (onDeSelectAll)="onDeSelectAll($event, 'segment')">
                      </angular2-multiselect>
                    </li>
                  </ul >
                </ng-container>

                <ng-container *ngIf="enableMoEngage">
                  <ul class="twoLi">
                    <li id="mo-segment-dropdown">
                        <label for="moSegments" class="control-label">Moengage Segment (Default All)</label>
                        <angular2-multiselect
                      [data]="moSegments"
                      [(ngModel)]="selectedMoSegments"
                      [settings]="moSegmentDropdownSettings"
                      (onSelect)="onItemSelect($event,'mosegment')"
                      (onSelectAll)="onSelectAll($event,'mosegment')"
                      (onDeSelect)="onItemDeSelect($event, 'mosegment')"
                      (onDeSelectAll)="onDeSelectAll($event, 'mosegment')">
                        </angular2-multiselect>
                    </li>
                  </ul >
                </ng-container>

                <ng-container *ngIf="enableCrossDomainNotification">
                  <ul class="twoLi">
                    <li id="mo-segment-dropdown">
                        <label for="crossDomains" class="control-label">Cross Domain Platforms</label>
                        <angular2-multiselect
                      [data]="crossDomains"
                      [(ngModel)]="selectedCrossDomains"
                      [settings]="crossDomainDropdownSettings"
                      (onSelect)="onItemSelect($event,'crossDomain')"
                      (onSelectAll)="onSelectAll($event,'crossDomain')"
                      (onDeSelect)="onItemDeSelect($event, 'crossDomain')"
                      (onDeSelectAll)="onDeSelectAll($event, 'crossDomain')">
                        </angular2-multiselect>
                    </li>
                  </ul >
                </ng-container>

                <!--ul class="twoLi">
                    <li>
                        <label for="tags" class="control-label">Tags (Default All)</label>
                        <angular2-multiselect
                        [data]="tags"
                        [(ngModel)]="selectedTags"
                        [settings]="tagDropdownSettings"
                        (onSelect)="onItemSelect($event,'tag')"
                        (onSelectAll)="onSelectAll($event,'tag')"
                        (onDeSelect)="onItemDeSelect($event, 'tag')"
                        (onDeSelectAll)="onDeSelectAll($event, 'tag')"
                      >
                      </angular2-multiselect>
                    </li>
                </ul-->

                <ul class="twoLi" *ngIf="selectedNotificationTypeObject['name'] === 'Breaking News Banner' || selectedNotificationTypeObject['name'] === 'Breaking News Text' || selectedNotificationTypeObject['name'] === 'Narrative' || selectedNotificationTypeObject['name'] === 'Video' || selectedNotificationTypeObject['name'] === 'Banner' || selectedNotificationTypeObject['name'] === 'Slug' || selectedNotificationTypeObject['name'] === 'External'">
                    <ng-container *ngIf="this.selectedNotificationTypeObject['name'] !== 'Slug'">
                      <li [class]="mandatoryFieldMessage ? 'errorInput' : ''">
                          <label for="title" class="control-label">Title</label>
                          <textarea id="title" name="title" size="20" class="form-control" (keyup)="sendGaEventNotificationFormEdited('Title')" [(ngModel)]="notification.title"></textarea>
                      </li>
                    </ng-container>
                    <ng-container *ngIf="this.selectedNotificationTypeObject['name'] === 'Slug'">
                        <li id="mo-segment-dropdown">
                            <label for="moEngageSlugs" class="control-label">Title </label>
                            <angular2-multiselect
                          [data]="moEngageSlugs"
                          [(ngModel)]="selectedMoSlug"
                          [settings]="moSlugSettings"
                          (onSelect)="onItemSelect($event,'moSlug')"
                          (onDeSelect)="onItemDeSelect($event, 'moSlug')"
                          (onDeSelectAll)="onDeSelectAll($event, 'moSlug')"
                          >
                            </angular2-multiselect>
                        </li>
                        <ng-container *ngIf="selectedMoSlug && selectedMoSlug[0] && selectedMoSlug[0]['itemName'] === 'Others'">
                          <li [class]="mandatoryFieldMessage ? 'errorInput' : ''">
                            <!-- <label for="title" class="control-label">Title</label> -->
                            <textarea id="title" name="title" size="20" class="form-control" placeholder="Enter custom title..." [(ngModel)]="notification.title"></textarea>
                          </li>
                        </ng-container>
                    </ng-container>

                </ul>
                <ul class="twoLi" *ngIf="selectedNotificationTypeObject['name'] === 'Breaking News Banner' || selectedNotificationTypeObject['name'] === 'Breaking News Text' || selectedNotificationTypeObject['name'] === 'Narrative' || selectedNotificationTypeObject['name'] === 'Video' || selectedNotificationTypeObject['name'] === 'Banner' || selectedNotificationTypeObject['name'] === 'Slug' || selectedNotificationTypeObject['name'] === 'External'">
                    <li>
                      <label for="description" class="control-label">Description</label>
                      <textarea id="description" name="description" size="30" class="form-control" (keyup)="sendGaEventNotificationFormEdited('Description')" [(ngModel)]="notification.description"></textarea>
                    </li>
                </ul>
                <ul class="twoLi" *ngIf="selectedNotificationTypeObject['name'] === 'Video' || selectedNotificationTypeObject['name'] === 'Banner' || selectedNotificationTypeObject['name'] === 'Slug' || selectedNotificationTypeObject['name'] === 'External'">
                    <li [class]="mandatoryFieldUrl ? 'errorInput' : ''">
                        <label for="storyUrl" class="control-label">URL</label>
                        <input id="storyUrl" name="storyUrl" class="form-control" type="text" value="" size="20" (keyup)="sendGaEventNotificationFormEdited('URL')" [(ngModel)]="notification.storyUrl">
                    </li>
                </ul>

                <ul class="twoLi" *ngIf="selectedNotificationTypeObject['name'] === 'Breaking News Banner' || selectedNotificationTypeObject['name'] === 'Breaking News Text' || selectedNotificationTypeObject['name'] === 'Narrative' || selectedNotificationTypeObject['name'] === 'Video' || selectedNotificationTypeObject['name'] === 'Banner' || selectedNotificationTypeObject['name'] === 'Slug' || selectedNotificationTypeObject['name'] === 'External'">
                    <li [class]="mandatoryImageUrl ? 'errorInput' : ''">
                        <label for="imageUrl" class="control-label">Image URL</label>
                        <input id="imageUrl" name="imageUrl" class="form-control" type="text" value="" size="20" (keyup)="sendGaEventNotificationFormEdited('Image URL')" [(ngModel)]="notification.imageUrl">
                    </li>
                </ul>

                <ul class="twoLi" *ngIf="selectedNotificationTypeObject['name'] === 'Banner' || selectedNotificationTypeObject['name'] === 'Slug' || selectedNotificationTypeObject['name'] === 'Video'">
                    <li [class]="mandatoryFieldStoryId ? 'errorInput' : ''">
                        <label for="storyId" class="control-label">Story Id</label>
                        <input id="storyId" name="storyId" class="form-control" type="text" value="" size="20" (keyup)="sendGaEventNotificationFormEdited('Story Id')" [(ngModel)]="notification.storyId">
                    </li>
                </ul>

            </div>
        </div>
          </div>
        </div>
        <div class="fr wid100 right padlr30 ptb15">
          <button class="cancel gray ml10" name="cancel"
            (click)="closeWebengagePopup()" type="button">Cancel</button>
          <button class="add blue ml10 " name="send" type="button" [disabled]="disableSendButton" (click)="sendWebEngageNotification()">Send</button>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="openSeoDetailsPopup">

  <div class="lightBox seoBlock block"  style="display:block;">
    <div class="unlockStory">
      <div class="wid100 pad30">

        <ul *ngFor="let seoComment of seoComments">
          <li [class]="checkSeoCommentColor(seoComment)">{{seoComment['text']}}</li>
        </ul>
      </div>
      <div class="fr wid100 right padlr30 ptb15">
        <button type="button" name="cancel" tabindex="0" (click)="closeSeoScore()" class="cancel blue ml10">Close</button>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="openPlagURL">

  <div class="lightBox seoBlock block"  style="display:block;">
    <div class="unlockStory">
      <div class="wid100 pad30">

        <ng-container *ngIf="plagData.matchedURLs">
          <ul *ngFor="let plagUrls of plagData.matchedURLs">
            <li (click)="openPlagUrlWindow(plagUrls)">{{plagUrls}}</li>
          </ul>
        </ng-container>

      </div>
      <div class="fr wid100 right padlr30 ptb15">
        <button type="button" name="cancel" tabindex="0" (click)="closePlagUrl()" class="cancel blue ml10">Close</button>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="openAmpDetailsPopup">

  <div class="lightBox seoBlock block"  style="display:block;">
    <div class="unlockStory">
      <div class="wid100 pad30">
        <ul *ngFor="let errors of ampResult?.error">
          <li class="red">{{errors}}</li>
        </ul>
        <ul *ngFor="let warns of ampResult?.warn">
          <li class="orange">{{warns}}</li>
        </ul>
      </div>
      <div class="fr wid100 right padlr30 ptb15">
        <button type="button" name="cancel" tabindex="0" (click)="closeAmpValidate()" class="cancel blue ml10">Close</button>
      </div>
    </div>
  </div>
</ng-container>

